
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("iuuxi", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $RfroO = parcelRequire("RfroO");


var $iMnC5 = parcelRequire("iMnC5");


var $6Pqow = parcelRequire("6Pqow");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");





var $2ltBS = parcelRequire("2ltBS");

const $56c648a5d052c63d$export$f370712d0ce7173b = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(9);
    const theme = (0, $2ltBS.useColorMode)();
    const isDarkTheme = theme === "dark";
    const fillColour = isDarkTheme ? "#4B4D51" : "#DDDEE1";
    const innerColour = isDarkTheme ? "#101214" : "white";
    let t0;
    if ($[0] !== fillColour) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M0 52.5871L0.0314182 52.6499H56.8739L56.9088 52.5871L28.4544 0L0 52.5871Z",
            fill: fillColour
        });
        $[0] = fillColour;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    let t2;
    if ($[2] !== innerColour) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M27.2725 38.0368V18.8333H29.8313V38.0368H27.2725Z",
            fill: innerColour
        });
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M28.0814 41.2098C28.2675 41.1764 28.4451 41.1665 28.5973 41.1665C28.7583 41.1665 28.9179 41.1777 29.0781 41.2023L29.084 41.2032L29.0899 41.2042C30.1047 41.37 30.9494 42.0762 31.154 43.2046C31.19 43.3958 31.1998 43.5794 31.1998 43.7306C31.1998 43.8478 31.1939 43.9799 31.1754 44.1197V44.1412L31.1552 44.2533C30.9533 45.3786 30.1106 46.0937 29.0899 46.2604L29.084 46.2614L29.0781 46.2623C28.9179 46.287 28.7583 46.2981 28.5973 46.2981C28.444 46.2981 28.2649 46.2881 28.0772 46.2541C27.0757 46.0805 26.2351 45.3807 26.0303 44.2574C25.9948 44.0692 25.9844 43.8932 25.9844 43.7341C25.9844 43.5767 25.9945 43.3951 26.0311 43.2033C26.2382 42.0971 27.0613 41.3814 28.0814 41.2098ZM28.5432 43.7274C28.5432 43.7295 28.5432 43.7318 28.5432 43.7341C28.5432 43.7352 28.5432 43.7362 28.5432 43.7373C28.5444 43.7374 28.5456 43.7375 28.547 43.7376C28.559 43.7385 28.5757 43.7393 28.5973 43.7393C28.6137 43.7393 28.6281 43.7389 28.6409 43.7381C28.6409 43.7357 28.641 43.7332 28.641 43.7306C28.641 43.7292 28.641 43.7278 28.6409 43.7265C28.6282 43.7258 28.6137 43.7253 28.5973 43.7253C28.5757 43.7253 28.559 43.7261 28.547 43.727C28.5457 43.7272 28.5444 43.7273 28.5432 43.7274Z",
            fill: innerColour
        });
        $[2] = innerColour;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    let t3;
    if ($[5] !== t0 || $[6] !== t1 || $[7] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            "data-testid": "navigation-empty-state--generic-error-icon",
            width: "57",
            height: "53",
            viewBox: "0 0 57 53",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t0, t1, t2);
        $[5] = t0;
        $[6] = t1;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
} : ()=>{
    const theme = (0, $2ltBS.useColorMode)();
    const isDarkTheme = theme === 'dark';
    const fillColour = isDarkTheme ? '#4B4D51' : '#DDDEE1';
    const innerColour = isDarkTheme ? '#101214' : 'white';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        "data-testid": "navigation-empty-state--generic-error-icon",
        width: "57",
        height: "53",
        viewBox: "0 0 57 53",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M0 52.5871L0.0314182 52.6499H56.8739L56.9088 52.5871L28.4544 0L0 52.5871Z",
        fill: fillColour
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M27.2725 38.0368V18.8333H29.8313V38.0368H27.2725Z",
        fill: innerColour
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M28.0814 41.2098C28.2675 41.1764 28.4451 41.1665 28.5973 41.1665C28.7583 41.1665 28.9179 41.1777 29.0781 41.2023L29.084 41.2032L29.0899 41.2042C30.1047 41.37 30.9494 42.0762 31.154 43.2046C31.19 43.3958 31.1998 43.5794 31.1998 43.7306C31.1998 43.8478 31.1939 43.9799 31.1754 44.1197V44.1412L31.1552 44.2533C30.9533 45.3786 30.1106 46.0937 29.0899 46.2604L29.084 46.2614L29.0781 46.2623C28.9179 46.287 28.7583 46.2981 28.5973 46.2981C28.444 46.2981 28.2649 46.2881 28.0772 46.2541C27.0757 46.0805 26.2351 45.3807 26.0303 44.2574C25.9948 44.0692 25.9844 43.8932 25.9844 43.7341C25.9844 43.5767 25.9945 43.3951 26.0311 43.2033C26.2382 42.0971 27.0613 41.3814 28.0814 41.2098ZM28.5432 43.7274C28.5432 43.7295 28.5432 43.7318 28.5432 43.7341C28.5432 43.7352 28.5432 43.7362 28.5432 43.7373C28.5444 43.7374 28.5456 43.7375 28.547 43.7376C28.559 43.7385 28.5757 43.7393 28.5973 43.7393C28.6137 43.7393 28.6281 43.7389 28.6409 43.7381C28.6409 43.7357 28.641 43.7332 28.641 43.7306C28.641 43.7292 28.641 43.7278 28.6409 43.7265C28.6282 43.7258 28.6137 43.7253 28.5973 43.7253C28.5757 43.7253 28.559 43.7261 28.547 43.727C28.5457 43.7272 28.5444 43.7273 28.5432 43.7274Z",
        fill: innerColour
    }));
};


const $5d23c774a8ae5aa2$var$styles = {
    textWrapper: "_195g1wug _p12fo8uj _1e0c1o8l",
    imageWrapper: "_n3td1jfw"
};
function $5d23c774a8ae5aa2$export$618cc98292cae482({ testId: testId = 'navigation-empty-state', renderImage: renderImage = ()=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        xcss: $5d23c774a8ae5aa2$var$styles.imageWrapper
    }, /*#__PURE__*/ $cozmU.createElement((0, $56c648a5d052c63d$export$f370712d0ce7173b), null)), description: description, ...restProps }) {
    return /*#__PURE__*/ $cozmU.createElement((0, $RfroO.default), {
        ...restProps,
        testId: testId,
        renderImage: renderImage,
        headingLevel: 3,
        headingSize: "xsmall",
        description: /*#__PURE__*/ $cozmU.createElement("span", {
            className: (0, $hekY6.default)([
                $5d23c774a8ae5aa2$var$styles.textWrapper
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $6Pqow.default), {
            size: "small",
            color: "color.text.subtle"
        }, description))
    });
}
module.exports["NavEmptyState"] = $5d23c774a8ae5aa2$export$618cc98292cae482;

});

parcelRegister("iZ8sH", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $2ot3O = parcelRequire("2ot3O");


var $cN3xQ = parcelRequire("cN3xQ");










function $262975364d45b3c9$export$8c20ab16ac9cf14f({ errorMessages: errorMessages, errorMessageValues: errorMessageValues }) {
    return errorMessages ? {
        header: errorMessages.header,
        description: errorMessages.description,
        values: errorMessageValues
    } : {};
}


const $de5f42b79a2733de$export$dd28f26aa5199f5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useBoundaryMessages(t0) {
    const $ = (0, $bDgLe.c)(3);
    const { errorMessages: errorMessages, errorMessageValues: errorMessageValues } = t0;
    let t1;
    if ($[0] !== errorMessageValues || $[1] !== errorMessages) {
        t1 = (0, $262975364d45b3c9$export$8c20ab16ac9cf14f)({
            errorMessages: errorMessages,
            errorMessageValues: errorMessageValues
        });
        $[0] = errorMessageValues;
        $[1] = errorMessages;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : function useBoundaryMessages({ errorMessages: errorMessages, errorMessageValues: errorMessageValues }) {
    return (0, $cozmU.useMemo)(()=>{
        return (0, $262975364d45b3c9$export$8c20ab16ac9cf14f)({
            errorMessages: errorMessages,
            errorMessageValues: errorMessageValues
        });
    }, [
        errorMessages,
        errorMessageValues
    ]);
};












var $kSwu1 = parcelRequire("kSwu1");

const $faee39858219e5fe$export$bc7f29bc4d00b60a = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useFailureFlagEmitter(flags) {
    const $ = (0, $bDgLe.c)(10);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const pendingFlagRef = (0, $cozmU.useRef)(null);
    const dismissPendingFlagRef = (0, $cozmU.useRef)(null);
    let t0;
    if ($[0] !== flags || $[1] !== formatMessage) {
        t0 = ()=>{
            const pending = pendingFlagRef.current;
            if (!flags || !pending) return;
            dismissPendingFlagRef.current?.();
            const dismiss = flags.showFailure({
                title: formatMessage(pending.header, pending.values),
                description: formatMessage(pending.description, pending.values)
            });
            dismissPendingFlagRef.current = typeof dismiss === "function" ? dismiss : null;
        };
        $[0] = flags;
        $[1] = formatMessage;
        $[2] = t0;
    } else t0 = $[2];
    const reEmitPendingFlag = t0;
    let t1;
    let t2;
    if ($[3] !== reEmitPendingFlag) {
        t1 = ()=>{
            if (pendingFlagRef.current) reEmitPendingFlag();
        };
        t2 = [
            reEmitPendingFlag
        ];
        $[3] = reEmitPendingFlag;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>()=>{
                dismissPendingFlagRef.current?.();
                dismissPendingFlagRef.current = null;
                pendingFlagRef.current = null;
            };
        t4 = [];
        $[6] = t3;
        $[7] = t4;
    } else {
        t3 = $[6];
        t4 = $[7];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[8] !== reEmitPendingFlag) {
        t5 = (pending_0)=>{
            pendingFlagRef.current = pending_0;
            reEmitPendingFlag();
        };
        $[8] = reEmitPendingFlag;
        $[9] = t5;
    } else t5 = $[9];
    return t5;
} : function useFailureFlagEmitter(flags) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const pendingFlagRef = (0, $cozmU.useRef)(null);
    const dismissPendingFlagRef = (0, $cozmU.useRef)(null);
    const reEmitPendingFlag = (0, $cozmU.useCallback)(()=>{
        const pending = pendingFlagRef.current;
        if (!flags || !pending) return;
        dismissPendingFlagRef.current?.();
        const dismiss = flags.showFailure({
            title: formatMessage(pending.header, pending.values),
            description: formatMessage(pending.description, pending.values)
        });
        dismissPendingFlagRef.current = typeof dismiss === 'function' ? dismiss : null;
    }, [
        flags,
        formatMessage
    ]);
    // Re-emit whenever `formatMessage` identity changes (i.e. the inner
    // IntlProvider has re-rendered with a new messages map after the async
    // load). No-op when the gate is OFF or no error has fired yet.
    (0, $cozmU.useEffect)(()=>{
        if (pendingFlagRef.current) reEmitPendingFlag();
    }, [
        reEmitPendingFlag
    ]);
    // On unmount, dismiss any flag we own so we don't leak it into the host
    // app's FlagGroup after this boundary goes away.
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            dismissPendingFlagRef.current?.();
            dismissPendingFlagRef.current = null;
            pendingFlagRef.current = null;
        };
    }, []);
    return (0, $cozmU.useCallback)((pending_0)=>{
        // Capture the descriptor inputs so the locale-change effect can
        // re-emit a re-localised flag once messages finish loading.
        // Emit immediately (possibly in the default language) so the
        // user gets visible feedback right away.
        pendingFlagRef.current = pending_0;
        reEmitPendingFlag();
    }, [
        reEmitPendingFlag
    ]);
};















var $5avUB = parcelRequire("5avUB");

const $bf593926feff8e14$export$ad59d437e6db3634 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useMessageFlags(t0) {
    const $ = (0, $bDgLe.c)(2);
    const { showFlags: t1 } = t0;
    const showFlags = t1 === undefined ? false : t1;
    const { showFlag: showFlag } = (0, $2ot3O.useFlags)();
    let t2;
    if ($[0] !== showFlag) {
        t2 = {
            showFailure: (t3)=>{
                const { title: title, description: description, actions: actions } = t3;
                return showFlag({
                    actions: actions,
                    description: description,
                    id: $bf593926feff8e14$var$flagsIds.failure,
                    isAutoDismiss: true,
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5avUB))), {
                        label: "Failure",
                        spacing: "spacious"
                    }),
                    testId: $bf593926feff8e14$var$flagsIds.failure,
                    title: title
                });
            }
        };
        $[0] = showFlag;
        $[1] = t2;
    } else t2 = $[1];
    const flags = t2;
    return !showFlags ? undefined : flags;
} : function useMessageFlags({ showFlags: showFlags = false }) {
    const { showFlag: showFlag } = (0, $2ot3O.useFlags)();
    const flags = (0, $cozmU.useMemo)(()=>({
            showFailure: ({ title: title, description: description, actions: actions })=>{
                return showFlag({
                    actions: actions,
                    description: description,
                    id: $bf593926feff8e14$var$flagsIds.failure,
                    isAutoDismiss: true,
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5avUB))), {
                        label: "Failure",
                        spacing: "spacious"
                    }),
                    testId: $bf593926feff8e14$var$flagsIds.failure,
                    title: title
                });
            }
        }), [
        showFlag
    ]);
    return !showFlags ? undefined : flags;
};
const $bf593926feff8e14$var$flagsIds = {
    failure: 'nav-error-boundary-failure-flag'
};






var $h6BA0 = parcelRequire("h6BA0");


var $fAint = parcelRequire("fAint");

function $d1beced314957844$export$2139d636391467cf({ interactionId: interactionId, ufoInteractionName: ufoInteractionName }) {
    const reportError = (0, $h6BA0.useUFOReportError)();
    const reportErrorRef = (0, $cozmU.useRef)(reportError);
    reportErrorRef.current = reportError;
    return (0, $cozmU.useCallback)((error)=>{
        const name = ufoInteractionName ? ufoInteractionName : interactionId ? (0, $fAint.NavigationExperienceId)[interactionId].experienceId : undefined;
        if (!name) return;
        reportErrorRef.current({
            name: name,
            errorMessage: error.message,
            errorStack: error.stack,
            errorStatusCode: error instanceof Response ? error?.status : undefined
        });
    }, [
        interactionId,
        ufoInteractionName
    ]);
}















var $iuuxi = parcelRequire("iuuxi");


var $4fwrR = parcelRequire("4fwrR");


const $6655ae61539b26f8$export$ed65a7143a39e5b6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ErrorBoundaryUI(t0) {
    const $ = (0, $bDgLe.c)(11);
    const { disableAnalytics: disableAnalytics, errorFallbackUI: errorFallbackUI, errorActionUI: errorActionUI, location: location, errorMessages: errorMessages, errorMessageValues: errorMessageValues } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { fireEvent: fireEvent } = (0, $4fwrR.useAnalyticsEvents)();
    const { header: header, description: description, values: values } = (0, $262975364d45b3c9$export$8c20ab16ac9cf14f)({
        errorMessages: errorMessages,
        errorMessageValues: errorMessageValues
    });
    let t1;
    let t2;
    if ($[0] !== disableAnalytics || $[1] !== errorFallbackUI || $[2] !== fireEvent || $[3] !== location) {
        t1 = ()=>{
            if (!disableAnalytics) fireEvent("ui.errorBoundary.viewed.errorBoundaryUI", {
                location: location,
                isFallbackUI: !!errorFallbackUI
            });
        };
        t2 = [
            disableAnalytics,
            errorFallbackUI,
            fireEvent,
            location
        ];
        $[0] = disableAnalytics;
        $[1] = errorFallbackUI;
        $[2] = fireEvent;
        $[3] = location;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $cozmU.useLayoutEffect)(t1, t2);
    if (errorFallbackUI) return errorFallbackUI({
        header: formatMessage(header, values),
        description: formatMessage(description, values)
    });
    const T0 = (0, $iuuxi.NavEmptyState);
    const t3 = "navigation-error-boundary-ui";
    const t4 = formatMessage(header, values);
    const t5 = formatMessage(description, values);
    let t6;
    if ($[6] !== T0 || $[7] !== errorActionUI || $[8] !== t4 || $[9] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            testId: t3,
            header: t4,
            description: t5,
            primaryAction: errorActionUI
        });
        $[6] = T0;
        $[7] = errorActionUI;
        $[8] = t4;
        $[9] = t5;
        $[10] = t6;
    } else t6 = $[10];
    return t6;
} : function ErrorBoundaryUI({ disableAnalytics: disableAnalytics, errorFallbackUI: errorFallbackUI, errorActionUI: errorActionUI, location: location, errorMessages: errorMessages, errorMessageValues: errorMessageValues }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { fireEvent: fireEvent } = (0, $4fwrR.useAnalyticsEvents)();
    // Message precedence: errorMessages (consumer-provided) > location-based lookup
    const { header: header, description: description, values: values } = (0, $262975364d45b3c9$export$8c20ab16ac9cf14f)({
        errorMessages: errorMessages,
        errorMessageValues: errorMessageValues
    });
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!disableAnalytics) fireEvent('ui.errorBoundary.viewed.errorBoundaryUI', {
            location: location,
            isFallbackUI: !!errorFallbackUI
        });
    }, [
        disableAnalytics,
        errorFallbackUI,
        fireEvent,
        location
    ]);
    // If a custom fallback UI is provided, render it directly at risk of consumer
    if (errorFallbackUI) return errorFallbackUI({
        header: formatMessage(header, values),
        description: formatMessage(description, values)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iuuxi.NavEmptyState), {
        testId: "navigation-error-boundary-ui",
        header: formatMessage(header, values),
        description: formatMessage(description, values),
        primaryAction: errorActionUI
    });
};


const $447f2ed187e945aa$export$afc779e659fd533f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function NavErrorBoundary(props) {
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2ot3O.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($447f2ed187e945aa$var$InnerErrorBoundary, props));
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function NavErrorBoundary(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2ot3O.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($447f2ed187e945aa$var$InnerErrorBoundary, props));
};
const $447f2ed187e945aa$var$InnerErrorBoundary = (0, $gtMdU.isReactCompilerActivePlatform)() ? function InnerErrorBoundary(t0) {
    const $ = (0, $bDgLe.c)(36);
    const { disableAnalytics: t1, disableSentry: t2, errorActionUI: errorActionUI, errorFallbackUI: errorFallbackUI, errorMessages: errorMessages, errorMessageValues: errorMessageValues, interactionId: interactionId, location: t3, onError: onError, showFlags: showFlags, silent: silent, children: children, sentryConfig: sentryConfig, tags: tags, ufoInteractionName: ufoInteractionName } = t0;
    const disableAnalytics = t1 === undefined ? false : t1;
    const disableSentry = t2 === undefined ? false : t2;
    const location = t3 === undefined ? "unknown" : t3;
    let t4;
    if ($[0] !== errorMessageValues || $[1] !== errorMessages) {
        t4 = {
            errorMessages: errorMessages,
            errorMessageValues: errorMessageValues
        };
        $[0] = errorMessageValues;
        $[1] = errorMessages;
        $[2] = t4;
    } else t4 = $[2];
    const { header: header, description: description, values: values } = (0, $de5f42b79a2733de$export$dd28f26aa5199f5)(t4);
    let t5;
    if ($[3] !== showFlags) {
        t5 = {
            showFlags: showFlags
        };
        $[3] = showFlags;
        $[4] = t5;
    } else t5 = $[4];
    const flags = (0, $bf593926feff8e14$export$ad59d437e6db3634)(t5);
    const emitFailureFlag = (0, $faee39858219e5fe$export$bc7f29bc4d00b60a)(flags);
    let t6;
    if ($[5] !== interactionId || $[6] !== ufoInteractionName) {
        t6 = {
            interactionId: interactionId,
            ufoInteractionName: ufoInteractionName
        };
        $[5] = interactionId;
        $[6] = ufoInteractionName;
        $[7] = t6;
    } else t6 = $[7];
    const reportInteractionError = (0, $d1beced314957844$export$2139d636391467cf)(t6);
    let t7;
    if ($[8] !== description || $[9] !== emitFailureFlag || $[10] !== header || $[11] !== onError || $[12] !== reportInteractionError || $[13] !== values) {
        t7 = (error)=>{
            emitFailureFlag({
                header: header,
                description: description,
                values: values
            });
            reportInteractionError(error);
            onError?.(error);
        };
        $[8] = description;
        $[9] = emitFailureFlag;
        $[10] = header;
        $[11] = onError;
        $[12] = reportInteractionError;
        $[13] = values;
        $[14] = t7;
    } else t7 = $[14];
    const onErrorUIHandler = t7;
    let t8;
    if ($[15] !== disableAnalytics || $[16] !== disableSentry || $[17] !== interactionId || $[18] !== location || $[19] !== onErrorUIHandler || $[20] !== sentryConfig || $[21] !== tags) {
        t8 = {
            disableAnalytics: disableAnalytics,
            disableSentry: disableSentry,
            interactionId: interactionId,
            location: location,
            onError: onErrorUIHandler,
            sentryConfig: sentryConfig,
            tags: tags
        };
        $[15] = disableAnalytics;
        $[16] = disableSentry;
        $[17] = interactionId;
        $[18] = location;
        $[19] = onErrorUIHandler;
        $[20] = sentryConfig;
        $[21] = tags;
        $[22] = t8;
    } else t8 = $[22];
    const { handleError: handleError } = (0, $cN3xQ.useNavBoundaryContext)(t8);
    let t9;
    if ($[23] !== disableAnalytics || $[24] !== errorActionUI || $[25] !== errorFallbackUI || $[26] !== errorMessageValues || $[27] !== errorMessages || $[28] !== flags || $[29] !== location || $[30] !== silent) {
        t9 = silent || flags ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6655ae61539b26f8$export$ed65a7143a39e5b6), {
            disableAnalytics: disableAnalytics,
            errorActionUI: errorActionUI,
            errorFallbackUI: errorFallbackUI,
            errorMessages: errorMessages,
            errorMessageValues: errorMessageValues,
            location: location
        });
        $[23] = disableAnalytics;
        $[24] = errorActionUI;
        $[25] = errorFallbackUI;
        $[26] = errorMessageValues;
        $[27] = errorMessages;
        $[28] = flags;
        $[29] = location;
        $[30] = silent;
        $[31] = t9;
    } else t9 = $[31];
    const errorComponent = t9;
    let t10;
    if ($[32] !== children || $[33] !== errorComponent || $[34] !== handleError) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
            onError: handleError,
            fallback: errorComponent
        }, children);
        $[32] = children;
        $[33] = errorComponent;
        $[34] = handleError;
        $[35] = t10;
    } else t10 = $[35];
    return t10;
} : function InnerErrorBoundary({ disableAnalytics: disableAnalytics = false, disableSentry: disableSentry = false, errorActionUI: errorActionUI, errorFallbackUI: errorFallbackUI, errorMessages: errorMessages, errorMessageValues: errorMessageValues, interactionId: interactionId, location: location = 'unknown', onError: onError, showFlags: showFlags, silent: silent, children: children, sentryConfig: sentryConfig, tags: tags, ufoInteractionName: ufoInteractionName }) {
    const { header: header, description: description, values: values } = (0, $de5f42b79a2733de$export$dd28f26aa5199f5)({
        errorMessages: errorMessages,
        errorMessageValues: errorMessageValues
    });
    const flags = (0, $bf593926feff8e14$export$ad59d437e6db3634)({
        showFlags: showFlags
    });
    const emitFailureFlag = (0, $faee39858219e5fe$export$bc7f29bc4d00b60a)(flags);
    const reportInteractionError = (0, $d1beced314957844$export$2139d636391467cf)({
        interactionId: interactionId,
        ufoInteractionName: ufoInteractionName
    });
    const onErrorUIHandler = (0, $cozmU.useCallback)((error)=>{
        emitFailureFlag({
            header: header,
            description: description,
            values: values
        });
        reportInteractionError(error);
        onError?.(error);
    }, [
        emitFailureFlag,
        reportInteractionError,
        header,
        description,
        values,
        onError
    ]);
    const { handleError: handleError } = (0, $cN3xQ.useNavBoundaryContext)({
        disableAnalytics: disableAnalytics,
        disableSentry: disableSentry,
        interactionId: interactionId,
        location: location,
        onError: onErrorUIHandler,
        sentryConfig: sentryConfig,
        tags: tags
    });
    // When `silent` is true or `flags` are enabled, we don't want to show any UI on error
    const errorComponent = silent || flags ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6655ae61539b26f8$export$ed65a7143a39e5b6), {
        disableAnalytics: disableAnalytics,
        errorActionUI: errorActionUI,
        errorFallbackUI: errorFallbackUI,
        errorMessages: errorMessages,
        errorMessageValues: errorMessageValues,
        location: location
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        onError: handleError,
        fallback: errorComponent
    }, children);
};
module.exports["NavErrorBoundary"] = $447f2ed187e945aa$export$afc779e659fd533f;

});

parcelRegister("aibb0", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $64VTj = parcelRequire("64VTj");

function $5a198a38a6368eba$export$6fa362ed4e835606({ defaultMessages: defaultMessages, asyncLanguages: asyncLanguages, onLoadError: onLoadError }) {
    const fetchMessagesForLocale = async (locale)=>{
        try {
            // Fallback to the generic locale (e.g. `de`) if the specified
            // region-qualified locale (e.g. `de-DE`) is not present in the map.
            const languageLocale = locale in asyncLanguages ? locale : locale.split(/[-_]/)[0] || '';
            const localeMessages = await asyncLanguages[languageLocale]?.();
            return localeMessages?.default ?? defaultMessages;
        } catch (e) {
            onLoadError?.(locale, e);
        }
        return defaultMessages;
    };
    return function AsyncIntlProvider({ children: children, disabled: disabled = false }) {
        if (disabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        // `fetchMessagesForLocale` is defined once at factory-call time and
        // closed over here, so its identity is already stable across renders
        // of this returned component — no `useCallback` needed.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $64VTj.default), {
            defaultMessages: defaultMessages,
            loaderFn: fetchMessagesForLocale
        }, children);
    };
}
module.exports["createAsyncIntlProvider"] = $5a198a38a6368eba$export$6fa362ed4e835606;

});

parcelRegister("cV7Sf", function(module, exports) {
/**
 * @generated SignedSource<<c5ca11060b3f01d0eef237e6ba896387>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b53acbdb9b25f3a8$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v1 = {
        "kind": "ScalarField",
        "name": "productType"
    }, v2 = {
        "kind": "ScalarField",
        "name": "url"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            }
        ],
        "kind": "Fragment",
        "name": "useGlobalShortcutsDataRelay",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "cloudId",
                        "variableName": "cloudId"
                    }
                ],
                "kind": "LinkedField",
                "name": "appSwitcher_availableProductsBySite",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "products",
                                "plural": true,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v1 /*: any*/ ,
                                            v2 /*: any*/ 
                                        ],
                                        "type": "AppSwitcherSingleUrlProduct"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v1 /*: any*/ ,
                                            {
                                                "concreteType": "AppSwitcherProductSite",
                                                "kind": "LinkedField",
                                                "name": "sites",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "siteId"
                                                    },
                                                    v2 /*: any*/ 
                                                ]
                                            }
                                        ],
                                        "type": "AppSwitcherSiteScopedProduct"
                                    }
                                ]
                            }
                        ],
                        "type": "AppSwitcherAvailableProductsBySite"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "message"
                            }
                        ],
                        "type": "QueryError"
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$b53acbdb9b25f3a8$var$node.hash = "c8b29534eaae104f3d284f0f36fda276";
var $b53acbdb9b25f3a8$export$2e2bcd8739ae039 = $b53acbdb9b25f3a8$var$node;



var $cozmU = parcelRequire("cozmU");


var $huGTe = parcelRequire("huGTe");


var $6SsN4 = parcelRequire("6SsN4");


var $ixfCV = parcelRequire("ixfCV");


var $cXPtd = parcelRequire("cXPtd");

const $8fc466faee27ed0c$export$2dc34b66082250f3 = ({ queryRef: queryRef, cloudId: cloudId, onError: onError, shortcutsConfig: shortcutsConfig, onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks })=>{
    const onUpdateGetFilteredProductLinksRef = (0, $cozmU.useRef)(onUpdateGetFilteredProductLinks);
    onUpdateGetFilteredProductLinksRef.current = onUpdateGetFilteredProductLinks;
    /* eslint-disable @atlassian/relay/graphql-naming */ /* eslint-disable @atlassian/relay/no-wrapping-hooks */ const fragmentData = (0, $6SsN4.useFragment)((0, $b53acbdb9b25f3a8$export$2e2bcd8739ae039), queryRef);
    /* eslint-enable @atlassian/relay/graphql-naming */ /* eslint-enable @atlassian/relay/no-wrapping-hooks */ const appSwitcherResult = fragmentData?.appSwitcher_availableProductsBySite;
    (0, $cozmU.useEffect)(()=>{
        if (appSwitcherResult?.__typename === 'QueryError') onError?.(new Error(appSwitcherResult.message ?? 'appSwitcher_availableProductsBySite failed'));
    }, [
        appSwitcherResult,
        onError
    ]);
    const { productLinksByProductType: productLinksByProductType_0, productLinksRequestStatus: productLinksRequestStatus_0 } = (0, $cozmU.useMemo)(()=>{
        const productLinksRequestStatus = !appSwitcherResult ? (0, $cXPtd.RequestStatus).INIT : appSwitcherResult.__typename === 'QueryError' ? (0, $cXPtd.RequestStatus).ERROR : appSwitcherResult.__typename === 'AppSwitcherAvailableProductsBySite' ? (0, $cXPtd.RequestStatus).COMPLETE : (0, $cXPtd.RequestStatus).INIT;
        const productLinksByProductType = new Map();
        if (appSwitcherResult?.__typename === 'AppSwitcherAvailableProductsBySite') {
            const products = appSwitcherResult.products;
            if (products?.length) for (const product of products){
                if (product.__typename === 'AppSwitcherSingleUrlProduct') {
                    if (product.url) productLinksByProductType.set(product.productType, [
                        {
                            url: product.url
                        }
                    ]);
                } else if (product.__typename === 'AppSwitcherSiteScopedProduct') {
                    const links = (product.sites ?? []).filter((site)=>Boolean(site.url)).map((site_0)=>({
                            cloudId: site_0.siteId,
                            url: site_0.url
                        }));
                    if (links.length) productLinksByProductType.set(product.productType, links);
                }
            }
        }
        return {
            productLinksByProductType: productLinksByProductType,
            productLinksRequestStatus: productLinksRequestStatus
        };
    }, [
        appSwitcherResult
    ]);
    const productLinksByProductTypeRef = (0, $cozmU.useRef)(productLinksByProductType_0);
    productLinksByProductTypeRef.current = productLinksByProductType_0;
    const productLinksRequestStatusRef = (0, $cozmU.useRef)(productLinksRequestStatus_0);
    productLinksRequestStatusRef.current = productLinksRequestStatus_0;
    const lastCompleteProductLinksByTypeRef = (0, $cozmU.useRef)(new Map());
    if (productLinksRequestStatus_0 === (0, $cXPtd.RequestStatus).COMPLETE) lastCompleteProductLinksByTypeRef.current = new Map(productLinksByProductType_0);
    const getRelayProductLinksForKey = (0, $cozmU.useCallback)((apsKey)=>({
            links: ((0, $ixfCV.fg)('navx-gas-getlink-unstable-fix') ? lastCompleteProductLinksByTypeRef.current : productLinksByProductTypeRef.current).get(apsKey) ?? [],
            status: (0, $ixfCV.fg)('navx-gas-getlink-unstable-fix') ? (0, $cXPtd.RequestStatus).COMPLETE : productLinksRequestStatusRef.current
        }), []);
    (0, $cozmU.useEffect)(()=>{
        if (!onUpdateGetFilteredProductLinksRef.current) return;
        if (productLinksRequestStatus_0 !== (0, $cXPtd.RequestStatus).COMPLETE && (0, $ixfCV.fg)('navx-gas-getlink-unstable-fix')) return;
        onUpdateGetFilteredProductLinksRef.current(getRelayProductLinksForKey);
    }, [
        getRelayProductLinksForKey,
        productLinksRequestStatus_0,
        productLinksByProductType_0
    ]);
    const productUrlMap = (0, $cozmU.useMemo)(()=>{
        const urlByProductType = new Map();
        for (const [productType, links_0] of productLinksByProductType_0.entries()){
            if (!links_0.length) continue;
            const match = cloudId ? links_0.find((l)=>l.cloudId === cloudId) : undefined;
            const chosen = match ?? links_0[0];
            if (chosen?.url) urlByProductType.set(productType, chosen.url);
        }
        return urlByProductType;
    }, [
        productLinksByProductType_0,
        cloudId
    ]);
    const appShortcuts = (0, $cozmU.useMemo)(()=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($huGTe)))(shortcutsConfig)) return shortcutsConfig;
        const config = shortcutsConfig;
        if (!productUrlMap.size) return shortcutsConfig;
        const isArray = Array.isArray(config);
        if (isArray) return config.reduce((acc, item)=>{
            if (item.type !== 'link' || !item.apsKey) {
                acc.push(item);
                return acc;
            }
            const url = productUrlMap.get(item.apsKey);
            if (url) acc.push({
                ...item,
                url: url
            });
            return acc;
        }, []);
        const entries = Object.entries(config);
        return entries.reduce((acc_0, [key, value])=>{
            if (value.type !== 'link' || !value.apsKey) {
                acc_0[key] = value;
                return acc_0;
            }
            const url_0 = productUrlMap.get(value.apsKey);
            if (url_0) acc_0[key] = {
                ...value,
                url: url_0
            };
            return acc_0;
        }, {});
    }, [
        productUrlMap,
        shortcutsConfig
    ]);
    return appShortcuts;
};
module.exports["useGlobalShortcutsDataRelay"] = $8fc466faee27ed0c$export$2dc34b66082250f3;

});

parcelRegister("cXPtd", function(module, exports) {
var $ae53bce35cc1f1d1$export$600e7c1f9e0414e1 = /*#__PURE__*/ function(RequestStatus) {
    RequestStatus["INIT"] = "initializing";
    RequestStatus["LOADING"] = "loading";
    RequestStatus["COMPLETE"] = "complete";
    RequestStatus["ERROR"] = "error";
    return RequestStatus;
}({});
var $ae53bce35cc1f1d1$export$92e44ea1079b9ec6 = /*#__PURE__*/ function(Products) {
    // ATLAS_* - Need to be standalone apps to sit in this space
    Products["ATLAS_ALIGN"] = "ALIGN";
    Products["ATLAS_HOME"] = "ATLAS_HOME";
    Products["ATLAS_GOALS"] = "GOALS";
    Products["ATLAS_TEAMS"] = "TEAMS";
    Products["ATLAS_HUB"] = "ATLAS_HUB";
    Products["ANALYTICS"] = "ANALYTICS";
    Products["ASSETS"] = "ASSETS";
    Products["BITBUCKET"] = "BITBUCKET";
    Products["COMPASS"] = "COMPASS";
    Products["CUSTOMER_SERVICE_MANAGEMENT"] = "JIRA_CUSTOMER_SERVICE";
    Products["FOCUS"] = "mercury";
    Products["STUDIO"] = "STUDIO";
    Products["OPSGENIE"] = "OPSGENIE";
    Products["JIRA_SERVICE_MANAGEMENT"] = "JIRA_SERVICE_DESK";
    Products["JIRA_PRODUCT_DISCOVERY"] = "JIRA_PRODUCT_DISCOVERY";
    Products["JIRA_SOFTWARE"] = "JIRA_SOFTWARE";
    Products["CONFLUENCE"] = "CONFLUENCE";
    Products["LOOM"] = "LOOM";
    Products["PROJECTS"] = "PROJECTS";
    Products["TALENT"] = "TALENT";
    Products["TRELLO"] = "TRELLO";
    Products["FEEDBACK"] = "FEEDBACK";
    return Products;
}({});
const $ae53bce35cc1f1d1$export$85183a312807388d = 'navigation';
module.exports["RequestStatus"] = $ae53bce35cc1f1d1$export$600e7c1f9e0414e1;
module.exports["Products"] = $ae53bce35cc1f1d1$export$92e44ea1079b9ec6;
module.exports["ANALYTICS_CHANNEL"] = $ae53bce35cc1f1d1$export$85183a312807388d;

});

parcelRegister("9kVQp", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

/**
 * @generated SignedSource<<8307d24646dec2179f7b4020c61d570b>>
 * @relayHash 86994beb11f4ef7c8af21523816aa062
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d25c1a9e348f5cef268af0c5a574df9a275e97bc5093fe2bce8d15900b232a1c
const $5296e6a3c12ed06f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v2 = {
        "kind": "ScalarField",
        "name": "productType"
    }, v3 = {
        "kind": "ScalarField",
        "name": "url"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "GlobalShortcutsRelayClientQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "useGlobalShortcutsDataRelay"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "GlobalShortcutsRelayClientQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        }
                    ],
                    "kind": "LinkedField",
                    "name": "appSwitcher_availableProductsBySite",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "products",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ 
                                            ],
                                            "type": "AppSwitcherSingleUrlProduct"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "concreteType": "AppSwitcherProductSite",
                                                    "kind": "LinkedField",
                                                    "name": "sites",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "siteId"
                                                        },
                                                        v3 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "AppSwitcherSiteScopedProduct"
                                        }
                                    ]
                                }
                            ],
                            "type": "AppSwitcherAvailableProductsBySite"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                }
                            ],
                            "type": "QueryError"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d25c1a9e348f5cef268af0c5a574df9a275e97bc5093fe2bce8d15900b232a1c",
            "metadata": {},
            "name": "GlobalShortcutsRelayClientQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$5296e6a3c12ed06f$var$node.hash = "293957e10078d4cb40237c0fdc35aadd";
var $5296e6a3c12ed06f$export$2e2bcd8739ae039 = $5296e6a3c12ed06f$var$node;



var $cozmU = parcelRequire("cozmU");


var $huGTe = parcelRequire("huGTe");


var $6SsN4 = parcelRequire("6SsN4");


var $ixfCV = parcelRequire("ixfCV");


var $d5gEx = parcelRequire("d5gEx");


var $cV7Sf = parcelRequire("cV7Sf");

const $8bbd0498031e8196$var$HydrationSafeSuspenseContent = /*#__PURE__*/ (0, $cozmU.memo)((0, $gtMdU.isReactCompilerActivePlatform)() ? function HydrationSafeSuspenseContent(t0) {
    const $ = (0, $bDgLe.c)(3);
    const { children: children, fallback: fallback } = t0;
    let t1;
    if ($[0] !== children || $[1] !== fallback) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: fallback
        }, children);
        $[0] = children;
        $[1] = fallback;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : function HydrationSafeSuspenseContent({ children: children, fallback: fallback }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: fallback
    }, children);
}, (_prevProps, nextProps)=>{
    // Block prop propagation into the Suspense boundary while locked (during hydration)
    return nextProps.isLocked;
});
const $8bbd0498031e8196$var$HydrationSafeSuspense = (0, $gtMdU.isReactCompilerActivePlatform)() ? function HydrationSafeSuspense(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { fallback: t1, children: children } = t0;
    const fallback = t1 === undefined ? null : t1;
    const [isLocked, setIsLocked] = (0, $cozmU.useState)(true);
    let t2;
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            setIsLocked(false);
        };
        t3 = [];
        $[0] = t2;
        $[1] = t3;
    } else {
        t2 = $[0];
        t3 = $[1];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[2] !== children || $[3] !== fallback || $[4] !== isLocked) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8bbd0498031e8196$var$HydrationSafeSuspenseContent, {
            isLocked: isLocked,
            fallback: fallback
        }, children);
        $[2] = children;
        $[3] = fallback;
        $[4] = isLocked;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
} : function HydrationSafeSuspense({ fallback: fallback = null, children: children }) {
    // Always start locked (true) regardless of SSR or CSR — this covers both SSR hydration
    // AND client-side transitions (e.g. edit mode) where process.env.REACT_SSR is false
    // but React still needs the boundary to stay stable until after the first mount.
    const [isLocked, setIsLocked] = (0, $cozmU.useState)(true);
    (0, $cozmU.useEffect)(()=>{
        setIsLocked(false);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8bbd0498031e8196$var$HydrationSafeSuspenseContent, {
        isLocked: isLocked,
        fallback: fallback
    }, children);
};
const $8bbd0498031e8196$var$emptySubscribe = ()=>()=>{};
/**
 * Returns `false` during SSR and the client's hydrating render, then `true` once React has finished
 * hydrating this subtree
 */ const $8bbd0498031e8196$var$useIsHydrated = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useIsHydrated() {
    return (0, $cozmU.useSyncExternalStore)($8bbd0498031e8196$var$emptySubscribe, $8bbd0498031e8196$var$_temp, $8bbd0498031e8196$var$_temp2);
} : function useIsHydrated() {
    return (0, $cozmU.useSyncExternalStore)($8bbd0498031e8196$var$emptySubscribe, ()=>true, ()=>false);
};
/**
 * Standalone GAS Relay entry: includes `RelayEnvironmentProvider` and `HydrationSafeSuspense`
 * so callers do not need to wrap the tree.
 *
 * Guards against React error #421 ("Suspense boundary received an update before it finished
 * hydrating"). When the `navx-4463-gas-agg-migration` gate is on, `GlobalShortcutsRelayClientImpl`
 * calls `loadQuery()` inside a `useEffect` on mount, which updates Relay's query-loader state while
 * the surrounding boundary is still hydrating.
 *
 * Behind the `confluence_global_shortcuts_hydration` gate we render the non-suspending
 * `GlobalShortcutsRelayClientSkip` until after the first mount (`isHydrated`), so the data-fetching
 * `HydrationSafeSuspense` boundary only mounts post-hydration and can never trip #421. With the
 * gate off, the `HydrationSafeSuspense` lock alone is the (best-effort) guard.
 *
 * Fallback uses `GlobalShortcutsRelayClientSkip` (no preload, same merge path).
 */ function $8bbd0498031e8196$var$_temp2() {
    return false;
}
function $8bbd0498031e8196$var$_temp() {
    return true;
}
const $8bbd0498031e8196$var$GlobalShortcutsRelayClient = (0, $gtMdU.isReactCompilerActivePlatform)() ? function GlobalShortcutsRelayClient(props) {
    const $ = (0, $bDgLe.c)(3);
    const isHydrated = $8bbd0498031e8196$var$useIsHydrated();
    let t0;
    if ($[0] !== isHydrated || $[1] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5gEx.RelayEnvironmentProvider), null, !isHydrated && (0, $ixfCV.fg)("confluence_global_shortcuts_hydration") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8bbd0498031e8196$var$GlobalShortcutsRelayClientSkip, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8bbd0498031e8196$var$HydrationSafeSuspense, {
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8bbd0498031e8196$var$GlobalShortcutsRelayClientSkip, props)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8bbd0498031e8196$var$GlobalShortcutsRelayClientImpl, props)));
        $[0] = isHydrated;
        $[1] = props;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : function GlobalShortcutsRelayClient(props) {
    const isHydrated = $8bbd0498031e8196$var$useIsHydrated();
    // Render Skip until after mount so the Suspense boundary only mounts post-hydration (avoids #421).
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5gEx.RelayEnvironmentProvider), null, !isHydrated && (0, $ixfCV.fg)('confluence_global_shortcuts_hydration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8bbd0498031e8196$var$GlobalShortcutsRelayClientSkip, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8bbd0498031e8196$var$HydrationSafeSuspense, {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8bbd0498031e8196$var$GlobalShortcutsRelayClientSkip, props)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8bbd0498031e8196$var$GlobalShortcutsRelayClientImpl, props)));
};
var $8bbd0498031e8196$export$2e2bcd8739ae039 = $8bbd0498031e8196$var$GlobalShortcutsRelayClient;
const $8bbd0498031e8196$var$GlobalShortcutsRelayClientImpl = (0, $gtMdU.isReactCompilerActivePlatform)() ? function GlobalShortcutsRelayClientImpl(props) {
    const $ = (0, $bDgLe.c)(14);
    let t0;
    if ($[0] !== props.cloudId || $[1] !== props.isShortcutsStatic || $[2] !== props.shortcutsConfig) {
        t0 = Boolean(props.cloudId) && !props.isShortcutsStatic && !(0, (/*@__PURE__*/$parcel$interopDefault($huGTe)))(props.shortcutsConfig);
        $[0] = props.cloudId;
        $[1] = props.isShortcutsStatic;
        $[2] = props.shortcutsConfig;
        $[3] = t0;
    } else t0 = $[3];
    const shouldFetch = t0;
    const [queryRef, loadQuery] = (0, $6SsN4.useQueryLoader)((0, $5296e6a3c12ed06f$export$2e2bcd8739ae039));
    let t1;
    let t2;
    if ($[4] !== loadQuery || $[5] !== props.cloudId || $[6] !== shouldFetch) {
        t1 = ()=>{
            if (!shouldFetch) return;
            (0, $cozmU.startTransition)(()=>{
                loadQuery({
                    cloudId: props.cloudId ?? ""
                });
            });
        };
        t2 = [
            shouldFetch,
            props.cloudId,
            loadQuery
        ];
        $[4] = loadQuery;
        $[5] = props.cloudId;
        $[6] = shouldFetch;
        $[7] = t1;
        $[8] = t2;
    } else {
        t1 = $[7];
        t2 = $[8];
    }
    (0, $cozmU.useEffect)(t1, t2);
    if (!shouldFetch || queryRef == null) {
        let t3;
        if ($[9] !== props) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8bbd0498031e8196$var$GlobalShortcutsRelayClientSkip, props);
            $[9] = props;
            $[10] = t3;
        } else t3 = $[10];
        return t3;
    }
    let t3;
    if ($[11] !== props || $[12] !== queryRef) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8bbd0498031e8196$var$GlobalShortcutsRelayClientPreloaded, {
            queryRef: queryRef,
            ...props
        });
        $[11] = props;
        $[12] = queryRef;
        $[13] = t3;
    } else t3 = $[13];
    return t3;
} : function GlobalShortcutsRelayClientImpl(props) {
    const shouldFetch = Boolean(props.cloudId) && !props.isShortcutsStatic && !(0, (/*@__PURE__*/$parcel$interopDefault($huGTe)))(props.shortcutsConfig);
    const [queryRef, loadQuery] = (0, $6SsN4.useQueryLoader)((0, $5296e6a3c12ed06f$export$2e2bcd8739ae039));
    (0, $cozmU.useEffect)(()=>{
        if (!shouldFetch) return;
        (0, $cozmU.startTransition)(()=>{
            loadQuery({
                cloudId: props.cloudId ?? ''
            });
        });
    }, [
        shouldFetch,
        props.cloudId,
        loadQuery
    ]);
    if (!shouldFetch || queryRef == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8bbd0498031e8196$var$GlobalShortcutsRelayClientSkip, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8bbd0498031e8196$var$GlobalShortcutsRelayClientPreloaded, {
        queryRef: queryRef,
        ...props
    });
};
const $8bbd0498031e8196$var$GlobalShortcutsRelayClientSkip = (0, $gtMdU.isReactCompilerActivePlatform)() ? function GlobalShortcutsRelayClientSkip(t0) {
    const $ = (0, $bDgLe.c)(11);
    const { children: children, shortcutsConfig: shortcutsConfig, cloudId: cloudId, onError: onError, product: product, onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks } = t0;
    let t1;
    if ($[0] !== cloudId || $[1] !== onError || $[2] !== onUpdateGetFilteredProductLinks || $[3] !== product || $[4] !== shortcutsConfig) {
        t1 = {
            queryRef: undefined,
            shortcutsConfig: shortcutsConfig,
            cloudId: cloudId,
            onError: onError,
            product: product,
            onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks
        };
        $[0] = cloudId;
        $[1] = onError;
        $[2] = onUpdateGetFilteredProductLinks;
        $[3] = product;
        $[4] = shortcutsConfig;
        $[5] = t1;
    } else t1 = $[5];
    const shortcutItems = (0, $cV7Sf.useGlobalShortcutsDataRelay)(t1);
    const t2 = shortcutItems;
    let t3;
    if ($[6] !== children || $[7] !== t2) {
        t3 = children(t2);
        $[6] = children;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t3);
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
} : function GlobalShortcutsRelayClientSkip({ children: children, shortcutsConfig: shortcutsConfig, cloudId: cloudId, onError: onError, product: product, onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks }) {
    const shortcutItems = (0, $cV7Sf.useGlobalShortcutsDataRelay)({
        queryRef: undefined,
        shortcutsConfig: shortcutsConfig,
        cloudId: cloudId,
        onError: onError,
        product: product,
        onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children(shortcutItems));
};
const $8bbd0498031e8196$var$GlobalShortcutsRelayClientPreloaded = (0, $gtMdU.isReactCompilerActivePlatform)() ? function GlobalShortcutsRelayClientPreloaded(t0) {
    const $ = (0, $bDgLe.c)(12);
    const { queryRef: queryRef, children: children, shortcutsConfig: shortcutsConfig, cloudId: cloudId, onError: onError, product: product, onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks } = t0;
    const queryData = (0, $6SsN4.usePreloadedQuery)((0, $5296e6a3c12ed06f$export$2e2bcd8739ae039), queryRef);
    let t1;
    if ($[0] !== cloudId || $[1] !== onError || $[2] !== onUpdateGetFilteredProductLinks || $[3] !== product || $[4] !== queryData || $[5] !== shortcutsConfig) {
        t1 = {
            queryRef: queryData,
            shortcutsConfig: shortcutsConfig,
            cloudId: cloudId,
            onError: onError,
            product: product,
            onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks
        };
        $[0] = cloudId;
        $[1] = onError;
        $[2] = onUpdateGetFilteredProductLinks;
        $[3] = product;
        $[4] = queryData;
        $[5] = shortcutsConfig;
        $[6] = t1;
    } else t1 = $[6];
    const shortcutItems = (0, $cV7Sf.useGlobalShortcutsDataRelay)(t1);
    const t2 = shortcutItems;
    let t3;
    if ($[7] !== children || $[8] !== t2) {
        t3 = children(t2);
        $[7] = children;
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    let t4;
    if ($[10] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t3);
        $[10] = t3;
        $[11] = t4;
    } else t4 = $[11];
    return t4;
} : function GlobalShortcutsRelayClientPreloaded({ queryRef: queryRef, children: children, shortcutsConfig: shortcutsConfig, cloudId: cloudId, onError: onError, product: product, onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks }) {
    const queryData = (0, $6SsN4.usePreloadedQuery)((0, $5296e6a3c12ed06f$export$2e2bcd8739ae039), queryRef);
    const shortcutItems = (0, $cV7Sf.useGlobalShortcutsDataRelay)({
        queryRef: queryData,
        shortcutsConfig: shortcutsConfig,
        cloudId: cloudId,
        onError: onError,
        product: product,
        onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children(shortcutItems));
};
module.exports["default"] = $8bbd0498031e8196$export$2e2bcd8739ae039;

});

parcelRegister("gOXu0", function(module, exports) {
$parcel$export(module.exports, "useGlobalShortcutsDataBFF", () => (parcelRequire("3vXmx")).useGlobalShortcutsDataBFF);
/* eslint-disable import/order */ 
var $3vXmx = parcelRequire("3vXmx");


var $cV7Sf = parcelRequire("cV7Sf");

const $3aa12f212f3c971e$export$bc8645ef40313f94 = (0, $3vXmx.useGlobalShortcutsDataBFF);

});

parcelRegister("1PREo", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $8AWCX = parcelRequire("8AWCX");

const $46d0283d8d2da690$var$styles = {
    root: "_4t3iutpp"
}; /**
    * Use this component to create visual separation between the:
    *
    * - global app shortcut section
    * - 'more' button menu item
    * - starred spaces (in Confluence)
    *
    * Only use this component in the top level of the menu,
    * and exercise caution when using it in new situations.
    *
    * This component exists to fulfil product design requirements but has not yet
    * been consolidated into the wider navigation system.
    *
    * It may not exist in the future when global apps are no longer in the side navigation.
    */ 
const $46d0283d8d2da690$export$5776f68925982056 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function TopLevelSpacer() {
    const $ = (0, $bDgLe.c)(4);
    const level = (0, $8AWCX.useLevel)();
    let t0;
    let t1;
    if ($[0] !== level) {
        t0 = ()=>{};
        t1 = [
            level
        ];
        $[0] = level;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, $cozmU.useEffect)(t0, t1);
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $46d0283d8d2da690$var$styles.root
            ])
        });
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function TopLevelSpacer() {
    const level = (0, $8AWCX.useLevel)();
    (0, $cozmU.useEffect)(()=>{}, [
        level
    ]);
    return /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $46d0283d8d2da690$var$styles.root
        ])
    });
};
module.exports["TopLevelSpacer"] = $46d0283d8d2da690$export$5776f68925982056;

});

parcelRegister("gq8Du", function(module, exports) {
const $3f8db0f27a859e4a$export$72b069d0875dccc = {
    MENU: 'L1MenuGroup',
    SHORTCUTS: 'L1ShortcutsGroup'
};
module.exports["L1_MENU_GROUPS"] = $3f8db0f27a859e4a$export$72b069d0875dccc;

});

parcelRegister("pl8ng", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bB0i2 = parcelRequire("bB0i2");

// When a user drags & drops a navigation item, ADS recommends that we flash the item visually, and if the move was
// triggered by keyboard, also set focus to the moved item. This element registry allows GSN to keep track of the
// actual HTML elements of the L1 items, so that we can flash and focus them after the drag & drop action is performed.
// This pattern is recommended by AtlasKit in the side nav drag & drop documentation:
// https://atlassian.design/components/navigation-system/side-nav-items/drag-and-drop#on-drop
const $12af1507b626ad3d$var$MORE_MENU_ID = Symbol('moreMenuId');
function $12af1507b626ad3d$export$b8d30beb0c187a7() {
    const registry = new Map();
    function registerL1Item({ id: id, element: element }) {
        registry.set(id, element);
        return function cleanup() {
            registry.delete(id);
        };
    }
    function getL1ItemElement(id) {
        return registry.get(id);
    }
    function registerMoreMenuItem(element) {
        return registerL1Item({
            id: $12af1507b626ad3d$var$MORE_MENU_ID,
            element: element
        });
    }
    function getMoreMenuElement() {
        return getL1ItemElement($12af1507b626ad3d$var$MORE_MENU_ID);
    }
    return {
        getL1ItemElement: getL1ItemElement,
        getMoreMenuElement: getMoreMenuElement,
        registerL1Item: registerL1Item,
        registerMoreMenuItem: registerMoreMenuItem
    };
}
const $12af1507b626ad3d$var$ElementRegistryContext = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $12af1507b626ad3d$export$ce0cc6a5e9b6a71a = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ElementRegistryProvider(t0) {
    const $ = (0, $bDgLe.c)(3);
    const { children: children, registry: registry } = t0;
    let t1;
    if ($[0] !== children || $[1] !== registry) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($12af1507b626ad3d$var$ElementRegistryContext.Provider, {
            value: registry
        }, children);
        $[0] = children;
        $[1] = registry;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : function ElementRegistryProvider({ children: children, registry: registry }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($12af1507b626ad3d$var$ElementRegistryContext.Provider, {
        value: registry
    }, children);
};
const $12af1507b626ad3d$export$9a176103b34f9da9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useElementRegistry() {
    const elementRegistry = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext($12af1507b626ad3d$var$ElementRegistryContext);
    (0, $bB0i2.default)(elementRegistry, "useElementRegistry must be used within an ElementRegistryProvider");
    return elementRegistry;
} : function useElementRegistry() {
    const elementRegistry = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext($12af1507b626ad3d$var$ElementRegistryContext);
    (0, $bB0i2.default)(elementRegistry, 'useElementRegistry must be used within an ElementRegistryProvider');
    return elementRegistry;
};
module.exports["createElementRegistry"] = $12af1507b626ad3d$export$b8d30beb0c187a7;
module.exports["ElementRegistryProvider"] = $12af1507b626ad3d$export$ce0cc6a5e9b6a71a;
module.exports["useElementRegistry"] = $12af1507b626ad3d$export$9a176103b34f9da9;

});

parcelRegister("6ZNK7", function(module, exports) {
const $56362c6cc63b01d8$var$l1ItemKey = Symbol('l1ItemKey');
const $56362c6cc63b01d8$var$nestedItemKey = Symbol('nestedItemKey');
const $56362c6cc63b01d8$var$moreMenuKey = Symbol('moreMenuKey');
const $56362c6cc63b01d8$export$a1dfda61267432e5 = (data)=>({
        ...data,
        type: 'menu-item',
        [$56362c6cc63b01d8$var$l1ItemKey]: true
    });
const $56362c6cc63b01d8$export$e9f7c92759d0f281 = (data)=>({
        ...data
    });
const $56362c6cc63b01d8$export$e52c346726a16591 = (data)=>{
    return data[$56362c6cc63b01d8$var$l1ItemKey] === true;
};
const $56362c6cc63b01d8$export$9d9fcc463b545806 = (data, groups)=>{
    return Array.isArray(groups) ? groups.includes(data.group) : groups === data.group;
};
const $56362c6cc63b01d8$export$7960450fbf5a0a72 = Symbol('moreMenuId');
function $56362c6cc63b01d8$export$e74f096ffe08821d() {
    return {
        menuItemId: $56362c6cc63b01d8$export$7960450fbf5a0a72,
        [$56362c6cc63b01d8$var$moreMenuKey]: true
    };
}
function $56362c6cc63b01d8$export$e37de48254c6595e(data) {
    return data[$56362c6cc63b01d8$var$moreMenuKey] === true;
}
const $56362c6cc63b01d8$export$fe7d1a1bab9e2488 = (data)=>({
        ...data,
        type: 'menu-item',
        [$56362c6cc63b01d8$var$nestedItemKey]: true
    });
const $56362c6cc63b01d8$export$db162439b96bd9a8 = (data)=>{
    return {
        ...data,
        [$56362c6cc63b01d8$var$nestedItemKey]: true
    };
};
const $56362c6cc63b01d8$export$23cae75a8064fbc1 = (data)=>{
    return data[$56362c6cc63b01d8$var$nestedItemKey] === true;
};
const $56362c6cc63b01d8$export$a3f9aca82641b845 = (data, groups)=>{
    return Array.isArray(groups) ? groups.includes(data.group) : groups === data.group;
};
const $56362c6cc63b01d8$export$98ff4de2f070152d = {
    MOVE_TO_TOP: 'MOVE_TO_TOP',
    MOVE_UP: 'MOVE_UP',
    MOVE_DOWN: 'MOVE_DOWN',
    MOVE_TO_BOTTOM: 'MOVE_TO_BOTTOM',
    BEFORE: 'reorder-before',
    AFTER: 'reorder-after'
};
module.exports["createL1ItemData"] = $56362c6cc63b01d8$export$a1dfda61267432e5;
module.exports["getL1ItemData"] = $56362c6cc63b01d8$export$e9f7c92759d0f281;
module.exports["isL1ItemData"] = $56362c6cc63b01d8$export$e52c346726a16591;
module.exports["isL1ItemDataInGroup"] = $56362c6cc63b01d8$export$9d9fcc463b545806;
module.exports["getMoreMenuData"] = $56362c6cc63b01d8$export$e74f096ffe08821d;
module.exports["isMoreMenuData"] = $56362c6cc63b01d8$export$e37de48254c6595e;

});

parcelRegister("91jNq", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $5Dlqn = parcelRequire("5Dlqn");


var $6iJ3v = parcelRequire("6iJ3v");


var $InD31 = parcelRequire("InD31");


var $h11I1 = parcelRequire("h11I1");


var $1TBPy = parcelRequire("1TBPy");

const $a83ddc93d6b30790$export$34e3b4eaa687835 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, forwardedRef)=>{
    const $ = (0, $bDgLe.c)(24);
    const { children: children, id: id, isOpen: isOpenControlled, isDefaultOpen: t1, onOpenChange: onOpenChange } = t0;
    const isDefaultOpen = t1 === undefined ? false : t1;
    let t2;
    if ($[0] !== isDefaultOpen) {
        t2 = ()=>isDefaultOpen;
        $[0] = isDefaultOpen;
        $[1] = t2;
    } else t2 = $[1];
    const [isOpen, setIsOpen] = (0, $5Dlqn.default)(isOpenControlled, t2);
    const titleId = (0, $cozmU.useId)();
    const previousIsOpen = (0, $6iJ3v.default)(isOpen);
    const onCloseRef = (0, $cozmU.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t3;
    let t4;
    if ($[2] !== createAnalyticsEvent || $[3] !== isOpen || $[4] !== onOpenChange || $[5] !== previousIsOpen) {
        t3 = ()=>{
            if (previousIsOpen === undefined || previousIsOpen === isOpen) return;
            if (isOpen && previousIsOpen === false) {
                const navigationAnalyticsEvent = createAnalyticsEvent({
                    source: "sideNav",
                    actionSubject: "flyoutMenu",
                    action: "opened"
                });
                navigationAnalyticsEvent.fire("navigation");
            }
            onOpenChange?.(isOpen);
        };
        t4 = [
            isOpen,
            onOpenChange,
            previousIsOpen,
            createAnalyticsEvent
        ];
        $[2] = createAnalyticsEvent;
        $[3] = isOpen;
        $[4] = onOpenChange;
        $[5] = previousIsOpen;
        $[6] = t3;
        $[7] = t4;
    } else {
        t3 = $[6];
        t4 = $[7];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[8] !== children || $[9] !== id || $[10] !== isOpen) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $InD31.Popup), {
            id: id,
            isOpen: isOpen,
            role: "dialog"
        }, children);
        $[8] = children;
        $[9] = id;
        $[10] = isOpen;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] !== forwardedRef || $[13] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $h11I1.MenuListItem), {
            ref: forwardedRef
        }, t5);
        $[12] = forwardedRef;
        $[13] = t5;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] !== t6 || $[16] !== titleId) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1TBPy.OnCloseContext).Provider, {
            value: onCloseRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1TBPy.TitleIdContextProvider), {
            value: titleId
        }, t6));
        $[15] = t6;
        $[16] = titleId;
        $[17] = t7;
    } else t7 = $[17];
    let t8;
    if ($[18] !== setIsOpen || $[19] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1TBPy.SetIsOpenContext).Provider, {
            value: setIsOpen
        }, t7);
        $[18] = setIsOpen;
        $[19] = t7;
        $[20] = t8;
    } else t8 = $[20];
    let t9;
    if ($[21] !== isOpen || $[22] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1TBPy.IsOpenContext).Provider, {
            value: isOpen
        }, t8);
        $[21] = isOpen;
        $[22] = t8;
        $[23] = t9;
    } else t9 = $[23];
    return t9;
} : ({ children: children, id: id, isOpen: isOpenControlled, isDefaultOpen: isDefaultOpen = false, onOpenChange: onOpenChange }, forwardedRef)=>{
    const [isOpen, setIsOpen] = (0, $5Dlqn.default)(isOpenControlled, ()=>isDefaultOpen);
    const titleId = (0, $cozmU.useId)();
    const previousIsOpen = (0, $6iJ3v.default)(isOpen);
    const onCloseRef = (0, $cozmU.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        if (previousIsOpen === undefined || previousIsOpen === isOpen) /**
       * The previous value is `undefined` on initialization, so if it is `undefined` then the value hasn't changed.
       *
       * The previous value can be equal to the current one if the component re-renders due to something else changing.
       *
       * In both cases the value hasn't changed and we don't want to notify consumers.
       */ return;
        // When flyout menu is opened, fire analytics event
        if (isOpen && previousIsOpen === false) {
            const navigationAnalyticsEvent = createAnalyticsEvent({
                source: 'sideNav',
                actionSubject: 'flyoutMenu',
                action: 'opened'
            });
            navigationAnalyticsEvent.fire('navigation');
        }
        onOpenChange?.(isOpen);
    }, [
        isOpen,
        onOpenChange,
        previousIsOpen,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1TBPy.IsOpenContext).Provider, {
        value: isOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1TBPy.SetIsOpenContext).Provider, {
        value: setIsOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1TBPy.OnCloseContext).Provider, {
        value: onCloseRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1TBPy.TitleIdContextProvider), {
        value: titleId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $h11I1.MenuListItem), {
        ref: forwardedRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $InD31.Popup), {
        id: id,
        isOpen: isOpen,
        role: "dialog"
    }, children))))));
});
module.exports["FlyoutMenuItem"] = $a83ddc93d6b30790$export$34e3b4eaa687835;

});

parcelRegister("InD31", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6JrSr = parcelRequire("6JrSr");


var $ixfCV = parcelRequire("ixfCV");


var $akErP = parcelRequire("akErP");


var $dpUmv = parcelRequire("dpUmv");


var $hj0rK = parcelRequire("hj0rK");


var $iKSY4 = parcelRequire("iKSY4");


var $dY7Kg = parcelRequire("dY7Kg");


var $EZmp0 = parcelRequire("EZmp0");


var $a9KY5 = parcelRequire("a9KY5");


var $7tDc6 = parcelRequire("7tDc6");

const $bac0d0bd018ab01d$export$129a32eedafa97c5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { children: children, id: providedId, isOpen: t1, role: role } = t0;
    const isOpen = t1 === undefined ? false : t1;
    const [triggerRef, setTriggerRef] = (0, $cozmU.useState)(null);
    const triggerRefObject = (0, $cozmU.useRef)(null);
    const generatedId = (0, $6JrSr.useId)();
    const id = providedId || generatedId;
    let t2;
    if ($[0] !== children) {
        t2 = (0, $ixfCV.fg)("platform-dst-top-layer") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7tDc6.TriggerRefObjectContext).Provider, {
            value: triggerRefObject
        }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $akErP.Manager), null, children);
        $[0] = children;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== isOpen || $[3] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $EZmp0.SetTriggerRefContext).Provider, {
            value: setTriggerRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iKSY4.IsOpenContext).Provider, {
            value: isOpen
        }, t2));
        $[2] = isOpen;
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== t3 || $[6] !== triggerRef) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9KY5.TriggerRefContext).Provider, {
            value: triggerRef
        }, t3);
        $[5] = t3;
        $[6] = triggerRef;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== id || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hj0rK.EnsureIsInsidePopupContext).Provider, {
            value: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dpUmv.IdContext).Provider, {
            value: id
        }, t4));
        $[8] = id;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== role || $[12] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dY7Kg.RoleContext).Provider, {
            value: role
        }, t5);
        $[11] = role;
        $[12] = t5;
        $[13] = t6;
    } else t6 = $[13];
    return t6;
} : ({ children: children, id: providedId, isOpen: isOpen = false, role: role })=>{
    const [triggerRef, setTriggerRef] = (0, $cozmU.useState)(null);
    // When the top-layer flag is on, we maintain a stable RefObject for the
    // trigger element, provided through TriggerRefObjectContext. Unlike the
    // state-based triggerRef (which causes a re-render when the trigger mounts),
    // this ref has a stable identity so useAnchorPosition's useLayoutEffect dep
    // array never changes — the effect runs once on mount when the trigger element
    // is already populated. PopupTrigger sets this ref directly instead of calling
    // the state setter, avoiding an unnecessary re-render.
    const triggerRefObject = (0, $cozmU.useRef)(null);
    const generatedId = (0, $6JrSr.useId)();
    const id = providedId || generatedId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dY7Kg.RoleContext).Provider, {
        value: role
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hj0rK.EnsureIsInsidePopupContext).Provider, {
        value: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dpUmv.IdContext).Provider, {
        value: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9KY5.TriggerRefContext).Provider, {
        value: triggerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $EZmp0.SetTriggerRefContext).Provider, {
        value: setTriggerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iKSY4.IsOpenContext).Provider, {
        value: isOpen
    }, (0, $ixfCV.fg)('platform-dst-top-layer') ? // Skip Popper's <Manager> when Top Layer is being used.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7tDc6.TriggerRefObjectContext).Provider, {
        value: triggerRefObject
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $akErP.Manager), null, children)))))));
};
module.exports["Popup"] = $bac0d0bd018ab01d$export$129a32eedafa97c5;

});

parcelRegister("cVdZm", function(module, exports) {
/* flyout-menu-item-content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $lmzCg = parcelRequire("lmzCg");


var $ixfCV = parcelRequire("ixfCV");


var $QodSn = parcelRequire("QodSn");


var $1TBPy = parcelRequire("1TBPy");

const $b8cce1e6327914dc$var$FLYOUT_MENU_VERTICAL_OFFSET_PX = 26; /**
                                            * The maximum height of the flyout menu in pixels, following the Confluence standard maximum
                                            * height of 760px.
                                            */ 
const $b8cce1e6327914dc$var$FLYOUT_MENU_MAX_HEIGHT_PX = 760;
const $b8cce1e6327914dc$var$FLYOUT_MENU_PADDING = "var(--ds-space-100, 8px)"; /**
                                                         * The margin around the flyout menu popup when it has its modal appearance on mobile screen sizes.
                                                         */ 
const $b8cce1e6327914dc$var$FLYOUT_MENU_MODAL_MARGIN = 4;
const $b8cce1e6327914dc$var$maxHeightCssVar = '--max-height';
const $b8cce1e6327914dc$var$flyoutMenuItemContentStyles = {
    root: "_1q51u2gc _85i5u2gc _bozgu2gc _y4tiu2gc _14b51kdj"
};
const $b8cce1e6327914dc$var$flyoutMenuItemContentContainerStyles = {
    container: "_1e0c1txw _4t3i1osq _2lx21bp4 _c71lq9dn _1jop304o"
};
const $b8cce1e6327914dc$export$2ca9a13c57a8839a = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ children: children, containerTestId: containerTestId, onClose: onClose, autoFocus: autoFocus, maxHeight: maxHeight = $b8cce1e6327914dc$var$FLYOUT_MENU_MAX_HEIGHT_PX }, forwardedRef)=>{
    const setIsOpen = (0, $cozmU.useContext)((0, $1TBPy.SetIsOpenContext));
    const onCloseRef = (0, $cozmU.useContext)((0, $1TBPy.OnCloseContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)(); // The source of the close is not accessible to the consumer, it is determined within the
    // handleClose function, or passed in as a parameter in FlyoutMenuItemTrigger (outside-click),
    // or FlyoutHeader (close-button).
    const handleClose = (0, $cozmU.useCallback)((event, source)=>{
        // Use the passed source if provided, otherwise determine from event
        let determinedSource = source || 'other';
        if (!source) {
            if (event instanceof KeyboardEvent) {
                const keyboardEvent = event;
                if (keyboardEvent.key === 'Escape' || keyboardEvent.key === 'Esc') determinedSource = 'escape-key';
            } else if (event instanceof MouseEvent) {
                if (event && 'type' in event && event.type === 'click') determinedSource = 'outside-click';
            }
        } // When flyout menu is closed, fire analytics event
        const navigationAnalyticsEvent = createAnalyticsEvent({
            source: 'sideNav',
            actionSubject: 'flyoutMenu',
            action: 'closed',
            attributes: {
                closeSource: determinedSource
            }
        });
        navigationAnalyticsEvent.fire('navigation');
        onClose?.();
        setIsOpen(false);
    }, [
        setIsOpen,
        onClose,
        createAnalyticsEvent
    ]); // Register handleClose in the ref to allow the FlyoutMenuItemTrigger to access it
    (0, $cozmU.useEffect)(()=>{
        onCloseRef.current = handleClose;
    }, [
        handleClose,
        onCloseRef
    ]);
    const titleId = (0, $1TBPy.useTitleId)();
    const computedMaxHeight = (0, $cozmU.useMemo)(()=>/**
   * The max height of the flyout menu needs to factor in the top nav and banner, as it will be layered
   * beneath them and would otherwise be clipped.
   *
   * We can remove these navigation variables once layering has been addressed holistically (e.g. using Top Layer).
   *
   * Not using the UNSAFE_MAIN_BLOCK_START_FOR_LEGACY_PAGES_ONLY variable from `@atlaskit/navigation-system`
   * to avoid a circular dependency, as that package imports this one for re-exporting components.
   */ `min(calc(100vh - ${$b8cce1e6327914dc$var$FLYOUT_MENU_VERTICAL_OFFSET_PX}px - var(--n_tNvM, 0px) - var(--n_bnrM, 0px)), ${maxHeight}px)`, [
        maxHeight
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $QodSn.PopupContent), {
        appearance: "UNSAFE_modal-below-sm",
        onClose: handleClose,
        placement: "right-start",
        // code that stops events. We _really_ want to close the flyout whenever
        // user user clicks outside the flyout content
        shouldUseCaptureOnOutsideClick: true,
        shouldFitViewport: true,
        testId: containerTestId,
        xcss: $b8cce1e6327914dc$var$flyoutMenuItemContentStyles.root,
        autoFocus: autoFocus,
        role: "dialog",
        titleId: (0, $ixfCV.fg)('navx-5180-flyout-dialog-aria-label') ? titleId : undefined,
        shouldDisableGpuAcceleration: true,
        shouldRenderToParent: true
    }, ({ update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b8cce1e6327914dc$var$UpdatePopperOnContentResize, {
            ref: forwardedRef,
            update: update
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1TBPy.TitleIdContextProvider), {
            value: titleId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: {
                [$b8cce1e6327914dc$var$maxHeightCssVar]: computedMaxHeight
            },
            "data-testid": containerTestId ? `${containerTestId}--container` : undefined,
            className: (0, $hekY6.default)([
                $b8cce1e6327914dc$var$flyoutMenuItemContentContainerStyles.container
            ])
        }, children))));
});
function $b8cce1e6327914dc$var$createResizeObserver(update) {
    return new ResizeObserver(update);
} /**
   * Will call the Popper.js `update()` method to recalculate positioning, when the flyout menu changes size.
   * This is the size of the scroll container, NOT the scroll content.
   *
   * We could potentially bake this into `@atlaskit/popup` or `@atlaskit/popper` but there are a few
   * reasons to keep it scoped to flyout menus for now:
   *
   * 1. It's easier to unwind
   * 2. We've only had bug reports for flyout menus
   * 3. Popup exposes the `update` function so consumers can already do this themselves if necessary
   * 4. Flyout menus are a lot more restricted to other popups, it might not make sense more generally
   */ 
const $b8cce1e6327914dc$var$UpdatePopperOnContentResize = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ update: update, children: children }, forwardedRef)=>{
    /**
   * Storing our `update` function in a ref so that we have a stable reference to it.
   * We need this because our `ResizeObserver` callback cannot be changed after creating it.
   */ const updateRef = (0, $cozmU.useRef)(update);
    (0, $cozmU.useEffect)(()=>{
        updateRef.current = update;
    }, [
        update
    ]); /**
                 * Stable function that calls the latest `update` function by calling it through the stable ref.
                 */ 
    const triggerUpdate = (0, $cozmU.useCallback)(()=>{
        updateRef.current?.();
    }, []);
    const [resizeObserver] = (0, $cozmU.useState)(()=>$b8cce1e6327914dc$var$createResizeObserver(triggerUpdate)); /**
                                                                                 * This is a callback ref that will update which `HTMLElement` we are observing,
                                                                                 * if or when the underlying `HTMLElement` changes or unmounts.
                                                                                 */ 
    const observeCallbackRef = (0, $cozmU.useCallback)((element)=>{
        /**
     * Unobserves all observed elements.
     * Allows us to cleanup without needing to store a reference to the previous element.
     */ resizeObserver.disconnect();
        if (!element) return;
        resizeObserver.observe(element);
    }, [
        resizeObserver
    ]); /**
                         * We need to memoize the ref otherwise `triggerUpdate` is repeatedly called.
                         *
                         * This stems from ResizeObserver firing once after calling `.observe()` even if there
                         * was no resize.
                         *
                         * Without memoizing the ref, the update causes a rerender, which causes the ref to
                         * get recreated, which triggers an update and so on in a loop.
                         */ 
    const ref = (0, $cozmU.useMemo)(()=>{
        return (0, $lmzCg.default)([
            forwardedRef,
            observeCallbackRef
        ]);
    }, [
        forwardedRef,
        observeCallbackRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: ref
    }, children);
});
module.exports["FlyoutMenuItemContent"] = $b8cce1e6327914dc$export$2ca9a13c57a8839a;

});

parcelRegister("QodSn", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1ZDKy = parcelRequire("1ZDKy");


var $5Tdig = parcelRequire("5Tdig");


var $ixfCV = parcelRequire("ixfCV");


var $cK21K = parcelRequire("cK21K");


var $lVRRo = parcelRequire("lVRRo");


var $bzkge = parcelRequire("bzkge");


var $dpUmv = parcelRequire("dpUmv");


var $iKSY4 = parcelRequire("iKSY4");

/* popup-content-top-layer.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $hekY6 = parcelRequire("hekY6");


var $dpsRj = parcelRequire("dpsRj");


var $aRDbl = parcelRequire("aRDbl");


var $2uGA5 = parcelRequire("2uGA5");

var $kVXS3 = parcelRequire("kVXS3");


var $juXYb = parcelRequire("juXYb");


var $97Yf0 = parcelRequire("97Yf0");


var $hPK4E = parcelRequire("hPK4E");


var $KvoGn = parcelRequire("KvoGn");


var $7tDc6 = parcelRequire("7tDc6");

const $0fb6df9fc708ed8d$var$overflowAutoStyles = null; // Top-layer positioning is handled by CSS Anchor Positioning, not inline styles.
const $0fb6df9fc708ed8d$var$EMPTY_STYLE = {}; /**
                                        * Top-layer implementation of the compositional PopupContent.
                                        *
                                        * Reads isOpen, id, triggerRef from the legacy compositional Popup context,
                                        * then renders via @atlaskit/top-layer's Popup compound.
                                        *
                                        * Gated behind the `platform-dst-top-layer` feature flag.
                                        */ 
function $0fb6df9fc708ed8d$export$a126ab411f00d484({ xcss: xcss, children: children, offset: offsetProp, onClose: onClose, testId: testId, placement: placement = 'auto', fallbackPlacements: _fallbackPlacements, popupComponent: PopupContainer, autoFocus: autoFocus = true, shouldFitContainer: shouldFitContainer, shouldFitViewport: shouldFitViewport, role: role, label: label, titleId: titleId, isOpen: isOpen, id: providedId, // ── No-op props ──
// top-layer: stacking managed by browser top layer. zIndex is a no-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
zIndex: _zIndex, // top-layer: always renders in top layer. shouldRenderToParent is a no-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
shouldRenderToParent: _shouldRenderToParent, // top-layer: CSS Anchor Positioning replaces Popper strategy. No-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
strategy: _strategy, // top-layer: viewport is the natural boundary. No-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
boundary: _boundary, // top-layer: viewport is the natural boundary. No-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
rootBoundary: _rootBoundary, // top-layer: native light dismiss replaces capture-phase click handler.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
shouldUseCaptureOnOutsideClick: _shouldUseCaptureOnOutsideClick, // top-layer: focus trapping is role-based. shouldDisableFocusLock is a no-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
shouldDisableFocusLock: _shouldDisableFocusLock, // top-layer: shouldFlip handled by CSS position-try fallbacks.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
shouldFlip: _shouldFlip, // top-layer: appearance is accepted but UNSAFE_modal-below-sm is not yet implemented.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
appearance: _appearance, // top-layer: GPU acceleration is not applicable.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
shouldDisableGpuAcceleration: _shouldDisableGpuAcceleration }) {
    /**
   * Escape hatch for consumer-chosen initial focus target.
   *
   * The legacy compositional `PopupContent` surfaced
   * `setInitialFocusRef` on the content children render prop with a
   * `Dispatch<SetStateAction<HTMLElement | null>>` signature so it
   * could be passed as a React `ref` callback. We keep the same shape
   * for API compatibility, but store the value in a ref rather than
   * component state. Flipping state on every open caused a needless
   * re-render and, more importantly, raced the initial-focus effect
   * below. The ref is read in the open-side effect to override the
   * role-based default focus chosen by `useInitialFocus` inside the
   * underlying `Popover`.
   */ const consumerInitialFocusRef = (0, $cozmU.useRef)(null);
    const setInitialFocusRef = (0, $cozmU.useCallback)((value)=>{
        consumerInitialFocusRef.current = typeof value === 'function' ? value(consumerInitialFocusRef.current) : value;
    }, []); // Placement conversion
    // Legacy `offset` is the popper `[along, away]` tuple; `fromLegacyPlacement`
    // folds it into the new `placement.offset` shape.
    const topLayerPlacement = (0, $cozmU.useMemo)(()=>(0, $aRDbl.fromLegacyPlacement)({
            legacy: placement,
            offset: offsetProp
        }), [
        placement,
        offsetProp
    ]); // ── onClose bridge ──
    const handleOnClose = (0, $cozmU.useCallback)(({ reason: reason })=>{
        if (!onClose) return;
        onClose((0, $2uGA5.createPopoverCloseEvent)({
            reason: reason
        }));
    }, [
        onClose
    ]); // ── Content render-prop bridge ──
    const contentProps = (0, $cozmU.useMemo)(()=>({
            isOpen: isOpen,
            update: (0, $dpsRj.default),
            onClose: onClose,
            setInitialFocusRef: setInitialFocusRef
        }), [
        isOpen,
        onClose,
        setInitialFocusRef
    ]); // ── Role mapping ──
    const roleProps = (0, $KvoGn.useRoleProps)({
        role: role,
        label: label,
        titleId: titleId
    });
    const popoverRef = (0, $cozmU.useRef)(null);
    const anchorRef = (0, $cozmU.useContext)((0, $7tDc6.TriggerRefObjectContext)); /**
                                                          * Override the role-based initial focus chosen by the underlying
                                                          * `Popover` (its internal `useInitialFocus`).
                                                          *
                                                          * React flushes child effects before parent effects, so by the time
                                                          * this effect runs the role-based default focus has already moved.
                                                          * We then apply the legacy `Popup` contract:
                                                          *
                                                          * 1. If the consumer wired `setInitialFocusRef`, focus that element
                                                          *    (escape hatch wins).
                                                          * 2. Otherwise, if `autoFocus={false}`, return focus to the trigger.
                                                          *    The `autoFocus` prop on `Popup` opts out of any initial-focus
                                                          *    movement, even for roles like `dialog`.
                                                          *
                                                          * When neither applies the role-based default from the underlying
                                                          * `Popover` stays in place.
                                                          */ 
    (0, $cozmU.useEffect)(()=>{
        if (!isOpen) {
            /**
       * Clear the consumer-supplied focus target on close so a
       * subsequent open does not silently inherit a stale ref from
       * the previous open cycle. The next open will re-collect a
       * target only if the content render prop re-wires
       * `setInitialFocusRef`.
       */ consumerInitialFocusRef.current = null;
            return;
        }
        const consumerTarget = consumerInitialFocusRef.current;
        if (consumerTarget && consumerTarget.isConnected) {
            consumerTarget.focus();
            return;
        }
        if (!autoFocus) {
            const trigger = anchorRef?.current ?? null;
            if (trigger && trigger.isConnected) trigger.focus();
        }
    }, [
        isOpen,
        autoFocus,
        anchorRef
    ]); // `isOpen` is included so the anchor positioning effect re-runs when
    // the Popover host element is unmounted/remounted across open cycles.
    (0, $97Yf0.useAnchorPosition)({
        anchorRef: anchorRef,
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isOpen: isOpen
    });
    (0, $hPK4E.useWidthFromAnchor)({
        mode: shouldFitContainer ? 'match-anchor' : 'none',
        popoverRef: popoverRef,
        anchorRef: anchorRef,
        isOpen: isOpen
    }); // Narrow to ForwardRefExoticComponent so JSX accepts the ref prop.
    // All popupComponent implementations use forwardRef per the PopupComponentProps contract.
    const Container = PopupContainer;
    return /*#__PURE__*/ $cozmU.createElement((0, $kVXS3.Popover), {
        ref: popoverRef,
        ...roleProps,
        isOpen: isOpen,
        animate: true,
        placement: topLayerPlacement,
        onClose: handleOnClose,
        testId: testId && `${testId}--content`
    }, Container ? /*#__PURE__*/ $cozmU.createElement(Container, {
        style: $0fb6df9fc708ed8d$var$EMPTY_STYLE,
        id: providedId,
        "data-placement": placement,
        "data-testid": testId,
        tabIndex: autoFocus ? -1 : undefined,
        xcss: xcss
    }, children(contentProps)) : /*#__PURE__*/ $cozmU.createElement((0, $juXYb.PopoverSurface), null, /*#__PURE__*/ $cozmU.createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $hekY6.default)([
            shouldFitViewport && "_1reo1wug _18m91wug",
            (0, $hekY6.default)([
                xcss
            ])
        ])
    }, children(contentProps))));
}



var $a9KY5 = parcelRequire("a9KY5");


var $2HzLc = parcelRequire("2HzLc");

const $802cf4f8c4db792b$var$defaultLayer = 400;
const $802cf4f8c4db792b$var$shouldDisableGpuAccelerationModifiers = [
    {
        name: 'computeStyles',
        options: {
            gpuAcceleration: false
        }
    }
];
const $802cf4f8c4db792b$export$2a2c7ba12d3231e3 = ({ xcss: xcss, appearance: inAppearance = 'default', children: children, boundary: boundary, offset: offset, strategy: strategy, onClose: onClose, testId: testId, rootBoundary: rootBoundary = 'viewport', shouldFlip: shouldFlip = true, placement: placement = 'auto', fallbackPlacements: fallbackPlacements, popupComponent: popupComponent, autoFocus: autoFocus = true, zIndex: zIndex = $802cf4f8c4db792b$var$defaultLayer, shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick = false, shouldIgnoreCloseEvent: shouldIgnoreCloseEvent, shouldRenderToParent: inShouldRenderToParent, shouldDisableFocusLock: shouldDisableFocusLock = false, shouldFitContainer: shouldFitContainer, shouldFitViewport: shouldFitViewport, shouldDisableGpuAcceleration: shouldDisableGpuAcceleration = false, role: role, label: label, titleId: titleId })=>{
    (0, $2HzLc.useEnsureIsInsidePopup)();
    const isOpen = (0, $cozmU.useContext)((0, $iKSY4.IsOpenContext));
    const id = (0, $cozmU.useContext)((0, $dpUmv.IdContext));
    const triggerRef = (0, $cozmU.useContext)((0, $a9KY5.TriggerRefContext));
    const { appearance: appearance, shouldRenderToParent: shouldRenderToParent } = (0, $bzkge.usePopupAppearance)({
        appearance: inAppearance,
        shouldRenderToParent: inShouldRenderToParent
    });
    const handleOpenLayerObserverCloseSignal = (0, $cozmU.useCallback)(()=>{
        onClose?.(null);
    }, [
        onClose
    ]);
    // On the top-layer path, the Popover primitive registers with the observer
    // directly, so we skip registration here to avoid double-counting.
    // Safe conditional hook: feature flags are resolved once at startup.
    if (!(0, $ixfCV.fg)('platform-dst-top-layer')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5Tdig.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: handleOpenLayerObserverCloseSignal,
        type: 'popup'
    });
    // Top-layer rendering path: native Popover API via @atlaskit/top-layer.
    // Mirrors the FF branch in the legacy `Popup` component (popup.tsx).
    if ((0, $ixfCV.fg)('platform-dst-top-layer')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0fb6df9fc708ed8d$export$a126ab411f00d484), {
        xcss: xcss,
        appearance: inAppearance,
        offset: offset,
        onClose: onClose,
        testId: testId,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        popupComponent: popupComponent,
        autoFocus: autoFocus,
        shouldFitContainer: shouldFitContainer,
        shouldFitViewport: shouldFitViewport,
        role: role,
        label: label,
        titleId: titleId,
        zIndex: zIndex,
        shouldRenderToParent: inShouldRenderToParent,
        strategy: strategy,
        boundary: boundary,
        rootBoundary: rootBoundary,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldDisableFocusLock: shouldDisableFocusLock,
        shouldFlip: shouldFlip,
        shouldDisableGpuAcceleration: shouldDisableGpuAcceleration,
        isOpen: isOpen,
        id: id
    }, children);
    if (!isOpen) return null;
    const popperWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1ZDKy.Layering), {
        isDisabled: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lVRRo.default), {
        xcss: xcss,
        appearance: appearance,
        content: children,
        isOpen: isOpen,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        boundary: boundary,
        rootBoundary: rootBoundary,
        shouldFlip: shouldFlip,
        offset: offset,
        popupComponent: popupComponent,
        id: id,
        testId: testId,
        onClose: onClose,
        autoFocus: autoFocus,
        shouldFitContainer: shouldFitContainer,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldIgnoreCloseEvent: shouldIgnoreCloseEvent,
        shouldRenderToParent: shouldRenderToParent,
        shouldDisableFocusLock: shouldDisableFocusLock,
        triggerRef: triggerRef,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport,
        modifiers: shouldDisableGpuAcceleration ? $802cf4f8c4db792b$var$shouldDisableGpuAccelerationModifiers : undefined,
        role: role,
        titleId: titleId
    }));
    if (shouldRenderToParent) return popperWrapper;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cK21K.default), {
        zIndex: zIndex
    }, popperWrapper);
};
module.exports["PopupContent"] = $802cf4f8c4db792b$export$2a2c7ba12d3231e3;

});

parcelRegister("9aB3o", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $lmzCg = parcelRequire("lmzCg");


var $aDSIl = parcelRequire("aDSIl");


var $cwlZp = parcelRequire("cwlZp");


var $KuePV = parcelRequire("KuePV");


var $1TBPy = parcelRequire("1TBPy");

const $e2116a94027fcdfd$var$elemAfterStyles = {
    root: "_18zr12x7 _1tz3r0mg"
};
const $e2116a94027fcdfd$export$9f59f399fe37b6ca = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, forwardedRef)=>{
    const $ = (0, $bDgLe.c)(17);
    const { children: children, elemBefore: elemBefore, onClick: onClick, isSelected: isSelected, interactionName: interactionName, testId: testId, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator } = t0;
    const isOpen = (0, $cozmU.useContext)((0, $1TBPy.IsOpenContext));
    const onCloseRef = (0, $cozmU.useContext)((0, $1TBPy.OnCloseContext));
    let t1;
    if ($[0] !== isOpen || $[1] !== onClick || $[2] !== onCloseRef) {
        t1 = (event, analyticsEvent)=>{
            if (isOpen && onCloseRef.current) onCloseRef.current(event, "outside-click");
            onClick?.(event, analyticsEvent);
        };
        $[0] = isOpen;
        $[1] = onClick;
        $[2] = onCloseRef;
        $[3] = t1;
    } else t1 = $[3];
    const handleClick = t1;
    let t2;
    if ($[4] !== children || $[5] !== dropIndicator || $[6] !== elemBefore || $[7] !== forwardedRef || $[8] !== handleClick || $[9] !== hasDragIndicator || $[10] !== interactionName || $[11] !== isContentTooltipDisabled || $[12] !== isDragging || $[13] !== isSelected || $[14] !== testId || $[15] !== visualContentRef) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $cwlZp.PopupTrigger), null, (t3)=>{
            const { ref: ref, "aria-controls": ariaControls, "aria-expanded": ariaExpanded, "aria-haspopup": ariaHasPopup } = t3;
            return /*#__PURE__*/ $cozmU.createElement((0, $KuePV.MenuItemBase), {
                testId: testId,
                ref: (0, $lmzCg.default)([
                    ref,
                    forwardedRef
                ]),
                visualContentRef: visualContentRef,
                elemBefore: elemBefore,
                elemAfter: /*#__PURE__*/ $cozmU.createElement("div", {
                    className: (0, $hekY6.default)([
                        $e2116a94027fcdfd$var$elemAfterStyles.root
                    ])
                }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                    label: "",
                    color: "currentColor",
                    size: "small"
                })),
                onClick: handleClick,
                ariaControls: ariaControls,
                ariaExpanded: ariaExpanded,
                ariaHasPopup: ariaHasPopup,
                interactionName: interactionName,
                isContentTooltipDisabled: isContentTooltipDisabled,
                isSelected: isSelected,
                isDragging: isDragging,
                hasDragIndicator: hasDragIndicator,
                dropIndicator: dropIndicator
            }, children);
        });
        $[4] = children;
        $[5] = dropIndicator;
        $[6] = elemBefore;
        $[7] = forwardedRef;
        $[8] = handleClick;
        $[9] = hasDragIndicator;
        $[10] = interactionName;
        $[11] = isContentTooltipDisabled;
        $[12] = isDragging;
        $[13] = isSelected;
        $[14] = testId;
        $[15] = visualContentRef;
        $[16] = t2;
    } else t2 = $[16];
    return t2;
} : ({ children: children, elemBefore: elemBefore, onClick: onClick, isSelected: isSelected, interactionName: interactionName, testId: testId, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    const isOpen = (0, $cozmU.useContext)((0, $1TBPy.IsOpenContext));
    const onCloseRef = (0, $cozmU.useContext)((0, $1TBPy.OnCloseContext));
    const handleClick = (0, $cozmU.useCallback)((event, analyticsEvent)=>{
        if (isOpen && onCloseRef.current) onCloseRef.current(event, 'outside-click');
        onClick?.(event, analyticsEvent);
    }, [
        isOpen,
        onCloseRef,
        onClick
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $cwlZp.PopupTrigger), null, ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup })=>/*#__PURE__*/ $cozmU.createElement((0, $KuePV.MenuItemBase), {
            testId: testId,
            ref: (0, $lmzCg.default)([
                ref,
                forwardedRef
            ]),
            visualContentRef: visualContentRef,
            elemBefore: elemBefore,
            elemAfter: /*#__PURE__*/ $cozmU.createElement("div", {
                className: (0, $hekY6.default)([
                    $e2116a94027fcdfd$var$elemAfterStyles.root
                ])
            }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                label: "",
                color: "currentColor",
                size: "small"
            })),
            onClick: handleClick,
            ariaControls: ariaControls,
            ariaExpanded: ariaExpanded,
            ariaHasPopup: ariaHasPopup,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            isSelected: isSelected,
            isDragging: isDragging,
            hasDragIndicator: hasDragIndicator,
            dropIndicator: dropIndicator
        }, children));
});
module.exports["FlyoutMenuItemTrigger"] = $e2116a94027fcdfd$export$9f59f399fe37b6ca;

});

parcelRegister("cwlZp", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $ixfCV = parcelRequire("ixfCV");


var $kN1yU = parcelRequire("kN1yU");


var $dfu3d = parcelRequire("dfu3d");


var $dpUmv = parcelRequire("dpUmv");


var $iKSY4 = parcelRequire("iKSY4");


var $dY7Kg = parcelRequire("dY7Kg");


var $EZmp0 = parcelRequire("EZmp0");


var $7tDc6 = parcelRequire("7tDc6");


var $2HzLc = parcelRequire("2HzLc");

const $aa081c2f921263f0$export$95d4acdbab2fc6ef = ({ children: children })=>{
    (0, $2HzLc.useEnsureIsInsidePopup)();
    const id = (0, $cozmU.useContext)((0, $dpUmv.IdContext));
    const setTriggerRef = (0, $cozmU.useContext)((0, $EZmp0.SetTriggerRefContext));
    const triggerRefObject = (0, $cozmU.useContext)((0, $7tDc6.TriggerRefObjectContext));
    const isOpen = (0, $cozmU.useContext)((0, $iKSY4.IsOpenContext));
    const getMergedTriggerRef = (0, $dfu3d.useGetMemoizedMergedTriggerRefNew)();
    const role = (0, $cozmU.useContext)((0, $dY7Kg.RoleContext));
    // Stable ref callback — avoids creating a new function instance on every render,
    // which would cause React to detach and reattach the ref unnecessarily.
    // triggerRefObject is a MutableRefObject (from useRef) so its identity never changes,
    // meaning this callback is effectively created once per mount.
    const triggerRef = (0, $cozmU.useCallback)((node)=>{
        triggerRefObject.current = node;
    }, [
        triggerRefObject
    ]);
    const ariaHasPopup = role === 'dialog' ? 'dialog' : true;
    // When the top-layer flag is on, bypass Popper's <Reference> entirely.
    // We only need to set triggerRefObject.current — no Popper ref merging needed.
    if ((0, $ixfCV.fg)('platform-dst-top-layer')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children({
        ref: triggerRef,
        'aria-controls': id,
        'aria-expanded': isOpen,
        'aria-haspopup': ariaHasPopup
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kN1yU.Reference), null, ({ ref: ref })=>children({
            ref: getMergedTriggerRef(ref, setTriggerRef),
            'aria-controls': id,
            'aria-expanded': isOpen,
            'aria-haspopup': ariaHasPopup
        }));
};
module.exports["PopupTrigger"] = $aa081c2f921263f0$export$95d4acdbab2fc6ef;

});

parcelRegister("igMdc", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6ZNK7 = parcelRequire("6ZNK7");











var $iY6Oi = parcelRequire("iY6Oi");


var $pl8ng = parcelRequire("pl8ng");

function $bfc807f883e56bab$export$9d7e63760538f47f(item) {
    if (!item || item.type === 'custom' && item.dragPreviewContent) // If the custom item has a drag preview content, we should assume it contains the icon already
    return undefined;
    return item.elemBefore;
}
function $bfc807f883e56bab$export$d5d05b25e1604a8f(item, name) {
    if (!item) {
        if (name) return name;
        return undefined;
    }
    if (item.type === 'custom' && item.dragPreviewContent) // Custom items may return their drag preview content as a React node
    return item.dragPreviewContent;
    // If not custom or drag preview content not present, use the label
    return item.labelElem ?? item.label;
}


const $4201c0da7c132263$export$4696d1da23170d9a = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useItemDragAndDrop(props) {
    const $ = (0, $bDgLe.c)(62);
    const { data: data, item: item, id: id, isExpandable: isExpandable, isItemDraggable: isItemDraggable, isItemDroppable: isItemDroppable, isExpandOrFlyoutOpen: isExpandOrFlyoutOpen, onExpandFlyoutToggle: onExpandFlyoutToggle, isDragAndDropEnabled: isDragAndDropEnabled, group: group, isItemDataInGroup: isItemDataInGroup, isItemData: isItemData, getItemData: getItemData } = props;
    let t0;
    if ($[0] !== data || $[1] !== isDragAndDropEnabled || $[2] !== isItemDraggable) {
        t0 = isItemDraggable?.(data) ?? !!isDragAndDropEnabled;
        $[0] = data;
        $[1] = isDragAndDropEnabled;
        $[2] = isItemDraggable;
        $[3] = t0;
    } else t0 = $[3];
    const itemIsDraggable = t0;
    let t1;
    if ($[4] !== data || $[5] !== isDragAndDropEnabled || $[6] !== isItemDroppable) {
        t1 = isItemDroppable?.(data) ?? !!isDragAndDropEnabled;
        $[4] = data;
        $[5] = isDragAndDropEnabled;
        $[6] = isItemDroppable;
        $[7] = t1;
    } else t1 = $[7];
    const itemIsDroppable = t1;
    let t2;
    if ($[8] !== data || $[9] !== getItemData || $[10] !== group || $[11] !== id) {
        t2 = ()=>getItemData({
                ...data,
                menuItemId: id,
                group: group
            });
        $[8] = data;
        $[9] = getItemData;
        $[10] = group;
        $[11] = id;
        $[12] = t2;
    } else t2 = $[12];
    const getInitialData = t2;
    let t3;
    if ($[13] !== data?.label || $[14] !== item) {
        t3 = ()=>({
                elemBefore: (0, $bfc807f883e56bab$export$9d7e63760538f47f)(item),
                content: (0, $bfc807f883e56bab$export$d5d05b25e1604a8f)(item, data?.label)
            });
        $[13] = data?.label;
        $[14] = item;
        $[15] = t3;
    } else t3 = $[15];
    data?.label;
    const getDragPreviewPieces = t3;
    let t4;
    if ($[16] !== data || $[17] !== isDragAndDropEnabled || $[18] !== isItemDraggable) {
        t4 = ()=>isItemDraggable ? isItemDraggable(data) : !!isDragAndDropEnabled;
        $[16] = data;
        $[17] = isDragAndDropEnabled;
        $[18] = isItemDraggable;
        $[19] = t4;
    } else t4 = $[19];
    const canDrag = t4;
    let t5;
    if ($[20] !== data || $[21] !== getItemData || $[22] !== id) {
        t5 = (args)=>{
            const { source: source } = args;
            return getItemData({
                ...data,
                menuItemId: id,
                group: source?.data?.group
            });
        };
        $[20] = data;
        $[21] = getItemData;
        $[22] = id;
        $[23] = t5;
    } else t5 = $[23];
    const getData = t5;
    let t6;
    if ($[24] !== itemIsDraggable) {
        t6 = ()=>({
                "reorder-before": itemIsDraggable ? "available" : undefined,
                "reorder-after": "available"
            });
        $[24] = itemIsDraggable;
        $[25] = t6;
    } else t6 = $[25];
    const getOperations = t6;
    let t7;
    if ($[26] !== group || $[27] !== id || $[28] !== isItemData || $[29] !== isItemDataInGroup) {
        t7 = (args_0)=>{
            const { source: source_0 } = args_0;
            return isItemData(source_0.data) && source_0.data.menuItemId !== id && isItemDataInGroup(source_0.data, group);
        };
        $[26] = group;
        $[27] = id;
        $[28] = isItemData;
        $[29] = isItemDataInGroup;
        $[30] = t7;
    } else t7 = $[30];
    const canDrop = t7;
    let t8;
    bb0: {
        if (isDragAndDropEnabled && itemIsDraggable) {
            let t9;
            if ($[31] !== canDrag || $[32] !== getDragPreviewPieces || $[33] !== getInitialData) {
                t9 = {
                    canDrag: canDrag,
                    getInitialData: getInitialData,
                    getDragPreviewPieces: getDragPreviewPieces
                };
                $[31] = canDrag;
                $[32] = getDragPreviewPieces;
                $[33] = getInitialData;
                $[34] = t9;
            } else t9 = $[34];
            t8 = t9;
            break bb0;
        }
        t8 = undefined;
    }
    const draggable = t8;
    let t9;
    bb1: {
        if (isDragAndDropEnabled && itemIsDroppable) {
            let t10;
            if ($[35] !== canDrop || $[36] !== getData || $[37] !== getOperations) {
                t10 = {
                    canDrop: canDrop,
                    getData: getData,
                    getOperations: getOperations
                };
                $[35] = canDrop;
                $[36] = getData;
                $[37] = getOperations;
                $[38] = t10;
            } else t10 = $[38];
            t9 = t10;
            break bb1;
        }
        t9 = undefined;
    }
    const dropTarget = t9;
    let t10;
    if ($[39] !== draggable || $[40] !== dropTarget) {
        t10 = {
            draggable: draggable,
            dropTarget: dropTarget
        };
        $[39] = draggable;
        $[40] = dropTarget;
        $[41] = t10;
    } else t10 = $[41];
    const memoizedHookProps = t10;
    const { draggableAnchorRef: draggableAnchorRef, draggableButtonRef: draggableButtonRef, state: dragState, dragPreview: dragPreview, dropTargetRef: dropTargetRef, dropIndicator: dropIndicator } = (0, $iY6Oi.useMenuItemDragAndDrop)(memoizedHookProps);
    const registry = (0, $pl8ng.useElementRegistry)();
    const registrationRef = (0, $cozmU.useRef)(null);
    let t11;
    if ($[42] !== draggableAnchorRef || $[43] !== draggableButtonRef || $[44] !== id || $[45] !== registry) {
        t11 = (element)=>{
            if (!element) {
                registrationRef.current?.();
                registrationRef.current = null;
                draggableAnchorRef.current = null;
                draggableButtonRef.current = null;
                return;
            }
            if (element instanceof HTMLAnchorElement) draggableAnchorRef.current = element;
            else draggableButtonRef.current = element;
            if (registrationRef.current) registrationRef.current();
            registrationRef.current = registry.registerL1Item({
                id: id,
                element: element
            });
        };
        $[42] = draggableAnchorRef;
        $[43] = draggableButtonRef;
        $[44] = id;
        $[45] = registry;
        $[46] = t11;
    } else t11 = $[46];
    const draggableRef = t11;
    const isDragging = !!itemIsDraggable && dragState.type === "dragging";
    const expandableClosedForDrag = (0, $cozmU.useRef)(false);
    let t12;
    let t13;
    if ($[47] !== isDragging || $[48] !== isExpandOrFlyoutOpen || $[49] !== isExpandable || $[50] !== itemIsDraggable || $[51] !== onExpandFlyoutToggle) {
        t12 = ()=>{
            if (!isExpandable || !itemIsDraggable) return;
            if (isDragging && isExpandOrFlyoutOpen) {
                onExpandFlyoutToggle(false);
                expandableClosedForDrag.current = true;
            } else if (!isDragging && expandableClosedForDrag.current) {
                onExpandFlyoutToggle(true);
                expandableClosedForDrag.current = false;
            }
        };
        t13 = [
            isDragging,
            isExpandable,
            isExpandOrFlyoutOpen,
            itemIsDraggable,
            expandableClosedForDrag,
            onExpandFlyoutToggle
        ];
        $[47] = isDragging;
        $[48] = isExpandOrFlyoutOpen;
        $[49] = isExpandable;
        $[50] = itemIsDraggable;
        $[51] = onExpandFlyoutToggle;
        $[52] = t12;
        $[53] = t13;
    } else {
        t12 = $[52];
        t13 = $[53];
    }
    (0, $cozmU.useLayoutEffect)(t12, t13);
    const t14 = itemIsDraggable ? draggableRef : undefined;
    const t15 = itemIsDroppable ? dropTargetRef : undefined;
    const t16 = itemIsDroppable ? dropIndicator : undefined;
    const t17 = itemIsDraggable ? dragPreview : null;
    let t18;
    if ($[54] !== isDragging || $[55] !== itemIsDraggable || $[56] !== itemIsDroppable || $[57] !== t14 || $[58] !== t15 || $[59] !== t16 || $[60] !== t17) {
        t18 = {
            draggableRef: t14,
            isItemDraggable: itemIsDraggable,
            isItemDroppable: itemIsDroppable,
            isDragging: isDragging,
            dropTargetRef: t15,
            dropIndicator: t16,
            maybeDragPreview: t17
        };
        $[54] = isDragging;
        $[55] = itemIsDraggable;
        $[56] = itemIsDroppable;
        $[57] = t14;
        $[58] = t15;
        $[59] = t16;
        $[60] = t17;
        $[61] = t18;
    } else t18 = $[61];
    return t18;
} : function useItemDragAndDrop(props) {
    const { data: data, item: item, id: id, isExpandable: isExpandable, isItemDraggable: isItemDraggable, isItemDroppable: isItemDroppable, isExpandOrFlyoutOpen: isExpandOrFlyoutOpen, onExpandFlyoutToggle: onExpandFlyoutToggle, isDragAndDropEnabled: isDragAndDropEnabled, group: group, isItemDataInGroup: isItemDataInGroup, isItemData: isItemData, getItemData: getItemData } = props;
    const itemIsDraggable = isItemDraggable?.(data) ?? !!isDragAndDropEnabled;
    const itemIsDroppable = isItemDroppable?.(data) ?? !!isDragAndDropEnabled;
    const getInitialData = (0, $cozmU.useCallback)(()=>getItemData({
            ...data,
            menuItemId: id,
            group: group
        }), [
        data,
        getItemData,
        group,
        id
    ]);
    const getDragPreviewPieces = (0, $cozmU.useCallback)(()=>({
            elemBefore: (0, $bfc807f883e56bab$export$9d7e63760538f47f)(item),
            content: (0, $bfc807f883e56bab$export$d5d05b25e1604a8f)(item, data?.label)
        }), [
        data?.label,
        item
    ]);
    const canDrag = (0, $cozmU.useCallback)(()=>isItemDraggable ? isItemDraggable(data) : !!isDragAndDropEnabled, [
        data,
        isDragAndDropEnabled,
        isItemDraggable
    ]);
    const getData = (0, $cozmU.useCallback)((args)=>{
        const { source: source } = args;
        return getItemData({
            ...data,
            menuItemId: id,
            group: source?.data?.group
        });
    }, [
        data,
        getItemData,
        id
    ]);
    const getOperations = (0, $cozmU.useCallback)(()=>({
            'reorder-before': itemIsDraggable ? 'available' : undefined,
            'reorder-after': 'available'
        }), [
        itemIsDraggable
    ]);
    const canDrop = (0, $cozmU.useCallback)((args_0)=>{
        const { source: source_0 } = args_0;
        return isItemData(source_0.data) && source_0.data.menuItemId !== id && isItemDataInGroup(source_0.data, group);
    }, [
        group,
        id,
        isItemData,
        isItemDataInGroup
    ]);
    const draggable = (0, $cozmU.useMemo)(()=>{
        if (isDragAndDropEnabled && itemIsDraggable) return {
            canDrag: canDrag,
            getInitialData: getInitialData,
            getDragPreviewPieces: getDragPreviewPieces
        };
    }, [
        canDrag,
        getInitialData,
        getDragPreviewPieces,
        isDragAndDropEnabled,
        itemIsDraggable
    ]);
    const dropTarget = (0, $cozmU.useMemo)(()=>{
        if (isDragAndDropEnabled && itemIsDroppable) return {
            canDrop: canDrop,
            getData: getData,
            getOperations: getOperations
        };
    }, [
        canDrop,
        getData,
        getOperations,
        isDragAndDropEnabled,
        itemIsDroppable
    ]);
    const memoizedHookProps = (0, $cozmU.useMemo)(()=>({
            draggable: draggable,
            dropTarget: dropTarget
        }), [
        draggable,
        dropTarget
    ]);
    const { draggableAnchorRef: draggableAnchorRef, draggableButtonRef: draggableButtonRef, state: dragState, dragPreview: dragPreview, dropTargetRef: dropTargetRef, dropIndicator: dropIndicator } = (0, $iY6Oi.useMenuItemDragAndDrop)(memoizedHookProps);
    const registry = (0, $pl8ng.useElementRegistry)();
    const registrationRef = (0, $cozmU.useRef)(null);
    const draggableRef = (0, $cozmU.useCallback)((element)=>{
        if (!element) {
            registrationRef.current?.();
            registrationRef.current = null;
            draggableAnchorRef.current = null;
            draggableButtonRef.current = null;
            return;
        }
        if (element instanceof HTMLAnchorElement) draggableAnchorRef.current = element;
        else draggableButtonRef.current = element;
        if (registrationRef.current) registrationRef.current();
        registrationRef.current = registry.registerL1Item({
            id: id,
            element: element
        });
    }, [
        id,
        registry,
        draggableAnchorRef,
        draggableButtonRef,
        registrationRef
    ]);
    const isDragging = !!itemIsDraggable && dragState.type === 'dragging';
    const expandableClosedForDrag = (0, $cozmU.useRef)(false);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!isExpandable || !itemIsDraggable) return;
        if (isDragging && isExpandOrFlyoutOpen) {
            onExpandFlyoutToggle(false);
            expandableClosedForDrag.current = true;
        } else if (!isDragging && expandableClosedForDrag.current) {
            onExpandFlyoutToggle(true);
            expandableClosedForDrag.current = false;
        }
    }, [
        isDragging,
        isExpandable,
        isExpandOrFlyoutOpen,
        itemIsDraggable,
        expandableClosedForDrag,
        onExpandFlyoutToggle
    ]);
    return (0, $cozmU.useMemo)(()=>({
            draggableRef: itemIsDraggable ? draggableRef : undefined,
            isItemDraggable: itemIsDraggable,
            isItemDroppable: itemIsDroppable,
            isDragging: isDragging,
            dropTargetRef: itemIsDroppable ? dropTargetRef : undefined,
            dropIndicator: itemIsDroppable ? dropIndicator : undefined,
            maybeDragPreview: itemIsDraggable ? dragPreview : null
        }), [
        draggableRef,
        dragPreview,
        dropIndicator,
        dropTargetRef,
        isDragging,
        itemIsDraggable,
        itemIsDroppable
    ]);
};


const $d62f75864882af78$export$f8cda0f87a8e0691 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useL1ItemDragAndDrop(t0) {
    const $ = (0, $bDgLe.c)(29);
    const { item: item, id: id, isExpandable: isExpandable, isExpandOrFlyoutOpen: isExpandOrFlyoutOpen, onExpandFlyoutToggle: onExpandFlyoutToggle, peek: peek, l1DragAndDropEnabled: l1DragAndDropEnabled, group: group } = t0;
    const t1 = item.isHideable !== false;
    const t2 = item.isReorderable !== false;
    let t3;
    if ($[0] !== group || $[1] !== id || $[2] !== item.label || $[3] !== t1 || $[4] !== t2) {
        t3 = (0, $6ZNK7.createL1ItemData)({
            menuItemId: id,
            group: group,
            isHidden: false,
            isHideable: t1,
            label: item.label,
            isReorderable: t2
        });
        $[0] = group;
        $[1] = id;
        $[2] = item.label;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    const data = t3;
    let t4;
    if ($[6] !== item.isDraggable || $[7] !== item.isHideable || $[8] !== item.isReorderable || $[9] !== item.type || $[10] !== l1DragAndDropEnabled || $[11] !== peek) {
        t4 = ()=>!!l1DragAndDropEnabled && !peek && (item.isHideable !== false || item.isReorderable !== false) && (item.type !== "custom" || !!item.isDraggable);
        $[6] = item.isDraggable;
        $[7] = item.isHideable;
        $[8] = item.isReorderable;
        $[9] = item.type;
        $[10] = l1DragAndDropEnabled;
        $[11] = peek;
        $[12] = t4;
    } else t4 = $[12];
    const isItemDraggable = t4;
    let t5;
    if ($[13] !== item.isDraggable || $[14] !== item.type || $[15] !== l1DragAndDropEnabled || $[16] !== peek) {
        t5 = ()=>!!l1DragAndDropEnabled && !peek && (item.type !== "custom" || !!item.isDraggable);
        $[13] = item.isDraggable;
        $[14] = item.type;
        $[15] = l1DragAndDropEnabled;
        $[16] = peek;
        $[17] = t5;
    } else t5 = $[17];
    const isItemDroppable = t5;
    let t6;
    if ($[18] !== data || $[19] !== group || $[20] !== id || $[21] !== isExpandOrFlyoutOpen || $[22] !== isExpandable || $[23] !== isItemDraggable || $[24] !== isItemDroppable || $[25] !== item || $[26] !== l1DragAndDropEnabled || $[27] !== onExpandFlyoutToggle) {
        t6 = {
            data: data,
            getItemData: (0, $6ZNK7.getL1ItemData),
            group: group,
            id: id,
            item: item,
            isDragAndDropEnabled: l1DragAndDropEnabled,
            isExpandable: isExpandable,
            isExpandOrFlyoutOpen: isExpandOrFlyoutOpen,
            isItemData: (0, $6ZNK7.isL1ItemData),
            isItemDataInGroup: (0, $6ZNK7.isL1ItemDataInGroup),
            isItemDraggable: isItemDraggable,
            isItemDroppable: isItemDroppable,
            onExpandFlyoutToggle: onExpandFlyoutToggle
        };
        $[18] = data;
        $[19] = group;
        $[20] = id;
        $[21] = isExpandOrFlyoutOpen;
        $[22] = isExpandable;
        $[23] = isItemDraggable;
        $[24] = isItemDroppable;
        $[25] = item;
        $[26] = l1DragAndDropEnabled;
        $[27] = onExpandFlyoutToggle;
        $[28] = t6;
    } else t6 = $[28];
    return (0, $4201c0da7c132263$export$4696d1da23170d9a)(t6);
} : function useL1ItemDragAndDrop({ item: item, id: id, isExpandable: isExpandable, isExpandOrFlyoutOpen: isExpandOrFlyoutOpen, onExpandFlyoutToggle: onExpandFlyoutToggle, peek: peek, l1DragAndDropEnabled: l1DragAndDropEnabled, group: group }) {
    const data = (0, $cozmU.useMemo)(()=>(0, $6ZNK7.createL1ItemData)({
            menuItemId: id,
            group: group,
            isHidden: false,
            isHideable: item.isHideable !== false,
            label: item.label,
            isReorderable: item.isReorderable !== false
        }), [
        group,
        id,
        item.isHideable,
        item.isReorderable,
        item.label
    ]);
    const isItemDraggable = (0, $cozmU.useCallback)(()=>{
        return !!l1DragAndDropEnabled && !peek && (item.isHideable !== false || item.isReorderable !== false) && (item.type !== 'custom' || !!item.isDraggable);
    }, [
        item.isDraggable,
        item.isHideable,
        item.isReorderable,
        item.type,
        l1DragAndDropEnabled,
        peek
    ]);
    const isItemDroppable = (0, $cozmU.useCallback)(()=>!!l1DragAndDropEnabled && !peek && (item.type !== 'custom' || !!item.isDraggable), [
        item.isDraggable,
        item.type,
        l1DragAndDropEnabled,
        peek
    ]);
    return (0, $4201c0da7c132263$export$4696d1da23170d9a)({
        data: data,
        getItemData: (0, $6ZNK7.getL1ItemData),
        group: group,
        id: id,
        item: item,
        isDragAndDropEnabled: l1DragAndDropEnabled,
        isExpandable: isExpandable,
        isExpandOrFlyoutOpen: isExpandOrFlyoutOpen,
        isItemData: (0, $6ZNK7.isL1ItemData),
        isItemDataInGroup: (0, $6ZNK7.isL1ItemDataInGroup),
        isItemDraggable: isItemDraggable,
        isItemDroppable: isItemDroppable,
        onExpandFlyoutToggle: onExpandFlyoutToggle
    });
};
module.exports["useL1ItemDragAndDrop"] = $d62f75864882af78$export$f8cda0f87a8e0691;

});

parcelRegister("iY6Oi", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9kbTQ = parcelRequire("9kbTQ");


var $iSrRp = parcelRequire("iSrRp");


var $fYWmN = parcelRequire("fYWmN");


var $cDMxg = parcelRequire("cDMxg");











var $hekY6 = parcelRequire("hekY6");


var $ixfCV = parcelRequire("ixfCV");


var $6q25I = parcelRequire("6q25I");


var $KuePV = parcelRequire("KuePV");


var $3TF4i = parcelRequire("3TF4i");

function $01f2684e06d1e32f$var$isSafari() {
    if (typeof window === 'undefined') return false;
    const { userAgent: userAgent } = navigator;
    return userAgent.includes('AppleWebKit') && !userAgent.includes('Chrome');
}
const $01f2684e06d1e32f$var$dragPreviewStyles = {
    root: "_2rko12b0 _189ee4h9 _1h6d1l7x _1dqonqa1 _bfhkvuon _y4ti1b66 _p12fgx0z",
    rootT26Shape: "_2rko1qi0",
    safariFix: "_1ul9uuw1"
}; /**
    * A drag preview for sidebar menu items.
    *
    * The limited API corresponds with the limited amount of information we
    * want to show in drag previews. Only essential information is shown.
    *
    * If no `elemBefore` is provided, then the `elemBefore` will automatically collapse.
    * There is no need to pass in `COLLAPSE_ELEM_BEFORE`. We do this as there is no
    * need to maintain vertical side navigation vertical alignment in the drag preview.
    *
    * Please ensure the drag preview is pushed away from the users pointer
    * (with `pointerOutsideOfPreview()` from Pragmatic drag and drop) by our
    * standard amount (`{x: token('space.200'), y: token('space.100')`)
    */ 
const $01f2684e06d1e32f$export$905ab40ac2179daa = (0, $gtMdU.isReactCompilerActivePlatform)() ? function DragPreview(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { elemBefore: elemBefore, children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            $01f2684e06d1e32f$var$dragPreviewStyles.root,
            (0, $ixfCV.fg)("platform-dst-shape-theme-default") && $01f2684e06d1e32f$var$dragPreviewStyles.rootT26Shape,
            $01f2684e06d1e32f$var$isSafari() && $01f2684e06d1e32f$var$dragPreviewStyles.safariFix
        ]);
        $[0] = t1;
    } else t1 = $[0];
    const t2 = elemBefore ?? (0, $3TF4i.COLLAPSE_ELEM_BEFORE);
    let t3;
    if ($[1] !== children || $[2] !== t2) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $6q25I.ExpandableMenuItemLevelContext).Provider, {
            value: 0
        }, /*#__PURE__*/ $cozmU.createElement("div", {
            className: t1
        }, /*#__PURE__*/ $cozmU.createElement((0, $KuePV.MenuItemBase), {
            elemBefore: t2
        }, children)));
        $[1] = children;
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    return t3;
} : function DragPreview({ elemBefore: elemBefore, children: children }) {
    return(// Resetting the expandable menu items to 0.
    // This is to prevent our hidden element from pushing
    // the drag preview further away from the users pointer
    /*#__PURE__*/ $cozmU.createElement((0, $6q25I.ExpandableMenuItemLevelContext).Provider, {
        value: 0
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $01f2684e06d1e32f$var$dragPreviewStyles.root,
            (0, $ixfCV.fg)('platform-dst-shape-theme-default') && $01f2684e06d1e32f$var$dragPreviewStyles.rootT26Shape,
            $01f2684e06d1e32f$var$isSafari() && $01f2684e06d1e32f$var$dragPreviewStyles.safariFix
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $KuePV.MenuItemBase), {
        elemBefore: elemBefore ?? (0, $3TF4i.COLLAPSE_ELEM_BEFORE)
    }, children))));
};



var $8aG6j = parcelRequire("8aG6j");







parcelRequire("cozmU");


var $9AuSX = parcelRequire("9AuSX");


var $vZEJe = parcelRequire("vZEJe");

const $c6b0b810afe42c2b$var$axisLookup = {
    vertical: {
        start: 'top',
        end: 'bottom'
    },
    horizontal: {
        start: 'left',
        end: 'right'
    }
};
const $c6b0b810afe42c2b$export$62ed72bc21f6b8a6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function DropIndicator(t0) {
    const $ = (0, $bDgLe.c)(12);
    const { instruction: instruction, lineGap: lineGap, lineType: lineType } = t0;
    const appearance = instruction.blocked ? "warning" : "default";
    const axis = $c6b0b810afe42c2b$var$axisLookup[instruction.axis];
    if (instruction.operation === "combine") {
        let t1;
        if ($[0] !== appearance) {
            t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9AuSX.DropIndicator), {
                appearance: appearance
            });
            $[0] = appearance;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    if (instruction.operation === "reorder-before") {
        let t1;
        if ($[2] !== appearance || $[3] !== axis.start || $[4] !== lineGap || $[5] !== lineType) {
            t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $vZEJe.DropIndicator), {
                edge: axis.start,
                appearance: appearance,
                gap: lineGap,
                type: lineType
            });
            $[2] = appearance;
            $[3] = axis.start;
            $[4] = lineGap;
            $[5] = lineType;
            $[6] = t1;
        } else t1 = $[6];
        return t1;
    }
    if (instruction.operation === "reorder-after") {
        let t1;
        if ($[7] !== appearance || $[8] !== axis.end || $[9] !== lineGap || $[10] !== lineType) {
            t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $vZEJe.DropIndicator), {
                edge: axis.end,
                appearance: appearance,
                gap: lineGap,
                type: lineType
            });
            $[7] = appearance;
            $[8] = axis.end;
            $[9] = lineGap;
            $[10] = lineType;
            $[11] = t1;
        } else t1 = $[11];
        return t1;
    }
    return null;
} : function DropIndicator({ instruction: instruction, lineGap: lineGap, lineType: lineType }) {
    const appearance = instruction.blocked ? 'warning' : 'default';
    const axis = $c6b0b810afe42c2b$var$axisLookup[instruction.axis];
    if (instruction.operation === 'combine') return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9AuSX.DropIndicator), {
        appearance: appearance
    });
    if (instruction.operation === 'reorder-before') return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $vZEJe.DropIndicator), {
        edge: axis.start,
        appearance: appearance,
        gap: lineGap,
        type: lineType
    });
    if (instruction.operation === 'reorder-after') return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $vZEJe.DropIndicator), {
        edge: axis.end,
        appearance: appearance,
        gap: lineGap,
        type: lineType
    });
    return null;
};



var $htuV6 = parcelRequire("htuV6");

const $238e7fcc46931eb1$var$idle = {
    type: 'idle'
};
const $238e7fcc46931eb1$export$fe281fdb09fbf0c8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useMenuItemDragAndDrop(t0) {
    const $ = (0, $bDgLe.c)(23);
    const { draggable: draggableArgs, dropTarget: dropTargetArgs } = t0;
    const draggableAnchorRef = (0, $cozmU.useRef)(null);
    const draggableButtonRef = (0, $cozmU.useRef)(null);
    const dropTargetRef = (0, $cozmU.useRef)(null);
    const [internalState, setInternalState] = (0, $cozmU.useState)($238e7fcc46931eb1$var$idle);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>draggableAnchorRef.current ?? draggableButtonRef.current ?? null;
        $[0] = t1;
    } else t1 = $[0];
    const getDraggableElement = t1;
    let t2;
    let t3;
    if ($[1] !== draggableArgs) {
        t2 = ()=>{
            if (!draggableArgs) return;
            const element = getDraggableElement();
            if (!element) return;
            return (0, $iSrRp.draggable)({
                element: element,
                getInitialData: draggableArgs.getInitialData,
                canDrag: draggableArgs.canDrag,
                onGenerateDragPreview (t4) {
                    const { nativeSetDragImage: nativeSetDragImage, source: source, location: location } = t4;
                    (0, $cDMxg.setCustomNativeDragPreview)({
                        nativeSetDragImage: nativeSetDragImage,
                        getOffset: (0, $fYWmN.pointerOutsideOfPreview)({
                            x: "var(--ds-space-200, 16px)",
                            y: "var(--ds-space-100, 8px)"
                        }),
                        render (t5) {
                            const { container: container } = t5;
                            const args = {
                                dragHandle: source.dragHandle,
                                element: source.element,
                                input: location.current.input
                            };
                            setInternalState({
                                type: "preview",
                                container: container,
                                ui: draggableArgs.getDragPreviewPieces(args)
                            });
                        }
                    });
                },
                onDragStart () {
                    setInternalState({
                        type: "dragging"
                    });
                },
                onDrop () {
                    setInternalState($238e7fcc46931eb1$var$idle);
                }
            });
        };
        t3 = [
            draggableArgs,
            getDraggableElement
        ];
        $[1] = draggableArgs;
        $[2] = t2;
        $[3] = t3;
    } else {
        t2 = $[2];
        t3 = $[3];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    let t5;
    if ($[4] !== dropTargetArgs) {
        t4 = ()=>{
            if (!dropTargetArgs) return;
            const draggableElement = getDraggableElement();
            const dropTarget = dropTargetRef.current;
            if (!dropTarget) return;
            return (0, $iSrRp.dropTargetForElements)({
                element: dropTarget,
                canDrop: (args_0)=>{
                    if (args_0.source.element === draggableElement) return false;
                    if (dropTargetArgs.canDrop) return dropTargetArgs.canDrop(args_0);
                    return true;
                },
                getIsSticky: $238e7fcc46931eb1$var$_temp,
                getData (args_1) {
                    const data = dropTargetArgs.getData?.(args_1) ?? {};
                    const operations = dropTargetArgs.getOperations(args_1);
                    return (0, $htuV6.attachInstruction)(data, {
                        input: args_1.input,
                        element: args_1.element,
                        operations: operations
                    });
                },
                onDragStart (t6) {
                    const { self: self } = t6;
                    const instruction = (0, $htuV6.extractInstruction)(self.data);
                    setInternalState({
                        type: "is-over",
                        instruction: instruction
                    });
                },
                onDrag (t7) {
                    const { self: self_0 } = t7;
                    const instruction_0 = (0, $htuV6.extractInstruction)(self_0.data);
                    setInternalState((current)=>{
                        if (current.type === "is-over" && instruction_0?.operation === current.instruction?.operation && instruction_0?.blocked === current.instruction?.blocked) return current;
                        return {
                            type: "is-over",
                            instruction: instruction_0
                        };
                    });
                },
                onDragLeave () {
                    setInternalState($238e7fcc46931eb1$var$idle);
                },
                onDrop () {
                    setInternalState($238e7fcc46931eb1$var$idle);
                },
                onDragEnter (t8) {
                    const { self: self_1 } = t8;
                    const instruction_1 = (0, $htuV6.extractInstruction)(self_1.data);
                    setInternalState({
                        type: "is-over",
                        instruction: instruction_1
                    });
                }
            });
        };
        t5 = [
            dropTargetArgs,
            getDraggableElement
        ];
        $[4] = dropTargetArgs;
        $[5] = t4;
        $[6] = t5;
    } else {
        t4 = $[5];
        t5 = $[6];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    bb0: {
        if (internalState.type !== "preview") {
            t6 = null;
            break bb0;
        }
        let t7;
        if ($[7] !== internalState.ui.content || $[8] !== internalState.ui.elemBefore) {
            t7 = /*#__PURE__*/ $cozmU.createElement((0, $01f2684e06d1e32f$export$905ab40ac2179daa), {
                elemBefore: internalState.ui.elemBefore
            }, internalState.ui.content);
            $[7] = internalState.ui.content;
            $[8] = internalState.ui.elemBefore;
            $[9] = t7;
        } else t7 = $[9];
        let t8;
        if ($[10] !== internalState.container || $[11] !== t7) {
            t8 = /*#__PURE__*/ (0, $9kbTQ.createPortal)(t7, internalState.container);
            $[10] = internalState.container;
            $[11] = t7;
            $[12] = t8;
        } else t8 = $[12];
        t6 = t8;
    }
    const dragPreview = t6;
    let t7;
    if ($[13] !== internalState.instruction || $[14] !== internalState.type) {
        t7 = internalState.type === "is-over" && internalState.instruction && /*#__PURE__*/ $cozmU.createElement((0, $c6b0b810afe42c2b$export$62ed72bc21f6b8a6), {
            instruction: internalState.instruction
        });
        $[13] = internalState.instruction;
        $[14] = internalState.type;
        $[15] = t7;
    } else t7 = $[15];
    const dropIndicator = t7;
    let t8;
    bb1: {
        if (internalState.type === "preview") {
            let t9;
            if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
                t9 = {
                    type: "preview"
                };
                $[16] = t9;
            } else t9 = $[16];
            t8 = t9;
            break bb1;
        }
        let t9;
        if ($[17] !== internalState) {
            t9 = {
                ...internalState
            };
            $[17] = internalState;
            $[18] = t9;
        } else t9 = $[18];
        t8 = t9;
    }
    const state = t8;
    let t9;
    if ($[19] !== dragPreview || $[20] !== dropIndicator || $[21] !== state) {
        t9 = {
            state: state,
            draggableButtonRef: draggableButtonRef,
            dropTargetRef: dropTargetRef,
            draggableAnchorRef: draggableAnchorRef,
            dragPreview: dragPreview,
            dropIndicator: dropIndicator
        };
        $[19] = dragPreview;
        $[20] = dropIndicator;
        $[21] = state;
        $[22] = t9;
    } else t9 = $[22];
    return t9;
} : function useMenuItemDragAndDrop({ draggable: draggableArgs, dropTarget: dropTargetArgs }) {
    const draggableAnchorRef = (0, $cozmU.useRef)(null);
    const draggableButtonRef = (0, $cozmU.useRef)(null);
    const dropTargetRef = (0, $cozmU.useRef)(null);
    const [internalState, setInternalState] = (0, $cozmU.useState)($238e7fcc46931eb1$var$idle);
    const getDraggableElement = (0, $cozmU.useCallback)(()=>{
        return draggableAnchorRef.current ?? draggableButtonRef.current ?? null;
    }, []); // Set up draggable
    (0, $cozmU.useEffect)(()=>{
        // Don't set up a draggable if there are no draggable args
        if (!draggableArgs) return;
        const element = getDraggableElement(); // Some elements may initially want to use DnD, then decide not to render.
        // In that case, we don't want to throw an error.
        if (!element) return;
        return (0, $iSrRp.draggable)({
            element: element,
            getInitialData: draggableArgs.getInitialData,
            canDrag: draggableArgs.canDrag,
            onGenerateDragPreview ({ nativeSetDragImage: nativeSetDragImage, source: source, location: location }) {
                (0, $cDMxg.setCustomNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage,
                    getOffset: (0, $fYWmN.pointerOutsideOfPreview)({
                        x: "var(--ds-space-200, 16px)",
                        y: "var(--ds-space-100, 8px)"
                    }),
                    render ({ container: container }) {
                        const args = {
                            dragHandle: source.dragHandle,
                            element: source.element,
                            input: location.current.input
                        };
                        setInternalState({
                            type: 'preview',
                            container: container,
                            ui: draggableArgs.getDragPreviewPieces(args)
                        });
                    }
                });
            },
            onDragStart () {
                setInternalState({
                    type: 'dragging'
                });
            },
            onDrop () {
                setInternalState($238e7fcc46931eb1$var$idle);
            }
        });
    }, [
        draggableArgs,
        getDraggableElement
    ]);
    // Set up drop target
    (0, $cozmU.useEffect)(()=>{
        if (!dropTargetArgs) return;
         // Don't need to provide a draggable element to have a drop target.
        // Using this element in our `canDrop` check
        const draggableElement = getDraggableElement();
        const dropTarget = dropTargetRef.current; // Some elements may initially want to use DnD, then decide not to render.
        // In that case, we don't want to throw an error
        if (!dropTarget) return;
        return (0, $iSrRp.dropTargetForElements)({
            element: dropTarget,
            // cannot drop on self
            canDrop: (args_0)=>{
                // cannot drop on self
                if (args_0.source.element === draggableElement) return false;
                if (dropTargetArgs.canDrop) return dropTargetArgs.canDrop(args_0);
                return true;
            },
            // menu items are always sticky, and the GroupDropIndicator should clear stickiness
            getIsSticky: ()=>true,
            getData (args_1) {
                const data = dropTargetArgs.getData?.(args_1) ?? {};
                const operations = dropTargetArgs.getOperations(args_1);
                return (0, $htuV6.attachInstruction)(data, {
                    input: args_1.input,
                    element: args_1.element,
                    operations: operations
                });
            },
            onDragStart ({ self: self }) {
                const instruction = (0, $htuV6.extractInstruction)(self.data);
                setInternalState({
                    type: 'is-over',
                    instruction: instruction
                });
            },
            onDrag ({ self: self_0 }) {
                const instruction_0 = (0, $htuV6.extractInstruction)(self_0.data);
                setInternalState((current)=>{
                    if (current.type === 'is-over' && instruction_0?.operation === current.instruction?.operation && instruction_0?.blocked === current.instruction?.blocked) return current;
                    return {
                        type: 'is-over',
                        instruction: instruction_0
                    };
                });
            },
            onDragLeave () {
                setInternalState($238e7fcc46931eb1$var$idle);
            },
            onDrop () {
                setInternalState($238e7fcc46931eb1$var$idle);
            },
            onDragEnter ({ self: self_1 }) {
                const instruction_1 = (0, $htuV6.extractInstruction)(self_1.data);
                setInternalState({
                    type: 'is-over',
                    instruction: instruction_1
                });
            }
        });
    }, [
        dropTargetArgs,
        getDraggableElement
    ]);
    const dragPreview = (()=>{
        if (internalState.type !== 'preview') return null;
        return /*#__PURE__*/ (0, $9kbTQ.createPortal)(/*#__PURE__*/ $cozmU.createElement((0, $01f2684e06d1e32f$export$905ab40ac2179daa), {
            elemBefore: internalState.ui.elemBefore
        }, internalState.ui.content), internalState.container);
    })();
    const dropIndicator = internalState.type === 'is-over' && internalState.instruction && /*#__PURE__*/ $cozmU.createElement((0, $c6b0b810afe42c2b$export$62ed72bc21f6b8a6), {
        instruction: internalState.instruction
    });
    const state = (0, $cozmU.useMemo)(()=>{
        if (internalState.type === 'preview') return {
            type: 'preview'
        };
         // returning a new object to avoid modification of our `internalState` object
        return {
            ...internalState
        };
    }, [
        internalState
    ]);
    return {
        state: state,
        draggableButtonRef: draggableButtonRef,
        dropTargetRef: dropTargetRef,
        draggableAnchorRef: draggableAnchorRef,
        dragPreview: dragPreview,
        dropIndicator: dropIndicator
    };
};
function $238e7fcc46931eb1$var$_temp() {
    return true;
}
module.exports["useMenuItemDragAndDrop"] = $238e7fcc46931eb1$export$fe281fdb09fbf0c8;

});

parcelRegister("htuV6", function(module, exports) {

var $aYBoi = parcelRequire("aYBoi");

// using a symbol so we can guarantee a key with a unique value
const $0738bd52d113a521$var$uniqueKey = Symbol('list-item-instruction');
const $0738bd52d113a521$var$axisLookup = {
    vertical: {
        start: 'top',
        end: 'bottom',
        size: 'height',
        point: 'y'
    },
    horizontal: {
        start: 'left',
        end: 'right',
        size: 'width',
        point: 'x'
    }
};
function $0738bd52d113a521$var$reorderAndCombine({ client: client, borderBox: borderBox, axis: axis }) {
    const quarterOfSize = borderBox[axis.size] / 4;
    // In the top 1/4: reorder-before
    // On the line: reorder-before to give a slight preference to reordering
    if (client[axis.point] <= borderBox[axis.start] + quarterOfSize) return 'reorder-before';
    // In the bottom 1/4: reorder-after
    // On the line: reorder-after to give a slight preference to reordering
    if (client[axis.point] >= borderBox[axis.end] - quarterOfSize) return 'reorder-after';
    return 'combine';
}
function $0738bd52d113a521$var$reorder({ client: client, borderBox: borderBox, axis: axis }) {
    const halfSize = borderBox[axis.size] / 2;
    // In the top 1/2: reorder-before
    // On the line: reorder-after to give a slight preference to moving forward
    if (client[axis.point] < borderBox[axis.start] + halfSize) return 'reorder-before';
    return 'reorder-after';
}
// Note: not using `memoize-one` as all we need is a cached value.
// We do not need to avoid executing an expensive function.
const $0738bd52d113a521$var$memoizeInstruction = (0, $aYBoi.stable)();
function $0738bd52d113a521$var$isPossible(...values) {
    return values.every((value)=>value === 'available' || value === 'blocked');
}
function $0738bd52d113a521$var$isNotAvailable(...values) {
    return values.every((value)=>value === 'not-available');
}
function $0738bd52d113a521$export$267ad49d812c2c7f(userData, { operations: operations, element: element, input: input, axis: axisValue = 'vertical' }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    const borderBox = element.getBoundingClientRect();
    const axis = $0738bd52d113a521$var$axisLookup[axisValue];
    const combine = operations.combine ?? 'not-available';
    const reorderAbove = operations['reorder-before'] ?? 'not-available';
    const reorderBelow = operations['reorder-after'] ?? 'not-available';
    const operation = (()=>{
        // Combining not possible
        if (!$0738bd52d113a521$var$isPossible(combine)) {
            // can reorder above and below
            if ($0738bd52d113a521$var$isPossible(reorderAbove, reorderBelow)) return $0738bd52d113a521$var$reorder({
                client: client,
                borderBox: borderBox,
                axis: axis
            });
            // can only reorder above
            if ($0738bd52d113a521$var$isPossible(reorderAbove)) return 'reorder-before';
            // can only reorder below
            if ($0738bd52d113a521$var$isPossible(reorderBelow)) return 'reorder-after';
            // no `true` values - no Outcome available.
            return null;
        }
        // combining is available
        const result = $0738bd52d113a521$var$reorderAndCombine({
            client: client,
            borderBox: borderBox,
            axis: axis
        });
        if (result === 'reorder-after') return $0738bd52d113a521$var$isNotAvailable(reorderBelow) ? 'combine' : result;
        if (result === 'reorder-before') return $0738bd52d113a521$var$isNotAvailable(reorderAbove) ? 'combine' : result;
        return result;
    })();
    // We cannot attach an instruction - all values passed where `false` or no values passed
    if (!operation) return userData;
    const instruction = {
        operation: operation,
        blocked: operations[operation] === 'blocked',
        axis: axisValue
    };
    const memoized = $0738bd52d113a521$var$memoizeInstruction(instruction);
    return {
        ...userData,
        [$0738bd52d113a521$var$uniqueKey]: memoized
    };
}
function $0738bd52d113a521$export$c8ffecbe249dc8f8(userData) {
    return userData[$0738bd52d113a521$var$uniqueKey] ?? null;
}
module.exports["attachInstruction"] = $0738bd52d113a521$export$267ad49d812c2c7f;
module.exports["extractInstruction"] = $0738bd52d113a521$export$c8ffecbe249dc8f8;

});

parcelRegister("czzzJ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $eq1BO = parcelRequire("eq1BO");


var $rECdA = parcelRequire("rECdA");


var $dinVW = parcelRequire("dinVW");


var $a1L5E = parcelRequire("a1L5E");


var $iDdJP = parcelRequire("iDdJP");


var $3ePvn = parcelRequire("3ePvn");

var $iBJls = parcelRequire("iBJls");

/**
 * Constants representing locations within the navigation system where errors might occur.
 * These help in identifying the source of errors for logging and debugging purposes.
 */ const $1fb207aeb440c1b4$export$1cb3fe63ec81f460 = 'global-shortcuts';
const $1fb207aeb440c1b4$export$7b1d5fb8b81e96a9 = 'ribbon';


var $iZ8sH = parcelRequire("iZ8sH");

var $cN3xQ = parcelRequire("cN3xQ");


var $9kVQp = parcelRequire("9kVQp");


var $aibb0 = parcelRequire("aibb0");


var $fFpVm = parcelRequire("fFpVm");

// Map of locale code -> dynamic import for that locale's i18n message bundle.
// Each entry is code-split into its own webpack chunk.
//
// AUTO-GENERATED — do not edit by hand.
// Regenerate with: yarn generate-async-languages <package-path>
// (script lives in platform/build/i18n/generate-async-languages.js)































const $4d47e9f115d5dd6f$export$3770c7a7737d463c = {
    cs: ()=>(parcelRequire("5ZZjS")),
    da: ()=>(parcelRequire("4jVWw")),
    de: ()=>(parcelRequire("h8zcI")),
    en: ()=>Promise.resolve((parcelRequire("fFpVm"))),
    'en-GB': ()=>(parcelRequire("g3qxk")),
    'en-ZZ': ()=>(parcelRequire("4ZUd5")),
    es: ()=>(parcelRequire("lxNMn")),
    fi: ()=>(parcelRequire("bp1ab")),
    fr: ()=>(parcelRequire("hfRnO")),
    hr: ()=>(parcelRequire("jnF3u")),
    hu: ()=>(parcelRequire("aOOAN")),
    it: ()=>(parcelRequire("lSe5S")),
    ja: ()=>(parcelRequire("jy1MI")),
    ko: ()=>(parcelRequire("fxFTV")),
    nb: ()=>(parcelRequire("42Bro")),
    nl: ()=>(parcelRequire("lzqbg")),
    pl: ()=>(parcelRequire("50QJG")),
    'pt-BR': ()=>(parcelRequire("iHp4g")),
    ru: ()=>(parcelRequire("fwCfK")),
    sk: ()=>(parcelRequire("eAKef")),
    sl: ()=>(parcelRequire("6aBQf")),
    sr: ()=>(parcelRequire("ghign")),
    'sr-RS': ()=>(parcelRequire("3rITN")),
    'sr-YR': ()=>(parcelRequire("kLFqZ")),
    sv: ()=>(parcelRequire("5b2wZ")),
    th: ()=>(parcelRequire("9XRm2")),
    tr: ()=>(parcelRequire("kuuW3")),
    uk: ()=>(parcelRequire("jDVbl")),
    vi: ()=>(parcelRequire("7Q3nl")),
    zh: ()=>(parcelRequire("2UzwX")),
    'zh-TW': ()=>(parcelRequire("iAWkb"))
};


const $975aaa55cf040e52$export$6b89dea1a4334953 = (0, $aibb0.createAsyncIntlProvider)({
    defaultMessages: (0, $fFpVm.default),
    asyncLanguages: $4d47e9f115d5dd6f$export$3770c7a7737d463c
});


const $7a2adbeb1f70395e$export$fe240e33002221f = 'global-shortcuts-platform-component';
const $7a2adbeb1f70395e$export$2158b6d23c9689f5 = 'global-shortcuts-data-loading';


parcelRequire("gOXu0");
var $3vXmx = parcelRequire("3vXmx");


var $3bmmh = parcelRequire("3bmmh");


var $kSwu1 = parcelRequire("kSwu1");

const $c3a7472dc0188501$export$628f6f7219a6b8b6 = (0, $kSwu1.defineMessages)({
    header: {
        id: "navigation.error.header.default",
        defaultMessage: "We couldn\u2019t load this content"
    },
    description: {
        id: "navigation.error.description.default",
        defaultMessage: "Refresh the page and try again"
    }
});



var $eaC3G = parcelRequire("eaC3G");














var $f922E = parcelRequire("f922E");


var $ixfCV = parcelRequire("ixfCV");







const $a6622c6f778415fb$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    viewAllAppsLabel: {
        id: "navigation.global-shortcuts.view-all-apps.label",
        defaultMessage: "View all apps"
    }
});


const $6e4658e1d77eae7a$var$analyticsName = 'VIEW_ALL_APPS';
const $6e4658e1d77eae7a$export$84e063904618ed06 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ViewAllAppsItem(t0) {
    const $ = (0, $bDgLe.c)(17);
    const { path: path, isSelected: isSelected, product: product, onNavigate: onNavigate } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage((0, $a6622c6f778415fb$export$defe85febe8b728c).viewAllAppsLabel);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f922E))), {
            label: ""
        });
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== isSelected || $[4] !== onNavigate || $[5] !== path || $[6] !== t1) {
        t3 = {
            key: $6e4658e1d77eae7a$var$analyticsName,
            analyticsName: $6e4658e1d77eae7a$var$analyticsName,
            label: t1,
            icon: t2,
            url: path,
            isReorderable: false,
            type: "internal",
            isSelected: isSelected,
            onClick: onNavigate
        };
        $[3] = isSelected;
        $[4] = onNavigate;
        $[5] = path;
        $[6] = t1;
        $[7] = t3;
    } else t3 = $[7];
    const memoisedShortcut = t3;
    if (!path || path.trim().length < 1) return null;
    let t4;
    if ($[8] !== formatMessage || $[9] !== isSelected || $[10] !== memoisedShortcut || $[11] !== onNavigate || $[12] !== path) {
        t4 = (0, $ixfCV.fg)("navx-4728-jira-stability-fixes") ? memoisedShortcut : {
            key: $6e4658e1d77eae7a$var$analyticsName,
            analyticsName: $6e4658e1d77eae7a$var$analyticsName,
            label: formatMessage((0, $a6622c6f778415fb$export$defe85febe8b728c).viewAllAppsLabel),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f922E))), {
                label: ""
            }),
            url: path,
            isReorderable: false,
            type: "internal",
            isSelected: isSelected,
            onClick: onNavigate
        };
        $[8] = formatMessage;
        $[9] = isSelected;
        $[10] = memoisedShortcut;
        $[11] = onNavigate;
        $[12] = path;
        $[13] = t4;
    } else t4 = $[13];
    const shortcut = t4;
    let t5;
    if ($[14] !== product || $[15] !== shortcut) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eaC3G.ShortcutMenuItem), {
            shortcut: shortcut,
            product: product
        });
        $[14] = product;
        $[15] = shortcut;
        $[16] = t5;
    } else t5 = $[16];
    return t5;
} : function ViewAllAppsItem({ path: path, isSelected: isSelected, product: product, onNavigate: onNavigate }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    // Behind `navx-4728-jira-stability-fixes`, memoise the `shortcut` object so the
    // memoised `ShortcutMenuItem` isn't handed a brand-new object (with a fresh
    // icon element) on every render, which would defeat its memo. Hooks must run
    // unconditionally, so this is computed before the early `path` guard below.
    const memoisedShortcut = (0, $cozmU.useMemo)(()=>({
            key: $6e4658e1d77eae7a$var$analyticsName,
            analyticsName: $6e4658e1d77eae7a$var$analyticsName,
            label: formatMessage((0, $a6622c6f778415fb$export$defe85febe8b728c).viewAllAppsLabel),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f922E))), {
                label: ""
            }),
            url: path,
            isReorderable: false,
            type: 'internal',
            isSelected: isSelected,
            onClick: onNavigate
        }), [
        formatMessage,
        path,
        isSelected,
        onNavigate
    ]);
    if (!path || path.trim().length < 1) return null;
    const shortcut = (0, $ixfCV.fg)('navx-4728-jira-stability-fixes') ? memoisedShortcut : {
        key: $6e4658e1d77eae7a$var$analyticsName,
        analyticsName: $6e4658e1d77eae7a$var$analyticsName,
        label: formatMessage((0, $a6622c6f778415fb$export$defe85febe8b728c).viewAllAppsLabel),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f922E))), {
            label: ""
        }),
        url: path,
        isReorderable: false,
        type: 'internal',
        isSelected: isSelected,
        onClick: onNavigate
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eaC3G.ShortcutMenuItem), {
        shortcut: shortcut,
        product: product
    });
};


const $67bfded25ae19901$export$9da1f15784a2a312 = $67bfded25ae19901$var$GlobalShortcutsRelay;
const $67bfded25ae19901$export$bae2da217bf9db6 = (0, $rECdA.componentWithFG)('navx-4463-gas-agg-migration', $67bfded25ae19901$var$GlobalShortcutsRelay, $67bfded25ae19901$var$GlobalShortcutsBFF);
const $67bfded25ae19901$var$isReactCompilerActivePlatform_result = (0, $gtMdU.isReactCompilerActivePlatform)();
function $67bfded25ae19901$var$GlobalShortcutsRelay_optimized(props) {
    const $ = (0, $bDgLe.c)(7);
    const { product: product } = props;
    let t0;
    if ($[0] !== product) {
        t0 = {
            product: product
        };
        $[0] = product;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($67bfded25ae19901$var$GlobalShortcutsInnerRelay, props);
        $[2] = props;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== t0 || $[5] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
            name: (0, $7a2adbeb1f70395e$export$fe240e33002221f)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iZ8sH.NavErrorBoundary), {
            errorMessages: (0, $c3a7472dc0188501$export$628f6f7219a6b8b6),
            sentryConfig: t0,
            silent: true,
            ufoInteractionName: (0, $7a2adbeb1f70395e$export$fe240e33002221f)
        }, t1));
        $[4] = t0;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
}
function $67bfded25ae19901$var$GlobalShortcutsRelay_unoptimized(props) {
    const { product: product } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: (0, $7a2adbeb1f70395e$export$fe240e33002221f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iZ8sH.NavErrorBoundary), {
        errorMessages: (0, $c3a7472dc0188501$export$628f6f7219a6b8b6),
        sentryConfig: {
            product: product
        },
        silent: true,
        ufoInteractionName: (0, $7a2adbeb1f70395e$export$fe240e33002221f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($67bfded25ae19901$var$GlobalShortcutsInnerRelay, props)));
}
function $67bfded25ae19901$var$GlobalShortcutsRelay(arg0) {
    if ($67bfded25ae19901$var$isReactCompilerActivePlatform_result) return $67bfded25ae19901$var$GlobalShortcutsRelay_optimized(arg0);
    else return $67bfded25ae19901$var$GlobalShortcutsRelay_unoptimized(arg0);
}
const $67bfded25ae19901$var$_isReactCompilerActivePlatform_result = (0, $gtMdU.isReactCompilerActivePlatform)();
function $67bfded25ae19901$var$GlobalShortcutsBFF_optimized(props) {
    const $ = (0, $bDgLe.c)(7);
    const { product: product } = props;
    let t0;
    if ($[0] !== product) {
        t0 = {
            product: product
        };
        $[0] = product;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($67bfded25ae19901$var$GlobalShortcutsInnerBFF, props);
        $[2] = props;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== t0 || $[5] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iBJls.BFFProvider), {
            consumer: (0, $3ePvn.BFFConsumerEnum).GLOBAL_SHORTCUTS
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
            name: (0, $7a2adbeb1f70395e$export$fe240e33002221f)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iZ8sH.NavErrorBoundary), {
            errorMessages: (0, $c3a7472dc0188501$export$628f6f7219a6b8b6),
            sentryConfig: t0,
            silent: true,
            ufoInteractionName: (0, $7a2adbeb1f70395e$export$fe240e33002221f)
        }, t1)));
        $[4] = t0;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
}
function $67bfded25ae19901$var$GlobalShortcutsBFF_unoptimized(props) {
    const { product: product } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iBJls.BFFProvider), {
        consumer: (0, $3ePvn.BFFConsumerEnum).GLOBAL_SHORTCUTS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: (0, $7a2adbeb1f70395e$export$fe240e33002221f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iZ8sH.NavErrorBoundary), {
        errorMessages: (0, $c3a7472dc0188501$export$628f6f7219a6b8b6),
        sentryConfig: {
            product: product
        },
        silent: true,
        ufoInteractionName: (0, $7a2adbeb1f70395e$export$fe240e33002221f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($67bfded25ae19901$var$GlobalShortcutsInnerBFF, props))));
}
function $67bfded25ae19901$var$GlobalShortcutsBFF(arg0) {
    if ($67bfded25ae19901$var$_isReactCompilerActivePlatform_result) return $67bfded25ae19901$var$GlobalShortcutsBFF_optimized(arg0);
    else return $67bfded25ae19901$var$GlobalShortcutsBFF_unoptimized(arg0);
}
const $67bfded25ae19901$var$GlobalShortcutsInnerRelay = (0, $gtMdU.isReactCompilerActivePlatform)() ? function GlobalShortcutsInnerRelay(t0) {
    const $ = (0, $bDgLe.c)(15);
    const { cloudId: cloudId, product: product, shortcutItems: rawShortcutItems, onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks, testId: testId, enableDragAndDrop: enableDragAndDrop, viewAllAppsConfig: viewAllAppsConfig, openInSameTab: openInSameTab } = t0;
    let t1;
    if ($[0] !== product) {
        t1 = {
            location: (0, $1fb207aeb440c1b4$export$1cb3fe63ec81f460),
            sentryConfig: {
                product: product
            },
            disableAnalytics: true
        };
        $[0] = product;
        $[1] = t1;
    } else t1 = $[1];
    const { handleError: handleError } = (0, $cN3xQ.useNavBoundaryContext)(t1);
    let t2;
    if ($[2] !== enableDragAndDrop || $[3] !== openInSameTab || $[4] !== product || $[5] !== testId || $[6] !== viewAllAppsConfig) {
        t2 = (shortcutItems)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($67bfded25ae19901$export$d64b9883b9bde88c, {
                enableDragAndDrop: enableDragAndDrop,
                openInSameTab: openInSameTab,
                product: product,
                shortcutItems: shortcutItems,
                testId: testId,
                viewAllAppsConfig: viewAllAppsConfig
            });
        $[2] = enableDragAndDrop;
        $[3] = openInSameTab;
        $[4] = product;
        $[5] = testId;
        $[6] = viewAllAppsConfig;
        $[7] = t2;
    } else t2 = $[7];
    let t3;
    if ($[8] !== cloudId || $[9] !== handleError || $[10] !== onUpdateGetFilteredProductLinks || $[11] !== product || $[12] !== rawShortcutItems || $[13] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9kVQp.default), {
            cloudId: cloudId,
            onError: handleError,
            onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks,
            product: product,
            shortcutsConfig: rawShortcutItems
        }, t2);
        $[8] = cloudId;
        $[9] = handleError;
        $[10] = onUpdateGetFilteredProductLinks;
        $[11] = product;
        $[12] = rawShortcutItems;
        $[13] = t2;
        $[14] = t3;
    } else t3 = $[14];
    return t3;
} : function GlobalShortcutsInnerRelay({ cloudId: cloudId, product: product, shortcutItems: rawShortcutItems, onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks, testId: testId, enableDragAndDrop: enableDragAndDrop, viewAllAppsConfig: viewAllAppsConfig, openInSameTab: openInSameTab }) {
    const { handleError: handleError } = (0, $cN3xQ.useNavBoundaryContext)({
        location: (0, $1fb207aeb440c1b4$export$1cb3fe63ec81f460),
        // Log backend errors only to Sentry
        // see: https://hello.atlassian.net/wiki/spaces/navx/pages/6439960649/NavX+-+FE+Observability#%3Acatchemall%3A--Error-handling
        sentryConfig: {
            product: product
        },
        disableAnalytics: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9kVQp.default), {
        cloudId: cloudId,
        onError: handleError,
        onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks,
        product: product,
        shortcutsConfig: rawShortcutItems
    }, (shortcutItems)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($67bfded25ae19901$export$d64b9883b9bde88c, {
            enableDragAndDrop: enableDragAndDrop,
            openInSameTab: openInSameTab,
            product: product,
            shortcutItems: shortcutItems,
            testId: testId,
            viewAllAppsConfig: viewAllAppsConfig
        }));
};
const $67bfded25ae19901$var$GlobalShortcutsInnerBFF = (0, $gtMdU.isReactCompilerActivePlatform)() ? function GlobalShortcutsInnerBFF(t0) {
    const $ = (0, $bDgLe.c)(15);
    const { cloudId: cloudId, product: product, shortcutItems: rawShortcutItems, onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks, testId: testId, enableDragAndDrop: enableDragAndDrop, viewAllAppsConfig: viewAllAppsConfig, openInSameTab: openInSameTab } = t0;
    let t1;
    if ($[0] !== product) {
        t1 = {
            location: (0, $1fb207aeb440c1b4$export$1cb3fe63ec81f460),
            sentryConfig: {
                product: product
            },
            disableAnalytics: true
        };
        $[0] = product;
        $[1] = t1;
    } else t1 = $[1];
    const { handleError: handleError } = (0, $cN3xQ.useNavBoundaryContext)(t1);
    let t2;
    if ($[2] !== cloudId || $[3] !== handleError || $[4] !== onUpdateGetFilteredProductLinks || $[5] !== product || $[6] !== rawShortcutItems) {
        t2 = {
            shortcutsConfig: rawShortcutItems,
            cloudId: cloudId,
            onError: handleError,
            onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks,
            product: product
        };
        $[2] = cloudId;
        $[3] = handleError;
        $[4] = onUpdateGetFilteredProductLinks;
        $[5] = product;
        $[6] = rawShortcutItems;
        $[7] = t2;
    } else t2 = $[7];
    const shortcutItems = (0, $3vXmx.useGlobalShortcutsDataBFF)(t2);
    let t3;
    if ($[8] !== enableDragAndDrop || $[9] !== openInSameTab || $[10] !== product || $[11] !== shortcutItems || $[12] !== testId || $[13] !== viewAllAppsConfig) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($67bfded25ae19901$export$d64b9883b9bde88c, {
            enableDragAndDrop: enableDragAndDrop,
            openInSameTab: openInSameTab,
            product: product,
            shortcutItems: shortcutItems,
            testId: testId,
            viewAllAppsConfig: viewAllAppsConfig
        });
        $[8] = enableDragAndDrop;
        $[9] = openInSameTab;
        $[10] = product;
        $[11] = shortcutItems;
        $[12] = testId;
        $[13] = viewAllAppsConfig;
        $[14] = t3;
    } else t3 = $[14];
    return t3;
} : function GlobalShortcutsInnerBFF({ cloudId: cloudId, product: product, shortcutItems: rawShortcutItems, onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks, testId: testId, enableDragAndDrop: enableDragAndDrop, viewAllAppsConfig: viewAllAppsConfig, openInSameTab: openInSameTab }) {
    const { handleError: handleError } = (0, $cN3xQ.useNavBoundaryContext)({
        location: (0, $1fb207aeb440c1b4$export$1cb3fe63ec81f460),
        // Log backend errors only to Sentry
        // see: https://hello.atlassian.net/wiki/spaces/navx/pages/6439960649/NavX+-+FE+Observability#%3Acatchemall%3A--Error-handling
        sentryConfig: {
            product: product
        },
        disableAnalytics: true
    });
    const shortcutItems = (0, $3vXmx.useGlobalShortcutsDataBFF)({
        shortcutsConfig: rawShortcutItems,
        cloudId: cloudId,
        onError: handleError,
        onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks,
        product: product
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($67bfded25ae19901$export$d64b9883b9bde88c, {
        enableDragAndDrop: enableDragAndDrop,
        openInSameTab: openInSameTab,
        product: product,
        shortcutItems: shortcutItems,
        testId: testId,
        viewAllAppsConfig: viewAllAppsConfig
    });
}; // This is the GAS UI component. In apps, it is typically surrounded by one of the data components
const $67bfded25ae19901$export$d64b9883b9bde88c = (0, $gtMdU.isReactCompilerActivePlatform)() ? function GlobalShortcutsMenu(t0) {
    const $ = (0, $bDgLe.c)(33);
    const { testId: testId, shortcutItems: t1, product: product, enableDragAndDrop: enableDragAndDrop, viewAllAppsConfig: t2, openInSameTab: openInSameTab, intlMode: t3 } = t0;
    let t4;
    if ($[0] !== t1) {
        t4 = t1 === undefined ? [] : t1;
        $[0] = t1;
        $[1] = t4;
    } else t4 = $[1];
    const shortcutItems = t4;
    let t5;
    if ($[2] !== t2) {
        t5 = t2 === undefined ? {} : t2;
        $[2] = t2;
        $[3] = t5;
    } else t5 = $[3];
    const viewAllAppsConfig = t5;
    const intlMode = t3 === undefined ? "async" : t3;
    const IntlWrapper = intlMode === "inherit" ? (0, $cozmU.Fragment) : (0, $975aaa55cf040e52$export$6b89dea1a4334953);
    let t6;
    if ($[4] !== shortcutItems) {
        t6 = shortcutItems.map($67bfded25ae19901$var$_temp);
        $[4] = shortcutItems;
        $[5] = t6;
    } else t6 = $[5];
    const mappedShortcutItems = t6;
    let t7;
    if ($[6] !== enableDragAndDrop || $[7] !== openInSameTab || $[8] !== product) {
        t7 = (shortcut)=>{
            if (shortcut.type === "component") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eaC3G.ShortcutMenuItem), {
                key: shortcut.key,
                shortcut: shortcut,
                dragAndDropEnabled: enableDragAndDrop
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eaC3G.ShortcutMenuItem), {
                key: shortcut.key,
                shortcut: shortcut,
                openInSameTab: openInSameTab,
                product: product
            });
        };
        $[6] = enableDragAndDrop;
        $[7] = openInSameTab;
        $[8] = product;
        $[9] = t7;
    } else t7 = $[9];
    const createLinkItem = t7;
    let t8;
    if ($[10] !== createLinkItem || $[11] !== mappedShortcutItems) {
        t8 = mappedShortcutItems?.map(createLinkItem);
        $[10] = createLinkItem;
        $[11] = mappedShortcutItems;
        $[12] = t8;
    } else t8 = $[12];
    let t9;
    if ($[13] !== product || $[14] !== viewAllAppsConfig) {
        t9 = viewAllAppsConfig?.path && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6e4658e1d77eae7a$export$84e063904618ed06), {
            ...viewAllAppsConfig,
            product: product
        });
        $[13] = product;
        $[14] = viewAllAppsConfig;
        $[15] = t9;
    } else t9 = $[15];
    let t10;
    if ($[16] !== t8 || $[17] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iDdJP.MenuList), null, t8, t9);
        $[16] = t8;
        $[17] = t9;
        $[18] = t10;
    } else t10 = $[18];
    const shortcutList = t10;
    let t11;
    if ($[19] !== product) {
        t11 = {
            product: product
        };
        $[19] = product;
        $[20] = t11;
    } else t11 = $[20];
    let t12;
    if ($[21] !== enableDragAndDrop || $[22] !== shortcutList) {
        t12 = enableDragAndDrop ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3bmmh.DragAndDropOptionsProvider), {
            enabled: enableDragAndDrop
        }, shortcutList) : shortcutList;
        $[21] = enableDragAndDrop;
        $[22] = shortcutList;
        $[23] = t12;
    } else t12 = $[23];
    let t13;
    if ($[24] !== t12 || $[25] !== testId) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
            testId: testId
        }, t12);
        $[24] = t12;
        $[25] = testId;
        $[26] = t13;
    } else t13 = $[26];
    let t14;
    if ($[27] !== t11 || $[28] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eq1BO.NavigationAnalyticsContext), {
            data: t11
        }, t13);
        $[27] = t11;
        $[28] = t13;
        $[29] = t14;
    } else t14 = $[29];
    let t15;
    if ($[30] !== IntlWrapper || $[31] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(IntlWrapper, null, t14);
        $[30] = IntlWrapper;
        $[31] = t14;
        $[32] = t15;
    } else t15 = $[32];
    return t15;
} : function GlobalShortcutsMenu({ testId: testId, shortcutItems: shortcutItems = [], product: product, enableDragAndDrop: enableDragAndDrop, viewAllAppsConfig: viewAllAppsConfig = {}, openInSameTab: openInSameTab, intlMode: intlMode = 'async' }) {
    const IntlWrapper = intlMode === 'inherit' ? (0, $cozmU.Fragment) : (0, $975aaa55cf040e52$export$6b89dea1a4334953);
    const mappedShortcutItems = (0, $cozmU.useMemo)(()=>{
        return shortcutItems.map((item, index)=>{
            let key = item.type === 'link' && item.apsKey || `shortcut-${index}`;
            if (item.type === 'component') key = item?.apsKey ?? item.menuItemId ?? `shortcut-${index}`;
            return {
                ...item,
                key: key
            };
        });
    }, [
        shortcutItems
    ]);
    const createLinkItem = (0, $cozmU.useCallback)((shortcut)=>{
        if (shortcut.type === 'component') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eaC3G.ShortcutMenuItem), {
            key: shortcut.key,
            shortcut: shortcut,
            dragAndDropEnabled: enableDragAndDrop
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eaC3G.ShortcutMenuItem), {
            key: shortcut.key,
            shortcut: shortcut,
            openInSameTab: openInSameTab,
            product: product
        });
    }, [
        product,
        openInSameTab,
        enableDragAndDrop
    ]);
    const shortcutList = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iDdJP.MenuList), null, mappedShortcutItems?.map(createLinkItem), viewAllAppsConfig?.path && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6e4658e1d77eae7a$export$84e063904618ed06), {
        ...viewAllAppsConfig,
        product: product
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(IntlWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eq1BO.NavigationAnalyticsContext), {
        data: {
            product: product
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        testId: testId
    }, enableDragAndDrop ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3bmmh.DragAndDropOptionsProvider), {
        enabled: enableDragAndDrop
    }, shortcutList) : shortcutList)));
};
function $67bfded25ae19901$var$_temp(item, index) {
    let key = item.type === "link" && item.apsKey || `shortcut-${index}`;
    if (item.type === "component") key = item?.apsKey ?? item.menuItemId ?? `shortcut-${index}`;
    return {
        ...item,
        key: key
    };
}
module.exports["GlobalShortcuts"] = $67bfded25ae19901$export$bae2da217bf9db6;
module.exports["GlobalShortcutsMenu"] = $67bfded25ae19901$export$d64b9883b9bde88c;

});

parcelRegister("fFpVm", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $1a28f47cf5f7164d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $f95Dj = parcelRequire("f95Dj");

var $1a28f47cf5f7164d$export$2e2bcd8739ae039 = (0, $f95Dj.default);

});

parcelRegister("5ZZjS", function(module, exports) {

let $45e2370c138c2932$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $45e2370c138c2932$var$load("1JYrd"),
    $45e2370c138c2932$var$load("cip6w"),
    $45e2370c138c2932$var$load("3feYV"),
    $45e2370c138c2932$var$load("gAG2n"),
    $45e2370c138c2932$var$load("hFpP9"),
    $45e2370c138c2932$var$load("cwjU2"),
    $45e2370c138c2932$var$load("3Ff1R"),
    $45e2370c138c2932$var$load("423Ga")
]).then(()=>parcelRequire('kP9PO'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("4jVWw", function(module, exports) {

let $3255e2097d8873fc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3255e2097d8873fc$var$load("30242"),
    $3255e2097d8873fc$var$load("3qBwQ"),
    $3255e2097d8873fc$var$load("7Q1SM"),
    $3255e2097d8873fc$var$load("cYGDU"),
    $3255e2097d8873fc$var$load("ddSTH"),
    $3255e2097d8873fc$var$load("33Iaa"),
    $3255e2097d8873fc$var$load("blA7x"),
    $3255e2097d8873fc$var$load("gJroP")
]).then(()=>parcelRequire('2OXDF'));

});

parcelRegister("h8zcI", function(module, exports) {

let $c79e7dcee1179d9a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c79e7dcee1179d9a$var$load("15aAJ"),
    $c79e7dcee1179d9a$var$load("8rREG"),
    $c79e7dcee1179d9a$var$load("7JdzX"),
    $c79e7dcee1179d9a$var$load("dgXJL"),
    $c79e7dcee1179d9a$var$load("9d8JZ"),
    $c79e7dcee1179d9a$var$load("6681T"),
    $c79e7dcee1179d9a$var$load("3dn3H"),
    $c79e7dcee1179d9a$var$load("cYXvt")
]).then(()=>parcelRequire('4z1H6'));

});

parcelRegister("g3qxk", function(module, exports) {

let $bb0182c106f15345$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $bb0182c106f15345$var$load("6Hcvs"),
    $bb0182c106f15345$var$load("bzMpd")
]).then(()=>parcelRequire('iM4np'));

});

parcelRegister("4ZUd5", function(module, exports) {

let $3a387618cd61e04d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3a387618cd61e04d$var$load("bbv9t"),
    $3a387618cd61e04d$var$load("9fQoJ"),
    $3a387618cd61e04d$var$load("cnlNg"),
    $3a387618cd61e04d$var$load("lTboH"),
    $3a387618cd61e04d$var$load("gBDXQ"),
    $3a387618cd61e04d$var$load("d3Phe"),
    $3a387618cd61e04d$var$load("lASLx"),
    $3a387618cd61e04d$var$load("bIXgz")
]).then(()=>parcelRequire('jKPRe'));

});

parcelRegister("lxNMn", function(module, exports) {

let $faf34b2a11504b81$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $faf34b2a11504b81$var$load("7p4je"),
    $faf34b2a11504b81$var$load("8SZbD"),
    $faf34b2a11504b81$var$load("9Uf61"),
    $faf34b2a11504b81$var$load("iE05k"),
    $faf34b2a11504b81$var$load("lv5aU"),
    $faf34b2a11504b81$var$load("3Yk1e"),
    $faf34b2a11504b81$var$load("5lJyy"),
    $faf34b2a11504b81$var$load("9w9df")
]).then(()=>parcelRequire('llNjh'));

});

parcelRegister("bp1ab", function(module, exports) {

let $84d2ee852ae5310b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $84d2ee852ae5310b$var$load("1jQRQ"),
    $84d2ee852ae5310b$var$load("5pOQA"),
    $84d2ee852ae5310b$var$load("fJSEb"),
    $84d2ee852ae5310b$var$load("5GSny"),
    $84d2ee852ae5310b$var$load("cQump"),
    $84d2ee852ae5310b$var$load("ajzkj"),
    $84d2ee852ae5310b$var$load("eyysG"),
    $84d2ee852ae5310b$var$load("27gvR")
]).then(()=>parcelRequire('cMzEL'));

});

parcelRegister("hfRnO", function(module, exports) {

let $c8fd3f255260a8b8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c8fd3f255260a8b8$var$load("km37l"),
    $c8fd3f255260a8b8$var$load("gbksI"),
    $c8fd3f255260a8b8$var$load("9TeWr"),
    $c8fd3f255260a8b8$var$load("j2X7f"),
    $c8fd3f255260a8b8$var$load("fE8pi"),
    $c8fd3f255260a8b8$var$load("kUZ7k"),
    $c8fd3f255260a8b8$var$load("dJQL7"),
    $c8fd3f255260a8b8$var$load("czj6d")
]).then(()=>parcelRequire('5jn90'));

});

parcelRegister("jnF3u", function(module, exports) {

let $e1c0030345fb69e8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e1c0030345fb69e8$var$load("hi9NG").then(()=>parcelRequire('k55sK'));

});

parcelRegister("aOOAN", function(module, exports) {

let $7e05d17eead01218$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $7e05d17eead01218$var$load("lTbXI"),
    $7e05d17eead01218$var$load("a98cw"),
    $7e05d17eead01218$var$load("fOGnR"),
    $7e05d17eead01218$var$load("e40mE"),
    $7e05d17eead01218$var$load("btBGI"),
    $7e05d17eead01218$var$load("cDQOq"),
    $7e05d17eead01218$var$load("8upye"),
    $7e05d17eead01218$var$load("GlmUM")
]).then(()=>parcelRequire('fIWFi'));

});

parcelRegister("lSe5S", function(module, exports) {

let $fec992d735d9195e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $fec992d735d9195e$var$load("iUyZj"),
    $fec992d735d9195e$var$load("4PDaO"),
    $fec992d735d9195e$var$load("8nEeY"),
    $fec992d735d9195e$var$load("lMhbw"),
    $fec992d735d9195e$var$load("amTTV"),
    $fec992d735d9195e$var$load("kLZKK"),
    $fec992d735d9195e$var$load("c7GMc"),
    $fec992d735d9195e$var$load("bnhJ1")
]).then(()=>parcelRequire('1xWNv'));

});

parcelRegister("jy1MI", function(module, exports) {

let $e3b293b3afb0a8b3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e3b293b3afb0a8b3$var$load("kPlMQ"),
    $e3b293b3afb0a8b3$var$load("ervs7"),
    $e3b293b3afb0a8b3$var$load("fzzMQ"),
    $e3b293b3afb0a8b3$var$load("8CX31"),
    $e3b293b3afb0a8b3$var$load("kYd4i"),
    $e3b293b3afb0a8b3$var$load("33S6H"),
    $e3b293b3afb0a8b3$var$load("kFae4"),
    $e3b293b3afb0a8b3$var$load("iZWpE")
]).then(()=>parcelRequire('7kLVY'));

});

parcelRegister("fxFTV", function(module, exports) {

let $b50a70c17283384f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b50a70c17283384f$var$load("iT2sv"),
    $b50a70c17283384f$var$load("iMMtn"),
    $b50a70c17283384f$var$load("3gNEO"),
    $b50a70c17283384f$var$load("23VWs"),
    $b50a70c17283384f$var$load("e1KaU"),
    $b50a70c17283384f$var$load("93obY"),
    $b50a70c17283384f$var$load("6Y9jE"),
    $b50a70c17283384f$var$load("cUTaY")
]).then(()=>parcelRequire('7nirx'));

});

parcelRegister("42Bro", function(module, exports) {

let $2f14645180a3c581$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2f14645180a3c581$var$load("lyPpF"),
    $2f14645180a3c581$var$load("eX5n7"),
    $2f14645180a3c581$var$load("gvylW"),
    $2f14645180a3c581$var$load("aiYuN"),
    $2f14645180a3c581$var$load("gqMCT"),
    $2f14645180a3c581$var$load("bxfRe"),
    $2f14645180a3c581$var$load("ed6s8"),
    $2f14645180a3c581$var$load("lAuJd")
]).then(()=>parcelRequire('ajRx2'));

});

parcelRegister("lzqbg", function(module, exports) {

let $fb412cd02864f643$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $fb412cd02864f643$var$load("iN3cj"),
    $fb412cd02864f643$var$load("3nHdy"),
    $fb412cd02864f643$var$load("80OLx"),
    $fb412cd02864f643$var$load("gDEvm"),
    $fb412cd02864f643$var$load("5MwHB"),
    $fb412cd02864f643$var$load("1EVcg"),
    $fb412cd02864f643$var$load("96q1k"),
    $fb412cd02864f643$var$load("XQtfV")
]).then(()=>parcelRequire('5OzV9'));

});

parcelRegister("50QJG", function(module, exports) {

let $3a65dc17b65c0d2c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3a65dc17b65c0d2c$var$load("eC1OL"),
    $3a65dc17b65c0d2c$var$load("ilL9c"),
    $3a65dc17b65c0d2c$var$load("e4s0V"),
    $3a65dc17b65c0d2c$var$load("64nco"),
    $3a65dc17b65c0d2c$var$load("9cx6P"),
    $3a65dc17b65c0d2c$var$load("28EXy"),
    $3a65dc17b65c0d2c$var$load("7RZp5"),
    $3a65dc17b65c0d2c$var$load("leyTH")
]).then(()=>parcelRequire('jIQoK'));

});

parcelRegister("iHp4g", function(module, exports) {

let $d9cfb0136cdbade7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d9cfb0136cdbade7$var$load("4NJ49"),
    $d9cfb0136cdbade7$var$load("bfOZL"),
    $d9cfb0136cdbade7$var$load("4dPO1"),
    $d9cfb0136cdbade7$var$load("jLbRX"),
    $d9cfb0136cdbade7$var$load("5g0HW"),
    $d9cfb0136cdbade7$var$load("gg8tK"),
    $d9cfb0136cdbade7$var$load("eF54W"),
    $d9cfb0136cdbade7$var$load("3hnPt")
]).then(()=>parcelRequire('7FCSx'));

});

parcelRegister("fwCfK", function(module, exports) {

let $b4d7846981e76ff8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b4d7846981e76ff8$var$load("g9gkE"),
    $b4d7846981e76ff8$var$load("jYdbS"),
    $b4d7846981e76ff8$var$load("ltrgi"),
    $b4d7846981e76ff8$var$load("6ncWv"),
    $b4d7846981e76ff8$var$load("gFneG"),
    $b4d7846981e76ff8$var$load("fu25G"),
    $b4d7846981e76ff8$var$load("iQGcz"),
    $b4d7846981e76ff8$var$load("ar4uw")
]).then(()=>parcelRequire('ccQsw'));

});

parcelRegister("eAKef", function(module, exports) {

let $a9f8498e0e589cdf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a9f8498e0e589cdf$var$load("kumDk").then(()=>parcelRequire('fUVCV'));

});

parcelRegister("6aBQf", function(module, exports) {

let $47e107d007426b65$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $47e107d007426b65$var$load("9pnOF").then(()=>parcelRequire('8ONDR'));

});

parcelRegister("ghign", function(module, exports) {

let $bd9c66870333986e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bd9c66870333986e$var$load("agpzZ").then(()=>parcelRequire('d8oe4'));

});

parcelRegister("3rITN", function(module, exports) {

let $2826b8b67d0489f5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2826b8b67d0489f5$var$load("98iHR").then(()=>parcelRequire('3Ix5E'));

});

parcelRegister("kLFqZ", function(module, exports) {

let $f1e856731ca48d6f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f1e856731ca48d6f$var$load("adgrV").then(()=>parcelRequire('dGChK'));

});

parcelRegister("5b2wZ", function(module, exports) {

let $3c4ff174df7c54b6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3c4ff174df7c54b6$var$load("jhikU"),
    $3c4ff174df7c54b6$var$load("f0i3H"),
    $3c4ff174df7c54b6$var$load("69YlM"),
    $3c4ff174df7c54b6$var$load("bvBAp"),
    $3c4ff174df7c54b6$var$load("9kqmW"),
    $3c4ff174df7c54b6$var$load("cyTsc"),
    $3c4ff174df7c54b6$var$load("kXCsp"),
    $3c4ff174df7c54b6$var$load("disCG")
]).then(()=>parcelRequire('7N28Q'));

});

parcelRegister("9XRm2", function(module, exports) {

let $741302ce7102eeb3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $741302ce7102eeb3$var$load("dkKxo"),
    $741302ce7102eeb3$var$load("jMiyA")
]).then(()=>parcelRequire('3InBG'));

});

parcelRegister("kuuW3", function(module, exports) {

let $eeae9b1dc74e064e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $eeae9b1dc74e064e$var$load("4TdLB"),
    $eeae9b1dc74e064e$var$load("7bwdR")
]).then(()=>parcelRequire('lsR5A'));

});

parcelRegister("jDVbl", function(module, exports) {

let $e4ce03fb8633dad0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e4ce03fb8633dad0$var$load("hUWr2"),
    $e4ce03fb8633dad0$var$load("fVBSK")
]).then(()=>parcelRequire('6WqWy'));

});

parcelRegister("7Q3nl", function(module, exports) {

let $5b50020818936e8b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $5b50020818936e8b$var$load("fgPWL"),
    $5b50020818936e8b$var$load("i8oT3")
]).then(()=>parcelRequire('4QPRO'));

});

parcelRegister("2UzwX", function(module, exports) {

let $21ec5f631da0fdef$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $21ec5f631da0fdef$var$load("708J7"),
    $21ec5f631da0fdef$var$load("kVqUf"),
    $21ec5f631da0fdef$var$load("j03Pa"),
    $21ec5f631da0fdef$var$load("2IMxh"),
    $21ec5f631da0fdef$var$load("98tcg"),
    $21ec5f631da0fdef$var$load("kke1I"),
    $21ec5f631da0fdef$var$load("gOwMq"),
    $21ec5f631da0fdef$var$load("6GfaN")
]).then(()=>parcelRequire('7iP7s'));

});

parcelRegister("iAWkb", function(module, exports) {

let $d898d4d24af7e249$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d898d4d24af7e249$var$load("d91RK"),
    $d898d4d24af7e249$var$load("f7hfJ"),
    $d898d4d24af7e249$var$load("brdRT"),
    $d898d4d24af7e249$var$load("QI1kr"),
    $d898d4d24af7e249$var$load("5LvhC"),
    $d898d4d24af7e249$var$load("lWBlc"),
    $d898d4d24af7e249$var$load("s2EmI"),
    $d898d4d24af7e249$var$load("jc0YL")
]).then(()=>parcelRequire('1mk9s'));

});

parcelRegister("eaC3G", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $iZ8sH = parcelRequire("iZ8sH");


var $6L2pn = parcelRequire("6L2pn");











var $lmzCg = parcelRequire("lmzCg");


var $gq8Du = parcelRequire("gq8Du");











var $k12R1 = parcelRequire("k12R1");


var $iMnC5 = parcelRequire("iMnC5");


var $8VFFa = parcelRequire("8VFFa");

// Note: this is also used in `drag-handle.tsx`
const $b9dab4e96f655813$var$dragHandleDisplayVar = '--drag-handle-display';
const $b9dab4e96f655813$var$dragCursorAnimation = null;
const $b9dab4e96f655813$var$topLevelSiblingStyles = {
    root: "_kqswh2mm _1e0c1txw _2lx21bp4"
};
const $b9dab4e96f655813$var$styles = {
    hasDragIndicator: "_1ifmglyw _1cykglyw _e0jc1txw _fxw76b4r _avx0ru3m _1rnc1amc _132yq7pw"
};
const $b9dab4e96f655813$export$f9bcea5c2cbf8443 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function DragIndicatorWrapper(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { children: children, hasDragIndicator: hasDragIndicator } = t0;
    if (hasDragIndicator) {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = (0, $k12R1.cx)($b9dab4e96f655813$var$topLevelSiblingStyles.root, $b9dab4e96f655813$var$styles.hasDragIndicator);
            $[0] = t1;
        } else t1 = $[0];
        let t2;
        if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8VFFa.DragHandle), null);
            $[1] = t2;
        } else t2 = $[1];
        let t3;
        if ($[2] !== children) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
                xcss: t1
            }, children, t2);
            $[2] = children;
            $[3] = t3;
        } else t3 = $[3];
        return t3;
    }
    let t1;
    if ($[4] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        $[4] = children;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
} : function DragIndicatorWrapper({ children: children, hasDragIndicator: hasDragIndicator }) {
    if (hasDragIndicator) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: (0, $k12R1.cx)($b9dab4e96f655813$var$topLevelSiblingStyles.root, $b9dab4e96f655813$var$styles.hasDragIndicator)
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8VFFa.DragHandle), null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};


var $igMdc = parcelRequire("igMdc");

const $28ae02d101b3371f$var$isMenuComponentDraggableItemConfig = (shortcut)=>{
    return !!(shortcut?.isReorderable && shortcut?.menuItemId);
};
const $28ae02d101b3371f$export$9de4dadf420d5c24 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function MenuComponentItem(t0) {
    const $ = (0, $bDgLe.c)(11);
    const { shortcut: shortcut, onClick: onClick, dragAndDropEnabled: dragAndDropEnabled, isInMoreMenu: isInMoreMenu } = t0;
    let t1;
    if ($[0] !== onClick || $[1] !== shortcut) {
        t1 = ()=>{
            onClick?.();
            shortcut.onClick?.();
        };
        $[0] = onClick;
        $[1] = shortcut;
        $[2] = t1;
    } else t1 = $[2];
    const handleClick = t1;
    if (dragAndDropEnabled && $28ae02d101b3371f$var$isMenuComponentDraggableItemConfig(shortcut)) {
        let t2;
        if ($[3] !== handleClick || $[4] !== isInMoreMenu || $[5] !== shortcut) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($28ae02d101b3371f$var$MenuComponentDraggableItem, {
                shortcut: shortcut,
                onClick: handleClick,
                isInMoreMenu: isInMoreMenu
            });
            $[3] = handleClick;
            $[4] = isInMoreMenu;
            $[5] = shortcut;
            $[6] = t2;
        } else t2 = $[6];
        return t2;
    }
    let t2;
    if ($[7] !== handleClick || $[8] !== isInMoreMenu || $[9] !== shortcut) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($28ae02d101b3371f$var$MenuComponentNonDraggableItem, {
            onClick: handleClick,
            shortcut: shortcut,
            isInMoreMenu: isInMoreMenu
        });
        $[7] = handleClick;
        $[8] = isInMoreMenu;
        $[9] = shortcut;
        $[10] = t2;
    } else t2 = $[10];
    return t2;
} : function MenuComponentItem({ shortcut: shortcut, onClick: onClick, dragAndDropEnabled: dragAndDropEnabled, isInMoreMenu: isInMoreMenu }) {
    const handleClick = (0, $cozmU.useCallback)(()=>{
        onClick?.();
        shortcut.onClick?.();
    }, [
        onClick,
        shortcut
    ]);
    if (dragAndDropEnabled && $28ae02d101b3371f$var$isMenuComponentDraggableItemConfig(shortcut)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($28ae02d101b3371f$var$MenuComponentDraggableItem, {
        shortcut: shortcut,
        onClick: handleClick,
        isInMoreMenu: isInMoreMenu
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($28ae02d101b3371f$var$MenuComponentNonDraggableItem, {
        onClick: handleClick,
        shortcut: shortcut,
        isInMoreMenu: isInMoreMenu
    });
};
const $28ae02d101b3371f$var$MenuComponentNonDraggableItem = (0, $gtMdU.isReactCompilerActivePlatform)() ? function MenuComponentNonDraggableItem(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { shortcut: shortcut, onClick: onClick, isInMoreMenu: isInMoreMenu } = t0;
    const ItemWrapper = shortcut?.ItemWrapper ?? (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment;
    const Component = shortcut.component;
    let t1;
    if ($[0] !== Component || $[1] !== isInMoreMenu || $[2] !== onClick) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
            onClick: onClick,
            isInMoreMenu: isInMoreMenu
        });
        $[0] = Component;
        $[1] = isInMoreMenu;
        $[2] = onClick;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== ItemWrapper || $[5] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ItemWrapper, null, t1);
        $[4] = ItemWrapper;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : function MenuComponentNonDraggableItem({ shortcut: shortcut, onClick: onClick, isInMoreMenu: isInMoreMenu }) {
    const ItemWrapper = shortcut?.ItemWrapper ?? (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment;
    const Component = shortcut.component;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ItemWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
        onClick: onClick,
        isInMoreMenu: isInMoreMenu
    }));
};
const $28ae02d101b3371f$var$MenuComponentDraggableItem = (0, $gtMdU.isReactCompilerActivePlatform)() ? function MenuComponentDraggableItem(t0) {
    const $ = (0, $bDgLe.c)(32);
    const { shortcut: shortcut, onClick: onClick, isInMoreMenu: isInMoreMenu } = t0;
    const Component = shortcut.component;
    const ItemWrapper = shortcut?.ItemWrapper ?? (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment;
    const [isExpandOrFlyoutOpen, setIsExpandOrFlyoutOpen] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (open)=>{
            setIsExpandOrFlyoutOpen(open);
        };
        $[0] = t1;
    } else t1 = $[0];
    const onExpandFlyoutToggle = t1;
    let t2;
    if ($[1] !== Component || $[2] !== shortcut.isReorderable || $[3] !== shortcut.label || $[4] !== shortcut.labelElem) {
        t2 = {
            type: "custom",
            elemBefore: null,
            label: shortcut.label,
            labelElem: shortcut.labelElem,
            isReorderable: shortcut.isReorderable,
            Component: Component,
            isDraggable: true
        };
        $[1] = Component;
        $[2] = shortcut.isReorderable;
        $[3] = shortcut.label;
        $[4] = shortcut.labelElem;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== isExpandOrFlyoutOpen || $[7] !== shortcut.menuItemId || $[8] !== t2) {
        t3 = {
            id: shortcut.menuItemId,
            isExpandable: true,
            isExpandOrFlyoutOpen: isExpandOrFlyoutOpen,
            l1DragAndDropEnabled: true,
            onExpandFlyoutToggle: onExpandFlyoutToggle,
            peek: false,
            item: t2,
            group: (0, $gq8Du.L1_MENU_GROUPS).SHORTCUTS
        };
        $[6] = isExpandOrFlyoutOpen;
        $[7] = shortcut.menuItemId;
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    const hookProps = t3;
    const { draggableRef: draggableRef, isDragging: isDragging, maybeDragPreview: maybeDragPreview, dropTargetRef: dropTargetRef, dropIndicator: dropIndicator } = (0, $igMdc.useL1ItemDragAndDrop)(hookProps);
    if (draggableRef === undefined || dropIndicator === undefined || dropTargetRef === undefined) {
        let t4;
        if ($[10] !== isInMoreMenu || $[11] !== onClick || $[12] !== shortcut) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($28ae02d101b3371f$var$MenuComponentNonDraggableItem, {
                shortcut: shortcut,
                onClick: onClick,
                isInMoreMenu: isInMoreMenu
            });
            $[10] = isInMoreMenu;
            $[11] = onClick;
            $[12] = shortcut;
            $[13] = t4;
        } else t4 = $[13];
        return t4;
    }
    const t4 = shortcut?.ref;
    let t5;
    if ($[14] !== draggableRef || $[15] !== t4) {
        t5 = (0, $lmzCg.default)([
            draggableRef,
            t4
        ]);
        $[14] = draggableRef;
        $[15] = t4;
        $[16] = t5;
    } else t5 = $[16];
    let t6;
    if ($[17] !== Component || $[18] !== dropIndicator || $[19] !== dropTargetRef || $[20] !== isDragging || $[21] !== isExpandOrFlyoutOpen || $[22] !== isInMoreMenu || $[23] !== onClick || $[24] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
            draggableRef: t5,
            dropIndicator: dropIndicator,
            hasDragIndicator: true,
            isDragging: isDragging,
            visualContentRef: dropTargetRef,
            onClick: onClick,
            isInMoreMenu: isInMoreMenu,
            isExpandOrFlyoutOpen: isExpandOrFlyoutOpen,
            onExpandFlyoutToggle: onExpandFlyoutToggle
        });
        $[17] = Component;
        $[18] = dropIndicator;
        $[19] = dropTargetRef;
        $[20] = isDragging;
        $[21] = isExpandOrFlyoutOpen;
        $[22] = isInMoreMenu;
        $[23] = onClick;
        $[24] = t5;
        $[25] = t6;
    } else t6 = $[25];
    let t7;
    if ($[26] !== ItemWrapper || $[27] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ItemWrapper, null, t6);
        $[26] = ItemWrapper;
        $[27] = t6;
        $[28] = t7;
    } else t7 = $[28];
    let t8;
    if ($[29] !== maybeDragPreview || $[30] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b9dab4e96f655813$export$f9bcea5c2cbf8443), {
            hasDragIndicator: true
        }, t7, maybeDragPreview);
        $[29] = maybeDragPreview;
        $[30] = t7;
        $[31] = t8;
    } else t8 = $[31];
    return t8;
} : function MenuComponentDraggableItem({ shortcut: shortcut, onClick: onClick, isInMoreMenu: isInMoreMenu }) {
    const Component = shortcut.component;
    const ItemWrapper = shortcut?.ItemWrapper ?? (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment;
    const [isExpandOrFlyoutOpen, setIsExpandOrFlyoutOpen] = (0, $cozmU.useState)(false);
    const onExpandFlyoutToggle = (0, $cozmU.useCallback)((open)=>{
        setIsExpandOrFlyoutOpen(open);
    }, []);
    const hookProps = (0, $cozmU.useMemo)(()=>({
            id: shortcut.menuItemId,
            isExpandable: true,
            isExpandOrFlyoutOpen: isExpandOrFlyoutOpen,
            l1DragAndDropEnabled: true,
            onExpandFlyoutToggle: onExpandFlyoutToggle,
            peek: false,
            item: {
                type: 'custom',
                elemBefore: null,
                label: shortcut.label,
                labelElem: shortcut.labelElem,
                isReorderable: shortcut.isReorderable,
                Component: Component,
                isDraggable: true
            },
            group: (0, $gq8Du.L1_MENU_GROUPS).SHORTCUTS
        }), [
        shortcut.label,
        shortcut.menuItemId,
        shortcut.labelElem,
        Component,
        shortcut.isReorderable,
        isExpandOrFlyoutOpen,
        onExpandFlyoutToggle
    ]);
    const { draggableRef: draggableRef, isDragging: isDragging, maybeDragPreview: maybeDragPreview, dropTargetRef: dropTargetRef, dropIndicator: dropIndicator } = (0, $igMdc.useL1ItemDragAndDrop)(hookProps);
    if (draggableRef === undefined || dropIndicator === undefined || dropTargetRef === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($28ae02d101b3371f$var$MenuComponentNonDraggableItem, {
        shortcut: shortcut,
        onClick: onClick,
        isInMoreMenu: isInMoreMenu
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b9dab4e96f655813$export$f9bcea5c2cbf8443), {
        hasDragIndicator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ItemWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
        draggableRef: (0, $lmzCg.default)([
            draggableRef,
            shortcut?.ref
        ]),
        dropIndicator: dropIndicator,
        hasDragIndicator: true,
        isDragging: isDragging,
        visualContentRef: dropTargetRef,
        onClick: onClick,
        isInMoreMenu: isInMoreMenu,
        isExpandOrFlyoutOpen: isExpandOrFlyoutOpen,
        onExpandFlyoutToggle: onExpandFlyoutToggle
    })), maybeDragPreview);
};












var $aIlZA = parcelRequire("aIlZA");





var $852mP = parcelRequire("852mP");








var $V3JOP = parcelRequire("V3JOP");


var $huaOC = parcelRequire("huaOC");








var $cXPtd = parcelRequire("cXPtd");











var $cbY7C = parcelRequire("cbY7C");

const $e74a3fb6aa1e8ce6$export$8209b3c2d1620841 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { onFocus: onFocus, onMouseEnter: onMouseEnter, onRightClick: onRightClick, children: children } = t0;
    const wrapperRef = (0, $cozmU.useRef)(null);
    let t1;
    let t2;
    if ($[0] !== onRightClick) {
        t1 = ()=>{
            if (!wrapperRef.current || !onRightClick) return;
            const handleMouseDown = (e)=>{
                const isLink = e.target.closest("a");
                if (isLink && e.button !== 0) onRightClick();
            };
            const unbind = (0, $cbY7C.bind)(wrapperRef.current, {
                type: "mousedown",
                listener: handleMouseDown
            });
            return unbind;
        };
        t2 = [
            onRightClick
        ];
        $[0] = onRightClick;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[3] !== children || $[4] !== onFocus || $[5] !== onMouseEnter) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            ref: wrapperRef,
            onMouseEnter: onMouseEnter,
            onFocus: onFocus
        }, children);
        $[3] = children;
        $[4] = onFocus;
        $[5] = onMouseEnter;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ({ onFocus: onFocus, onMouseEnter: onMouseEnter, onRightClick: onRightClick, children: children })=>{
    const wrapperRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        if (!wrapperRef.current || !onRightClick) return;
        const handleMouseDown = (e)=>{
            const isLink = e.target.closest('a');
            if (isLink && e.button !== 0) onRightClick();
        };
        const unbind = (0, $cbY7C.bind)(wrapperRef.current, {
            type: 'mousedown',
            listener: handleMouseDown
        });
        return unbind;
    }, [
        onRightClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        ref: wrapperRef,
        onMouseEnter: onMouseEnter,
        onFocus: onFocus
    }, children);
};












var $3bmmh = parcelRequire("3bmmh");

const $552721561f4f1f78$export$eae7963fc47ca0d0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useDragAndDropOptions() {
    const $ = (0, $bDgLe.c)(3);
    const context = (0, $cozmU.useContext)((0, $3bmmh.DragAndDropOptionsContext));
    if (!context) {
        let t0;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = {
                enabled: false
            };
            $[0] = t0;
        } else t0 = $[0];
        return t0;
    }
    let t0;
    if ($[1] !== context.enabled) {
        t0 = {
            enabled: context.enabled
        };
        $[1] = context.enabled;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : function useDragAndDropOptions() {
    const context = (0, $cozmU.useContext)((0, $3bmmh.DragAndDropOptionsContext));
    if (!context) return {
        enabled: false
    };
    return {
        enabled: context.enabled
    };
};





















var $1sCHt = parcelRequire("1sCHt");


var $gFEZF = parcelRequire("gFEZF");


var $9d7Pd = parcelRequire("9d7Pd");

var $6IL1T = parcelRequire("6IL1T");


var $ixfCV = parcelRequire("ixfCV");


var $5wHqn = parcelRequire("5wHqn");







const $57358e7cb8a2df4e$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    shortcutActionOpenMenuLabel: {
        id: "navigation.global-shortcuts.shortcut-action.open-menu-label",
        defaultMessage: "open menu"
    }
});


const $cf64808be0ffbc08$export$7e648395389e18b0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { actions: actions, analyticsName: analyticsName } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] !== analyticsName || $[1] !== createAnalyticsEvent) {
        t1 = ()=>{
            setIsOpen(true);
            $cf64808be0ffbc08$var$fireShortcutActionMenuClickedAnalyticsEvent(createAnalyticsEvent, analyticsName);
        };
        $[0] = analyticsName;
        $[1] = createAnalyticsEvent;
        $[2] = t1;
    } else t1 = $[2];
    const handleClick = t1;
    let t2;
    if ($[3] !== createAnalyticsEvent) {
        t2 = (itemId)=>{
            $cf64808be0ffbc08$var$fireShortcutActionDropdownItemClickedAnalyticsEvent(createAnalyticsEvent, itemId);
        };
        $[3] = createAnalyticsEvent;
        $[4] = t2;
    } else t2 = $[4];
    const handleDropdownItemClick = t2;
    let t3;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>setIsOpen(false);
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== actions || $[7] !== handleDropdownItemClick) {
        t4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6IL1T.default), null, actions.map((action, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cf64808be0ffbc08$var$ButtonItemWithAnalytics, {
                    index: index,
                    action: action,
                    fireShortcutActionDropdownItemClickedAnalyticsEvent: handleDropdownItemClick,
                    setIsOpen: setIsOpen
                })));
        $[6] = actions;
        $[7] = handleDropdownItemClick;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== formatMessage || $[10] !== handleClick) {
        t5 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                ...triggerProps,
                appearance: "subtle",
                spacing: "compact",
                icon: $cf64808be0ffbc08$var$_temp,
                label: formatMessage((0, $57358e7cb8a2df4e$export$defe85febe8b728c).shortcutActionOpenMenuLabel),
                onClick: handleClick
            });
        $[9] = formatMessage;
        $[10] = handleClick;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] !== isOpen || $[13] !== t4 || $[14] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.Popup), {
            shouldRenderToParent: true,
            isOpen: isOpen,
            onClose: t3,
            placement: "bottom-start",
            content: t4,
            trigger: t5
        });
        $[12] = isOpen;
        $[13] = t4;
        $[14] = t5;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
} : ({ actions: actions, analyticsName: analyticsName })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const handleClick = (0, $cozmU.useCallback)(()=>{
        setIsOpen(true);
        $cf64808be0ffbc08$var$fireShortcutActionMenuClickedAnalyticsEvent(createAnalyticsEvent, analyticsName);
    }, [
        createAnalyticsEvent,
        analyticsName,
        setIsOpen
    ]);
    const handleDropdownItemClick = (0, $cozmU.useCallback)((itemId)=>{
        $cf64808be0ffbc08$var$fireShortcutActionDropdownItemClickedAnalyticsEvent(createAnalyticsEvent, itemId);
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.Popup), {
        shouldRenderToParent: true,
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "bottom-start",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6IL1T.default), null, actions.map((action, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cf64808be0ffbc08$var$ButtonItemWithAnalytics, {
                    index: index,
                    action: action,
                    fireShortcutActionDropdownItemClickedAnalyticsEvent: handleDropdownItemClick,
                    setIsOpen: setIsOpen
                }))),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                ...triggerProps,
                appearance: "subtle",
                spacing: "compact",
                icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))), {
                        ...props,
                        size: "small"
                    }),
                label: formatMessage((0, $57358e7cb8a2df4e$export$defe85febe8b728c).shortcutActionOpenMenuLabel),
                onClick: handleClick
            })
    });
};
const $cf64808be0ffbc08$var$ButtonItemWithAnalytics = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { index: index, action: action, fireShortcutActionDropdownItemClickedAnalyticsEvent: fireShortcutActionDropdownItemClickedAnalyticsEvent, setIsOpen: setIsOpen } = t0;
    let t1;
    if ($[0] !== action || $[1] !== fireShortcutActionDropdownItemClickedAnalyticsEvent || $[2] !== setIsOpen) {
        t1 = (e)=>{
            e.preventDefault();
            action.onClick?.();
            if ((0, $ixfCV.fg)("navx-global-side-nav-confluence")) fireShortcutActionDropdownItemClickedAnalyticsEvent(action.itemId);
            setIsOpen(false);
        };
        $[0] = action;
        $[1] = fireShortcutActionDropdownItemClickedAnalyticsEvent;
        $[2] = setIsOpen;
        $[3] = t1;
    } else t1 = $[3];
    const handleClick = t1;
    let t2;
    if ($[4] !== action.component || $[5] !== handleClick || $[6] !== index) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
            key: index,
            onClick: handleClick
        }, action.component);
        $[4] = action.component;
        $[5] = handleClick;
        $[6] = index;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : ({ index: index, action: action, fireShortcutActionDropdownItemClickedAnalyticsEvent: fireShortcutActionDropdownItemClickedAnalyticsEvent, setIsOpen: setIsOpen })=>{
    const handleClick = (0, $cozmU.useCallback)((e)=>{
        e.preventDefault();
        action.onClick?.();
        if ((0, $ixfCV.fg)('navx-global-side-nav-confluence')) fireShortcutActionDropdownItemClickedAnalyticsEvent(action.itemId);
        setIsOpen(false);
    }, [
        action,
        fireShortcutActionDropdownItemClickedAnalyticsEvent,
        setIsOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
        key: index,
        onClick: handleClick
    }, action.component);
};
const $cf64808be0ffbc08$var$fireShortcutActionMenuClickedAnalyticsEvent = (createAnalyticsEvent, analyticsName)=>{
    createAnalyticsEvent({
        eventType: (0, $852mP.UI_EVENT_TYPE),
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'ShortcutActionMenu',
        attributes: {
            name: analyticsName
        }
    }).fire((0, $cXPtd.ANALYTICS_CHANNEL));
};
const $cf64808be0ffbc08$var$fireShortcutActionDropdownItemClickedAnalyticsEvent = (createAnalyticsEvent, itemId)=>{
    createAnalyticsEvent({
        eventType: (0, $852mP.UI_EVENT_TYPE),
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'ShortcutActionDropdownItem',
        attributes: {
            itemId: itemId
        }
    }).fire((0, $cXPtd.ANALYTICS_CHANNEL));
};
function $cf64808be0ffbc08$var$_temp(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))), {
        ...props,
        size: "small"
    });
}





const $d4deb4c891b09149$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    linkExternalIconLabel: {
        id: "navigation.global-shortcuts.menu-link-item.link-external-item-label",
        defaultMessage: "Open external link icon"
    }
});


const $4436fe58c5f22254$export$18a13ecc162cd5c2 = (createAnalyticsEvent, analyticsName)=>{
    createAnalyticsEvent({
        eventType: (0, $852mP.UI_EVENT_TYPE),
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'globalNavigation',
        attributes: {
            name: analyticsName
        }
    }).fire((0, $cXPtd.ANALYTICS_CHANNEL));
};
/**
 * Utility to return whether actions and options should be shown
 */ const $4436fe58c5f22254$var$getShouldShowActionsAndOptions = (actions, optionsMenuElem)=>actions && actions.length >= 0 || !!optionsMenuElem;
/**
 * Actions and Options component to render both the action menu and options menu
 * beside each other on hover/focus
 */ const $4436fe58c5f22254$var$ActionsAndOptions = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { actions: actions, analyticsName: analyticsName, optionsMenuElem: optionsMenuElem } = t0;
    let t1;
    if ($[0] !== actions || $[1] !== analyticsName) {
        t1 = actions && actions.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cf64808be0ffbc08$export$7e648395389e18b0), {
            actions: actions,
            analyticsName: analyticsName
        });
        $[0] = actions;
        $[1] = analyticsName;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== optionsMenuElem || $[4] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t1, optionsMenuElem);
        $[3] = optionsMenuElem;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ actions: actions, analyticsName: analyticsName, optionsMenuElem: optionsMenuElem })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, actions && actions.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cf64808be0ffbc08$export$7e648395389e18b0), {
        actions: actions,
        analyticsName: analyticsName
    }), optionsMenuElem);
const $4436fe58c5f22254$var$MenuLinkItemComponent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(26);
    const { url: url, label: label, labelElem: labelElem, icon: icon, ariaLabel: ariaLabel, actions: actions, onClick: onClick, optionalRef: optionalRef, isSelected: isSelected, openInSameTab: openInSameTab, optionsMenuElem: optionsMenuElem, analyticsName: analyticsName } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== optionalRef) {
        t1 = (0, $lmzCg.default)(optionalRef ? [
            optionalRef
        ] : []);
        $[0] = optionalRef;
        $[1] = t1;
    } else t1 = $[1];
    const mergedRefs = t1;
    let t2;
    if ($[2] !== actions || $[3] !== optionsMenuElem) {
        t2 = $4436fe58c5f22254$var$getShouldShowActionsAndOptions(actions, optionsMenuElem);
        $[2] = actions;
        $[3] = optionsMenuElem;
        $[4] = t2;
    } else t2 = $[4];
    const shouldShowActionsAndOptions = t2;
    let t3;
    if ($[5] !== actions || $[6] !== analyticsName || $[7] !== optionsMenuElem || $[8] !== shouldShowActionsAndOptions) {
        t3 = shouldShowActionsAndOptions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4436fe58c5f22254$var$ActionsAndOptions, {
            actions: actions,
            analyticsName: analyticsName,
            optionsMenuElem: optionsMenuElem
        });
        $[5] = actions;
        $[6] = analyticsName;
        $[7] = optionsMenuElem;
        $[8] = shouldShowActionsAndOptions;
        $[9] = t3;
    } else t3 = $[9];
    let t4;
    if ($[10] !== formatMessage || $[11] !== openInSameTab) {
        t4 = !openInSameTab && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))), {
            label: formatMessage((0, $d4deb4c891b09149$export$defe85febe8b728c).linkExternalIconLabel),
            size: "small",
            spacing: "spacious"
        });
        $[10] = formatMessage;
        $[11] = openInSameTab;
        $[12] = t4;
    } else t4 = $[12];
    const t5 = url || "";
    const t6 = openInSameTab ? "_self" : "_blank";
    const t7 = labelElem ?? label;
    let t8;
    if ($[13] !== ariaLabel || $[14] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "aria-label": ariaLabel
        }, t7);
        $[13] = ariaLabel;
        $[14] = t7;
        $[15] = t8;
    } else t8 = $[15];
    let t9;
    if ($[16] !== icon || $[17] !== isSelected || $[18] !== mergedRefs || $[19] !== onClick || $[20] !== t3 || $[21] !== t4 || $[22] !== t5 || $[23] !== t6 || $[24] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $huaOC.LinkMenuItem), {
            actionsOnHover: t3,
            elemBefore: icon,
            elemAfter: t4,
            href: t5,
            target: t6,
            onClick: onClick,
            ref: mergedRefs,
            isSelected: isSelected
        }, t8);
        $[16] = icon;
        $[17] = isSelected;
        $[18] = mergedRefs;
        $[19] = onClick;
        $[20] = t3;
        $[21] = t4;
        $[22] = t5;
        $[23] = t6;
        $[24] = t8;
        $[25] = t9;
    } else t9 = $[25];
    return t9;
} : ({ url: url, label: label, labelElem: labelElem, icon: icon, ariaLabel: ariaLabel, actions: actions, onClick: onClick, optionalRef: optionalRef, isSelected: isSelected, openInSameTab: openInSameTab, optionsMenuElem: optionsMenuElem, analyticsName: analyticsName })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const mergedRefs = (0, $lmzCg.default)(optionalRef ? [
        optionalRef
    ] : []);
    const shouldShowActionsAndOptions = $4436fe58c5f22254$var$getShouldShowActionsAndOptions(actions, optionsMenuElem);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $huaOC.LinkMenuItem), {
        actionsOnHover: shouldShowActionsAndOptions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4436fe58c5f22254$var$ActionsAndOptions, {
            actions: actions,
            analyticsName: analyticsName,
            optionsMenuElem: optionsMenuElem
        }),
        elemBefore: icon,
        elemAfter: !openInSameTab && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))), {
            label: formatMessage((0, $d4deb4c891b09149$export$defe85febe8b728c).linkExternalIconLabel),
            size: "small",
            spacing: "spacious"
        }),
        href: url || '',
        target: openInSameTab ? '_self' : '_blank',
        onClick: onClick,
        ref: mergedRefs,
        isSelected: isSelected
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "aria-label": ariaLabel
    }, labelElem ?? label));
};
const $4436fe58c5f22254$var$MenuLinkItemDraggableComponent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(43);
    const { url: url, label: label, labelElem: labelElem, icon: icon, ariaLabel: ariaLabel, actions: actions, onClick: onClick, isReorderable: isReorderable, optionalRef: optionalRef, menuItemId: menuItemId, openInSameTab: openInSameTab, optionsMenuElem: optionsMenuElem, analyticsName: analyticsName, isSelected: isSelected } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { enabled: enabled } = (0, $552721561f4f1f78$export$eae7963fc47ca0d0)();
    const t1 = url || "";
    let t2;
    if ($[0] !== icon || $[1] !== isReorderable || $[2] !== label || $[3] !== labelElem || $[4] !== t1) {
        t2 = {
            type: "link",
            elemBefore: icon,
            label: label,
            labelElem: labelElem,
            href: t1,
            isReorderable: isReorderable
        };
        $[0] = icon;
        $[1] = isReorderable;
        $[2] = label;
        $[3] = labelElem;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== enabled || $[7] !== menuItemId || $[8] !== t2) {
        t3 = {
            id: menuItemId,
            isExpandable: false,
            isExpandOrFlyoutOpen: false,
            l1DragAndDropEnabled: enabled,
            onExpandFlyoutToggle: $4436fe58c5f22254$var$_temp,
            peek: false,
            item: t2,
            group: (0, $gq8Du.L1_MENU_GROUPS).SHORTCUTS
        };
        $[6] = enabled;
        $[7] = menuItemId;
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    const { draggableRef: draggableRef, isDragging: isDragging, maybeDragPreview: maybeDragPreview, dropTargetRef: dropTargetRef, dropIndicator: dropIndicator } = (0, $igMdc.useL1ItemDragAndDrop)(t3);
    let t4;
    if ($[10] !== draggableRef || $[11] !== optionalRef) {
        const draggableRefCollection = draggableRef ? [
            draggableRef
        ] : [];
        t4 = (0, $lmzCg.default)(optionalRef ? [
            optionalRef,
            ...draggableRefCollection
        ] : [
            ...draggableRefCollection
        ]);
        $[10] = draggableRef;
        $[11] = optionalRef;
        $[12] = t4;
    } else t4 = $[12];
    const mergedRefs = t4;
    let t5;
    if ($[13] !== actions || $[14] !== optionsMenuElem) {
        t5 = $4436fe58c5f22254$var$getShouldShowActionsAndOptions(actions, optionsMenuElem);
        $[13] = actions;
        $[14] = optionsMenuElem;
        $[15] = t5;
    } else t5 = $[15];
    const shouldShowActionsAndOptions = t5;
    let t6;
    if ($[16] !== actions || $[17] !== analyticsName || $[18] !== optionsMenuElem || $[19] !== shouldShowActionsAndOptions) {
        t6 = shouldShowActionsAndOptions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4436fe58c5f22254$var$ActionsAndOptions, {
            actions: actions,
            analyticsName: analyticsName,
            optionsMenuElem: optionsMenuElem
        });
        $[16] = actions;
        $[17] = analyticsName;
        $[18] = optionsMenuElem;
        $[19] = shouldShowActionsAndOptions;
        $[20] = t6;
    } else t6 = $[20];
    let t7;
    if ($[21] !== formatMessage || $[22] !== openInSameTab) {
        t7 = !openInSameTab && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))), {
            label: formatMessage((0, $d4deb4c891b09149$export$defe85febe8b728c).linkExternalIconLabel),
            size: "small",
            spacing: "spacious"
        });
        $[21] = formatMessage;
        $[22] = openInSameTab;
        $[23] = t7;
    } else t7 = $[23];
    const t8 = url || "";
    const t9 = openInSameTab ? "_self" : "_blank";
    const t10 = labelElem ?? label;
    let t11;
    if ($[24] !== ariaLabel || $[25] !== t10) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "aria-label": ariaLabel
        }, t10);
        $[24] = ariaLabel;
        $[25] = t10;
        $[26] = t11;
    } else t11 = $[26];
    let t12;
    if ($[27] !== dropIndicator || $[28] !== dropTargetRef || $[29] !== icon || $[30] !== isDragging || $[31] !== isSelected || $[32] !== mergedRefs || $[33] !== onClick || $[34] !== t11 || $[35] !== t6 || $[36] !== t7 || $[37] !== t8 || $[38] !== t9) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $huaOC.LinkMenuItem), {
            isDragging: isDragging,
            hasDragIndicator: true,
            ref: mergedRefs,
            dropIndicator: dropIndicator,
            visualContentRef: dropTargetRef,
            actionsOnHover: t6,
            elemBefore: icon,
            elemAfter: t7,
            href: t8,
            target: t9,
            isSelected: isSelected,
            onClick: onClick
        }, t11);
        $[27] = dropIndicator;
        $[28] = dropTargetRef;
        $[29] = icon;
        $[30] = isDragging;
        $[31] = isSelected;
        $[32] = mergedRefs;
        $[33] = onClick;
        $[34] = t11;
        $[35] = t6;
        $[36] = t7;
        $[37] = t8;
        $[38] = t9;
        $[39] = t12;
    } else t12 = $[39];
    let t13;
    if ($[40] !== maybeDragPreview || $[41] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t12, maybeDragPreview);
        $[40] = maybeDragPreview;
        $[41] = t12;
        $[42] = t13;
    } else t13 = $[42];
    return t13;
} : ({ url: url, label: label, labelElem: labelElem, icon: icon, ariaLabel: ariaLabel, actions: actions, onClick: onClick, isReorderable: isReorderable, optionalRef: optionalRef, menuItemId: menuItemId, openInSameTab: openInSameTab, optionsMenuElem: optionsMenuElem, analyticsName: analyticsName, isSelected: isSelected })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { enabled: enabled } = (0, $552721561f4f1f78$export$eae7963fc47ca0d0)();
    const { draggableRef: draggableRef, isDragging: isDragging, maybeDragPreview: maybeDragPreview, dropTargetRef: dropTargetRef, dropIndicator: dropIndicator } = (0, $igMdc.useL1ItemDragAndDrop)({
        id: menuItemId,
        isExpandable: false,
        isExpandOrFlyoutOpen: false,
        l1DragAndDropEnabled: enabled,
        onExpandFlyoutToggle: ()=>{},
        peek: false,
        item: {
            type: 'link',
            elemBefore: icon,
            label: label,
            labelElem: labelElem,
            href: url || '',
            isReorderable: isReorderable
        },
        group: (0, $gq8Du.L1_MENU_GROUPS).SHORTCUTS
    });
    // Can possibly be undefined
    const draggableRefCollection = draggableRef ? [
        draggableRef
    ] : [];
    const mergedRefs = (0, $lmzCg.default)(optionalRef ? [
        optionalRef,
        ...draggableRefCollection
    ] : [
        ...draggableRefCollection
    ]);
    const shouldShowActionsAndOptions = $4436fe58c5f22254$var$getShouldShowActionsAndOptions(actions, optionsMenuElem);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $huaOC.LinkMenuItem), {
        isDragging: isDragging,
        hasDragIndicator: true,
        ref: mergedRefs,
        dropIndicator: dropIndicator,
        visualContentRef: dropTargetRef,
        actionsOnHover: shouldShowActionsAndOptions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4436fe58c5f22254$var$ActionsAndOptions, {
            actions: actions,
            analyticsName: analyticsName,
            optionsMenuElem: optionsMenuElem
        }),
        elemBefore: icon,
        elemAfter: !openInSameTab && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))), {
            label: formatMessage((0, $d4deb4c891b09149$export$defe85febe8b728c).linkExternalIconLabel),
            size: "small",
            spacing: "spacious"
        }),
        href: url || '',
        target: openInSameTab ? '_self' : '_blank',
        isSelected: isSelected,
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "aria-label": ariaLabel
    }, labelElem ?? label)), maybeDragPreview);
};
const $4436fe58c5f22254$export$68ef190193a37bc2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(30);
    const { analyticsName: analyticsName, url: url, label: label, labelElem: labelElem, icon: icon, ariaLabel: ariaLabel, actions: actions, onClick: onClick, onRightClick: onRightClick, onFocus: onFocus, onMouseEnter: onMouseEnter, optionalRef: optionalRef, isReorderable: isReorderable, menuItemId: menuItemId, isSelected: isSelected, product: t1, openInSameTab: openInSameTab } = t0;
    const product = t1 === undefined ? "globalNavigation" : t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { enabled: dndEnabled } = (0, $552721561f4f1f78$export$eae7963fc47ca0d0)();
    let t2;
    if ($[0] !== product) {
        t2 = {
            bridge: "globalShortcuts",
            product: product
        };
        $[0] = product;
        $[1] = t2;
    } else t2 = $[1];
    const analyticsUrlWrapper = (0, $aIlZA.default)(t2);
    let t3;
    if ($[2] !== analyticsUrlWrapper) {
        t3 = (url_0)=>{
            if (!$4436fe58c5f22254$var$isValidUrl(url_0)) return url_0;
            try {
                const parsedUrl = new URL(url_0);
                const continueParam = parsedUrl.searchParams.get("continue");
                if (!continueParam) return analyticsUrlWrapper(url_0);
                const wrappedContinueUrl = analyticsUrlWrapper(continueParam);
                parsedUrl.searchParams.set("continue", wrappedContinueUrl);
                return parsedUrl.toString();
            } catch  {
                return url_0;
            }
        };
        $[2] = analyticsUrlWrapper;
        $[3] = t3;
    } else t3 = $[3];
    const getTargetUrl = t3;
    let t4;
    if ($[4] !== analyticsName || $[5] !== createAnalyticsEvent || $[6] !== onClick) {
        t4 = (event)=>{
            $4436fe58c5f22254$export$18a13ecc162cd5c2(createAnalyticsEvent, analyticsName);
            onClick?.(event);
        };
        $[4] = analyticsName;
        $[5] = createAnalyticsEvent;
        $[6] = onClick;
        $[7] = t4;
    } else t4 = $[7];
    const onClickMenuLinkItem = t4;
    if (!url) return null;
    let t5;
    if ($[8] !== getTargetUrl || $[9] !== url) {
        t5 = getTargetUrl(url);
        $[8] = getTargetUrl;
        $[9] = url;
        $[10] = t5;
    } else t5 = $[10];
    const targetUrl = t5;
    let t6;
    if ($[11] !== actions || $[12] !== ariaLabel || $[13] !== dndEnabled || $[14] !== icon || $[15] !== isReorderable || $[16] !== isSelected || $[17] !== label || $[18] !== labelElem || $[19] !== menuItemId || $[20] !== onClickMenuLinkItem || $[21] !== openInSameTab || $[22] !== optionalRef || $[23] !== targetUrl) {
        t6 = dndEnabled && menuItemId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4436fe58c5f22254$var$MenuLinkItemDraggableComponent, {
            optionalRef: optionalRef,
            url: targetUrl,
            icon: icon,
            ariaLabel: ariaLabel,
            label: label,
            labelElem: labelElem,
            actions: actions,
            onClick: onClickMenuLinkItem,
            isReorderable: isReorderable,
            isSelected: isSelected,
            menuItemId: menuItemId,
            openInSameTab: openInSameTab
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4436fe58c5f22254$var$MenuLinkItemComponent, {
            optionalRef: optionalRef,
            url: targetUrl,
            icon: icon,
            ariaLabel: ariaLabel,
            label: label,
            labelElem: labelElem,
            actions: actions,
            onClick: onClickMenuLinkItem,
            isReorderable: isReorderable,
            isSelected: isSelected,
            openInSameTab: openInSameTab
        });
        $[11] = actions;
        $[12] = ariaLabel;
        $[13] = dndEnabled;
        $[14] = icon;
        $[15] = isReorderable;
        $[16] = isSelected;
        $[17] = label;
        $[18] = labelElem;
        $[19] = menuItemId;
        $[20] = onClickMenuLinkItem;
        $[21] = openInSameTab;
        $[22] = optionalRef;
        $[23] = targetUrl;
        $[24] = t6;
    } else t6 = $[24];
    let t7;
    if ($[25] !== onFocus || $[26] !== onMouseEnter || $[27] !== onRightClick || $[28] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e74a3fb6aa1e8ce6$export$8209b3c2d1620841), {
            onRightClick: onRightClick,
            onMouseEnter: onMouseEnter,
            onFocus: onFocus
        }, t6);
        $[25] = onFocus;
        $[26] = onMouseEnter;
        $[27] = onRightClick;
        $[28] = t6;
        $[29] = t7;
    } else t7 = $[29];
    return t7;
} : ({ analyticsName: analyticsName, url: url, label: label, labelElem: labelElem, icon: icon, ariaLabel: ariaLabel, actions: actions, onClick: onClick, onRightClick: onRightClick, onFocus: onFocus, onMouseEnter: onMouseEnter, optionalRef: optionalRef, isReorderable: isReorderable, menuItemId: menuItemId, isSelected: isSelected, product: product = 'globalNavigation', openInSameTab: openInSameTab })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { enabled: dndEnabled } = (0, $552721561f4f1f78$export$eae7963fc47ca0d0)();
    const analyticsUrlWrapper = (0, $aIlZA.default)({
        bridge: 'globalShortcuts',
        product: product
    });
    const getTargetUrl = (0, $cozmU.useCallback)((url_0)=>{
        // For SPA links, we don't want to wrap the URL
        if (!$4436fe58c5f22254$var$isValidUrl(url_0)) return url_0;
        try {
            const parsedUrl = new URL(url_0);
            const continueParam = parsedUrl.searchParams.get('continue');
            if (!continueParam) // If there is no continue param, we just wrap the whole URL
            return analyticsUrlWrapper(url_0);
            // Safely deserialize identity links e.g: https://id.atlassian.com/login?login_hint=...
            const wrappedContinueUrl = analyticsUrlWrapper(continueParam);
            // Reconstruct the original URL with the wrapped continue param
            parsedUrl.searchParams.set('continue', wrappedContinueUrl);
            return parsedUrl.toString();
        } catch  {
            // Gracefully handle any URL parsing errors by returning the original URL
            // TODO: Log error to Sentry
            return url_0;
        }
    }, [
        analyticsUrlWrapper
    ]);
    const onClickMenuLinkItem = (0, $cozmU.useCallback)((event)=>{
        $4436fe58c5f22254$export$18a13ecc162cd5c2(createAnalyticsEvent, analyticsName);
        onClick?.(event);
    }, [
        createAnalyticsEvent,
        analyticsName,
        onClick
    ]);
    // If a shortcut doesn't have a URL, don't show it. This is a change from earlier behaviour in which
    // the shortcut would be shown, but greyed-out (disabled).
    if (!url) return null;
    const targetUrl = getTargetUrl(url);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e74a3fb6aa1e8ce6$export$8209b3c2d1620841), {
        onRightClick: onRightClick,
        onMouseEnter: onMouseEnter,
        onFocus: onFocus
    }, dndEnabled && menuItemId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4436fe58c5f22254$var$MenuLinkItemDraggableComponent, {
        optionalRef: optionalRef,
        url: targetUrl,
        icon: icon,
        ariaLabel: ariaLabel,
        label: label,
        labelElem: labelElem,
        actions: actions,
        onClick: onClickMenuLinkItem,
        isReorderable: isReorderable,
        isSelected: isSelected,
        menuItemId: menuItemId,
        openInSameTab: openInSameTab
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4436fe58c5f22254$var$MenuLinkItemComponent, {
        optionalRef: optionalRef,
        url: targetUrl,
        icon: icon,
        ariaLabel: ariaLabel,
        label: label,
        labelElem: labelElem,
        actions: actions,
        onClick: onClickMenuLinkItem,
        isReorderable: isReorderable,
        isSelected: isSelected,
        openInSameTab: openInSameTab
    }));
};
const $4436fe58c5f22254$var$isValidUrl = (urlString)=>{
    if (typeof urlString !== 'string') return false;
    try {
        return Boolean(new URL(urlString));
    } catch  {
        return false;
    }
};
function $4436fe58c5f22254$var$_temp() {}





const $8d671dcba983b0f5$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    menuLinkItemAriaLabel: {
        id: "navigation.global-shortcuts.shortcut-link-item.aria-label",
        defaultMessage: "{appName}{siteName}"
    }
});
const $8d671dcba983b0f5$export$b010a30b3233e0c5 = (0, $kSwu1.defineMessages)({
    header: {
        id: "navigation.global-shortcuts.error.header",
        defaultMessage: "We couldn\u2019t load the shortcut for {menuId}"
    },
    description: {
        id: "navigation.global-shortcuts.error.description",
        defaultMessage: "Refresh the page and try again"
    }
});


const $3ee0708e488dd620$export$af94fce1535255cc = /*#__PURE__*/ (0, $cozmU.memo)($3ee0708e488dd620$var$ShortcutMenuItemInner);
const $3ee0708e488dd620$var$isReactCompilerActivePlatform_result = (0, $gtMdU.isReactCompilerActivePlatform)();
function $3ee0708e488dd620$var$ShortcutMenuItemInner_optimized(props) {
    const $ = (0, $bDgLe.c)(8);
    const menuId = props.shortcut.key;
    let t0;
    if ($[0] !== menuId) {
        t0 = {
            menuId: menuId
        };
        $[0] = menuId;
        $[1] = t0;
    } else t0 = $[1];
    const errorMessageValues = t0;
    let t1;
    if ($[2] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3ee0708e488dd620$var$ShortcutMenuItemWithoutErrorBoundary, props);
        $[2] = props;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== errorMessageValues || $[5] !== menuId || $[6] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iZ8sH.NavErrorBoundary), {
            key: menuId,
            errorMessages: (0, $8d671dcba983b0f5$export$b010a30b3233e0c5),
            errorMessageValues: errorMessageValues,
            showFlags: true
        }, t1);
        $[4] = errorMessageValues;
        $[5] = menuId;
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
}
function $3ee0708e488dd620$export$61fd8e200e2caa97(props) {
    const menuId = props.shortcut.key;
    const errorMessageValues = (0, $cozmU.useMemo)(()=>({
            menuId: menuId
        }), [
        menuId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iZ8sH.NavErrorBoundary), {
        key: menuId,
        errorMessages: (0, $8d671dcba983b0f5$export$b010a30b3233e0c5),
        errorMessageValues: errorMessageValues,
        showFlags: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3ee0708e488dd620$var$ShortcutMenuItemWithoutErrorBoundary, props));
}
function $3ee0708e488dd620$var$ShortcutMenuItemInner(arg0) {
    if ($3ee0708e488dd620$var$isReactCompilerActivePlatform_result) return $3ee0708e488dd620$var$ShortcutMenuItemInner_optimized(arg0);
    else return $3ee0708e488dd620$export$61fd8e200e2caa97(arg0);
}
const $3ee0708e488dd620$var$ShortcutMenuItemWithoutErrorBoundary = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ShortcutMenuItemWithoutErrorBoundary(t0) {
    const $ = (0, $bDgLe.c)(52);
    const { shortcut: shortcut, dragAndDropEnabled: dragAndDropEnabled, product: product, openInSameTab: openInSameTab, isInMoreMenu: isInMoreMenu } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const labelText = shortcut.label;
    const analyticsName = shortcut.analyticsName || `unknown_${labelText}`;
    const ItemWrapper = shortcut?.ItemWrapper ?? (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment;
    let t1;
    if ($[0] !== analyticsName || $[1] !== createAnalyticsEvent) {
        t1 = ()=>{
            (0, $4436fe58c5f22254$export$18a13ecc162cd5c2)(createAnalyticsEvent, analyticsName);
        };
        $[0] = analyticsName;
        $[1] = createAnalyticsEvent;
        $[2] = t1;
    } else t1 = $[2];
    const customComponentDraggableOnClick = t1;
    if (shortcut.type === "component") {
        let t2;
        if ($[3] !== customComponentDraggableOnClick || $[4] !== dragAndDropEnabled || $[5] !== isInMoreMenu || $[6] !== shortcut) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $28ae02d101b3371f$export$9de4dadf420d5c24), {
                shortcut: shortcut,
                dragAndDropEnabled: dragAndDropEnabled,
                isInMoreMenu: isInMoreMenu,
                onClick: customComponentDraggableOnClick
            });
            $[3] = customComponentDraggableOnClick;
            $[4] = dragAndDropEnabled;
            $[5] = isInMoreMenu;
            $[6] = shortcut;
            $[7] = t2;
        } else t2 = $[7];
        return t2;
    }
    if (shortcut.type === "internal") {
        const t2 = shortcut.key;
        const t3 = shortcut.icon;
        const t4 = shortcut.isSelected;
        const t5 = shortcut.isReorderable;
        const t6 = shortcut.labelElem;
        const t7 = shortcut.onClick;
        const t8 = shortcut.onRightClick;
        let t9;
        if ($[8] !== shortcut) {
            t9 = (0, $6L2pn.getUrlMaybe)(shortcut);
            $[8] = shortcut;
            $[9] = t9;
        } else t9 = $[9];
        let t10;
        if ($[10] !== analyticsName || $[11] !== labelText || $[12] !== product || $[13] !== shortcut.icon || $[14] !== shortcut.isReorderable || $[15] !== shortcut.isSelected || $[16] !== shortcut.key || $[17] !== shortcut.labelElem || $[18] !== shortcut.onClick || $[19] !== shortcut.onRightClick || $[20] !== t9) {
            t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4436fe58c5f22254$export$68ef190193a37bc2), {
                analyticsName: analyticsName,
                key: t2,
                icon: t3,
                isSelected: t4,
                isReorderable: t5,
                label: labelText,
                labelElem: t6,
                openInSameTab: true,
                onClick: t7,
                onRightClick: t8,
                product: product,
                url: t9
            });
            $[10] = analyticsName;
            $[11] = labelText;
            $[12] = product;
            $[13] = shortcut.icon;
            $[14] = shortcut.isReorderable;
            $[15] = shortcut.isSelected;
            $[16] = shortcut.key;
            $[17] = shortcut.labelElem;
            $[18] = shortcut.onClick;
            $[19] = shortcut.onRightClick;
            $[20] = t9;
            $[21] = t10;
        } else t10 = $[21];
        let t11;
        if ($[22] !== ItemWrapper || $[23] !== t10) {
            t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ItemWrapper, null, t10);
            $[22] = ItemWrapper;
            $[23] = t10;
            $[24] = t11;
        } else t11 = $[24];
        return t11;
    }
    const t2 = shortcut.actions;
    let t3;
    if ($[25] !== formatMessage || $[26] !== labelText) {
        t3 = formatMessage((0, $8d671dcba983b0f5$export$defe85febe8b728c).menuLinkItemAriaLabel, {
            appName: labelText,
            siteName: ""
        });
        $[25] = formatMessage;
        $[26] = labelText;
        $[27] = t3;
    } else t3 = $[27];
    const t4 = shortcut.icon;
    const t5 = shortcut.isReorderable;
    const t6 = shortcut.key;
    const t7 = shortcut.labelElem;
    const t8 = shortcut.menuItemId;
    const t9 = shortcut.onClick;
    const t10 = shortcut.onFocus;
    const t11 = shortcut.onMouseEnter;
    const t12 = shortcut.onRightClick;
    const t13 = shortcut.ref;
    const t14 = shortcut.optionsMenuElem;
    let t15;
    if ($[28] !== shortcut) {
        t15 = (0, $6L2pn.getUrlMaybe)(shortcut);
        $[28] = shortcut;
        $[29] = t15;
    } else t15 = $[29];
    let t16;
    if ($[30] !== analyticsName || $[31] !== labelText || $[32] !== openInSameTab || $[33] !== product || $[34] !== shortcut.actions || $[35] !== shortcut.icon || $[36] !== shortcut.isReorderable || $[37] !== shortcut.key || $[38] !== shortcut.labelElem || $[39] !== shortcut.menuItemId || $[40] !== shortcut.onClick || $[41] !== shortcut.onFocus || $[42] !== shortcut.onMouseEnter || $[43] !== shortcut.onRightClick || $[44] !== shortcut.optionsMenuElem || $[45] !== shortcut.ref || $[46] !== t15 || $[47] !== t3) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4436fe58c5f22254$export$68ef190193a37bc2), {
            actions: t2,
            analyticsName: analyticsName,
            ariaLabel: t3,
            icon: t4,
            isReorderable: t5,
            key: t6,
            label: labelText,
            labelElem: t7,
            menuItemId: t8,
            onClick: t9,
            onFocus: t10,
            onMouseEnter: t11,
            onRightClick: t12,
            openInSameTab: openInSameTab,
            optionalRef: t13,
            optionsMenuElem: t14,
            product: product,
            url: t15
        });
        $[30] = analyticsName;
        $[31] = labelText;
        $[32] = openInSameTab;
        $[33] = product;
        $[34] = shortcut.actions;
        $[35] = shortcut.icon;
        $[36] = shortcut.isReorderable;
        $[37] = shortcut.key;
        $[38] = shortcut.labelElem;
        $[39] = shortcut.menuItemId;
        $[40] = shortcut.onClick;
        $[41] = shortcut.onFocus;
        $[42] = shortcut.onMouseEnter;
        $[43] = shortcut.onRightClick;
        $[44] = shortcut.optionsMenuElem;
        $[45] = shortcut.ref;
        $[46] = t15;
        $[47] = t3;
        $[48] = t16;
    } else t16 = $[48];
    let t17;
    if ($[49] !== ItemWrapper || $[50] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ItemWrapper, null, t16);
        $[49] = ItemWrapper;
        $[50] = t16;
        $[51] = t17;
    } else t17 = $[51];
    return t17;
} : function ShortcutMenuItemWithoutErrorBoundary({ shortcut: shortcut, dragAndDropEnabled: dragAndDropEnabled, product: product, openInSameTab: openInSameTab, isInMoreMenu: isInMoreMenu }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const labelText = shortcut.label;
    const analyticsName = shortcut.analyticsName || `unknown_${labelText}`;
    const ItemWrapper = shortcut?.ItemWrapper ?? (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment;
    const customComponentDraggableOnClick = (0, $cozmU.useCallback)(()=>{
        (0, $4436fe58c5f22254$export$18a13ecc162cd5c2)(createAnalyticsEvent, analyticsName);
    }, [
        analyticsName,
        createAnalyticsEvent
    ]);
    if (shortcut.type === 'component') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $28ae02d101b3371f$export$9de4dadf420d5c24), {
        shortcut: shortcut,
        dragAndDropEnabled: dragAndDropEnabled,
        isInMoreMenu: isInMoreMenu,
        onClick: customComponentDraggableOnClick
    });
    if (shortcut.type === 'internal') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ItemWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4436fe58c5f22254$export$68ef190193a37bc2), {
        analyticsName: analyticsName,
        key: shortcut.key,
        icon: shortcut.icon,
        isSelected: shortcut.isSelected,
        isReorderable: shortcut.isReorderable,
        label: labelText,
        labelElem: shortcut.labelElem,
        openInSameTab: true,
        onClick: shortcut.onClick,
        onRightClick: shortcut.onRightClick,
        product: product,
        url: (0, $6L2pn.getUrlMaybe)(shortcut)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ItemWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4436fe58c5f22254$export$68ef190193a37bc2), {
        actions: shortcut.actions,
        analyticsName: analyticsName,
        ariaLabel: formatMessage((0, $8d671dcba983b0f5$export$defe85febe8b728c).menuLinkItemAriaLabel, {
            appName: labelText,
            siteName: ''
        }),
        icon: shortcut.icon,
        isReorderable: shortcut.isReorderable,
        key: shortcut.key,
        label: labelText,
        labelElem: shortcut.labelElem,
        menuItemId: shortcut.menuItemId,
        onClick: shortcut.onClick,
        onFocus: shortcut.onFocus,
        onMouseEnter: shortcut.onMouseEnter,
        onRightClick: shortcut.onRightClick,
        openInSameTab: openInSameTab,
        optionalRef: shortcut.ref,
        optionsMenuElem: shortcut.optionsMenuElem,
        product: product,
        url: (0, $6L2pn.getUrlMaybe)(shortcut)
    }));
};
module.exports["ShortcutMenuItem"] = $3ee0708e488dd620$export$af94fce1535255cc;

});

parcelRegister("6L2pn", function(module, exports) {
const $e3979d392b20e279$export$739b3f561aa47bc9 = (fallbackUrl)=>{
    if (typeof fallbackUrl === 'function') return fallbackUrl();
    // `fallbackUrl` is a string, return it directly
    return fallbackUrl;
};


const $eed1b6b355e7decd$export$1f32ba41e2b31f39 = (fallbackUrl)=>{
    if (fallbackUrl === undefined) return undefined;
    return (0, $e3979d392b20e279$export$739b3f561aa47bc9)(fallbackUrl);
};


const $7debef14dbb0f4c8$export$ac51fdc0c7ed862d = (options)=>options.url || (0, $eed1b6b355e7decd$export$1f32ba41e2b31f39)(options.fallbackUrl);
module.exports["getUrlMaybe"] = $7debef14dbb0f4c8$export$ac51fdc0c7ed862d;

});

parcelRegister("3vXmx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $huGTe = parcelRequire("huGTe");


var $ixfCV = parcelRequire("ixfCV");





var $3ePvn = parcelRequire("3ePvn");


var $9Kv4c = parcelRequire("9Kv4c");


var $8PNRl = parcelRequire("8PNRl");





var $hp074 = parcelRequire("hp074");


var $jH9cM = parcelRequire("jH9cM");




function $d7684f9e0b21a4d6$export$3e8bbf689f8e6cad(record, sortFunction) {
    for(const key in record)if (Array.isArray(record[key])) record[key].sort(sortFunction); // Sorts alphabetically or numerically by default
    return record;
}






var $kSwu1 = parcelRequire("kSwu1");

const $78d7c3a0068f3aa2$export$905fe28a7c283e1d = (text)=>{
    return typeof text === 'string' ? text : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), text);
};
const $78d7c3a0068f3aa2$export$60f5d4abb43a14b3 = (direction)=>(a, b)=>{
        const aLower = a.toLowerCase();
        const bLower = b.toLowerCase();
        if (direction === 'asc') return aLower.localeCompare(bLower);
        return bLower.localeCompare(aLower);
    };
const $78d7c3a0068f3aa2$export$e57a6793604f15ac = (atiArray)=>{
    return atiArray && atiArray.length > 0 ? atiArray.join(',') : undefined;
};






var $hrm0L = parcelRequire("hrm0L");

function $0a5e899f2d5517f1$var$checkShouldRemoveJWM(productType) {
    return [
        'JIRA_SOFTWARE',
        'JIRA_PRODUCT_DISCOVERY',
        'JIRA_SERVICE_DESK'
    ].includes(productType);
}
const $0a5e899f2d5517f1$var$flightdeckClient = new (0, $hp074.default)('atlassian-navigagtion-bff-data-provider');
function $0a5e899f2d5517f1$export$79322ba781a26ce1({ cloudId: cloudId, orgId: orgId, forceStatic: forceStatic }) {
    const { items: items } = (0, $8PNRl.useCache)();
    const { setStatus: setStatus } = (0, $hrm0L.useStatus)();
    const [fdResponse, setFdResponse] = (0, $cozmU.useState)(null);
    const [productConfig, setProductConfig] = (0, $cozmU.useState)(null);
    (0, $cozmU.useEffect)(()=>{
        const getFlightdeckData = async ()=>{
            try {
                setStatus((0, $3ePvn.RequestStatus).LOADING, (0, $3ePvn.FLIGHTDECK_REQUEST_STATUS_KEY));
                const fdResponse_0 = await $0a5e899f2d5517f1$var$flightdeckClient.fetchConfigFromFlightDeck({
                    // app-switcher-fe is currently the only valid name that is configured
                    // in Flightdeck
                    name: 'app-switcher-fe',
                    // This should get updated to be based on the supplied consumer
                    // name: `app-global-shortcuts-${consumer}-fe`,
                    dimensions: {
                        environmentType: 'prod',
                        perimeter: (0, $jH9cM.isFedRamp)() ? 'fedramp-moderate' : 'commercial'
                    }
                });
                setFdResponse(fdResponse_0);
                setStatus((0, $3ePvn.RequestStatus).COMPLETE, (0, $3ePvn.FLIGHTDECK_REQUEST_STATUS_KEY));
            } catch  {
                setStatus((0, $3ePvn.RequestStatus).ERROR, (0, $3ePvn.FLIGHTDECK_REQUEST_STATUS_KEY));
            }
        };
        if (!fdResponse && !forceStatic) getFlightdeckData();
    }, [
        fdResponse,
        setStatus,
        forceStatic
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!fdResponse) return;
        const config = {};
        for (const product of fdResponse.products){
            const { apsKey: apsKey, tcsProductKey: tcsProductKey, siteUrlSuffix: siteUrlSuffix, displayName: displayName, rebrandedDisplayName: rebrandedDisplayName, subtitle: subtitle, ordinal: ordinal, iconKey: iconKey, rebrandedIconKey: rebrandedIconKey } = product;
            config[apsKey] = {
                key: !!tcsProductKey ? tcsProductKey : apsKey.toLowerCase(),
                siteUrlSuffix: siteUrlSuffix,
                ordinal: ordinal,
                label: (0, $78d7c3a0068f3aa2$export$905fe28a7c283e1d)(displayName),
                rebrandedLabel: rebrandedDisplayName && (0, $78d7c3a0068f3aa2$export$905fe28a7c283e1d)(rebrandedDisplayName),
                description: (0, $78d7c3a0068f3aa2$export$905fe28a7c283e1d)(subtitle),
                iconKey: iconKey,
                rebrandedIconKey: rebrandedIconKey
            };
            // TODO: remove this once Asset app becomes standalone app
            if (apsKey === 'JIRA_SERVICE_DESK' && !config[0, $3ePvn.ASSETS_APP_KEY]) config[0, $3ePvn.ASSETS_APP_KEY] = {
                key: (0, $3ePvn.ASSETS_APP_KEY),
                siteUrlSuffix: '/jira/assets',
                ordinal: ordinal + 0.1,
                // make sure assets is below jsm
                label: (0, $78d7c3a0068f3aa2$export$905fe28a7c283e1d)('Assets'),
                iconKey: 'assets'
            };
        }
        setProductConfig(config);
    }, [
        fdResponse
    ]);
    const getProductLinkForItem = (0, $cozmU.useCallback)((productType, siteUrl, productUrl)=>{
        if (productUrl) return productUrl;
        const siteSuffix = productConfig?.[productType]?.siteUrlSuffix;
        return `${siteUrl}${siteSuffix}`;
    }, [
        productConfig
    ]);
    const productLinks = (0, $cozmU.useMemo)(()=>{
        const products = {};
        const shouldRemoveJWM = items.some((item)=>{
            return (item.availableProducts || []).some(({ productType: productType_0 })=>$0a5e899f2d5517f1$var$checkShouldRemoveJWM(productType_0));
        });
        items.forEach((item_0)=>{
            const { availableProducts: availableProducts = [], cloudId: cachedItemCloudId, avatar: avatar, url: siteUrl_0, displayName: displayName_0, org: org } = item_0;
            // only apply org level filtering if org data is available
            if (org && orgId && org.id !== orgId) return;
            availableProducts.forEach((product_0)=>{
                const { url: productUrl_0 } = product_0;
                let { productType: productType_1 } = product_0;
                const isExcludeJiraBusiness = productType_1 === 'JIRA_BUSINESS' && !shouldRemoveJWM;
                // if a site has JWM only and no other Jiras, JWM needs to appear under "Jira"
                // to ensure that this happens, we set JSM's productType to 'JIRA_SOFTWARE'
                // this will ensure that JWM is not removed, even if another site has JSW/JPD/JSM
                if (isExcludeJiraBusiness) productType_1 = 'JIRA_SOFTWARE';
                if (!products[productType_1]) products[productType_1] = [];
                if (!isExcludeJiraBusiness) products[productType_1].push({
                    isCurrentSite: Boolean(cachedItemCloudId) && cloudId?.toLowerCase() === cachedItemCloudId?.toLowerCase(),
                    displayName: displayName_0,
                    url: getProductLinkForItem(productType_1, siteUrl_0, productUrl_0),
                    avatar: avatar,
                    cloudId: cachedItemCloudId
                });
            });
        });
        return (0, $d7684f9e0b21a4d6$export$3e8bbf689f8e6cad)(products, (a, b)=>{
            return (0, $78d7c3a0068f3aa2$export$60f5d4abb43a14b3)('asc')(a.displayName, b.displayName);
        });
    }, [
        items,
        orgId,
        cloudId,
        getProductLinkForItem
    ]);
    return {
        productLinks: productLinks
    };
}






var $2nIbk = parcelRequire("2nIbk");

async function $ea54d8a6b0272f84$var$wait(ms) {
    return new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
}
function $ea54d8a6b0272f84$export$a00b492c9c3c66db({ request: request, cloudId: cloudId, orgId: orgId, product: product, userId: userId, forceStatic: forceStatic }) {
    const { items: cachedItems, addItemsToCache: addItemsToCache, clearCache: clearCache, cacheKey: cacheKey, updateCacheKey: updateCacheKey } = (0, $8PNRl.useCache)();
    const { status: status, error: error, setStatus: setStatus } = (0, $hrm0L.useStatus)();
    const { productLinks: productLinks } = (0, $0a5e899f2d5517f1$export$79322ba781a26ce1)({
        cloudId: cloudId,
        orgId: orgId,
        forceStatic: forceStatic
    });
    const { buildURL: buildURL } = (0, $2nIbk.useURLBuilder)({
        cloudId: cloudId,
        userId: userId,
        product: product
    });
    const currentRequest = (0, $cozmU.useRef)(null);
    const fetchData = (0, $cozmU.useCallback)(async (url, data, attemptCount = 1, successCheck)=>{
        if (url === '') throw new Error('URL is empty');
        // Always clear error status at the start of a new request
        setStatus((0, $3ePvn.RequestStatus).LOADING, (0, $3ePvn.BFF_REQUEST_STATUS_KEY), undefined);
        try {
            const response = await (0, $9Kv4c.fetchJSON)(url, {});
            switch(response.status){
                case (0, $3ePvn.RequestStatus).ERROR:
                    throw response.error;
                case (0, $3ePvn.RequestStatus).COMPLETE:
                    setStatus((0, $3ePvn.RequestStatus).COMPLETE, (0, $3ePvn.BFF_REQUEST_STATUS_KEY), undefined);
                    currentRequest.current = null;
                    return response.data;
            }
        } catch (error_0) {
            const maxAttempts = request?.maxAttempts ?? (0, $3ePvn.MAX_ATTEMPTS_NEW_DEFAULT);
            if (request?.shouldRetryOnException && attemptCount < maxAttempts) {
                const baseInterval = request?.attemptInterval ?? (0, $3ePvn.RETRY_INTERVAL_DEFAULT);
                // Exponential backoff: delay doubles with each attempt (1x, 2x, 4x)
                const delay = request?.enableExponentialDelay ? baseInterval * Math.pow(2, attemptCount - 1) : baseInterval;
                await $ea54d8a6b0272f84$var$wait(delay);
                return await fetchData(url, data, attemptCount + 1, successCheck);
            } else {
                currentRequest.current = null;
                setStatus((0, $3ePvn.RequestStatus).ERROR, undefined, error_0 instanceof Error ? error_0 : new Error(String(error_0)));
                throw error_0;
            }
        }
    }, [
        request?.attemptInterval,
        request?.maxAttempts,
        request?.shouldRetryOnException,
        request?.enableExponentialDelay,
        setStatus
    ]);
    /**
   * Helper function to build a URL and fetch data.
   */ const buildURLAndFetchData = (0, $cozmU.useCallback)(async ()=>{
        // Wait for the current request to end before firing another
        if (currentRequest.current) return currentRequest.current;
        const builtUrl = buildURL({});
        if (builtUrl !== '') {
            currentRequest.current = fetchData(builtUrl, undefined, undefined, undefined);
            const fetchedData = await currentRequest.current;
            if (!!fetchedData?.sites?.length) addItemsToCache(fetchedData.sites);
        }
    }, [
        addItemsToCache,
        buildURL,
        fetchData
    ]);
    return {
        error: error,
        status: status,
        cachedItems: cachedItems,
        cacheKey: cacheKey,
        updateCacheKey: updateCacheKey,
        addItemsToCache: addItemsToCache,
        clearCache: clearCache,
        buildURL: buildURL,
        fetchData: fetchData,
        buildURLAndFetchData: buildURLAndFetchData,
        productLinks: productLinks
    };
}



var $cXPtd = parcelRequire("cXPtd");

const $4162cd98cfbbb9d0$export$54a1da5292674ec8 = (workspaceCloudId)=>(item, index, arr)=>{
        const matchedItem = arr.find((productLink)=>{
            return productLink.cloudId === workspaceCloudId;
        });
        // If an item exists in the parent array with the same cloudId,
        // we don't want to show a flyout and instead only want the list
        // of available product links to include the matching cloudId.
        if (matchedItem) return workspaceCloudId === item.cloudId;
        // If the filter gets here we want to only pass the first item
        return index === 0;
    };


const $5076d2e48ef5ec58$export$716312c3742c01a3 = ({ shortcutsConfig: shortcutsConfig, cloudId: cloudId, product: product, onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks, isShortcutsStatic: isShortcutsStatic, onError: onError })=>{
    const onUpdateGetFilteredProductLinksRef = (0, $cozmU.useRef)(onUpdateGetFilteredProductLinks);
    onUpdateGetFilteredProductLinksRef.current = onUpdateGetFilteredProductLinks;
    const { buildURLAndFetchData: buildURLAndFetchData, status: status, productLinks: productLinks, error: error } = (0, $ea54d8a6b0272f84$export$a00b492c9c3c66db)({
        request: {},
        cloudId: cloudId,
        forceStatic: isShortcutsStatic,
        product: product
    });
    const productLinksRef = (0, $cozmU.useRef)(productLinks);
    productLinksRef.current = productLinks;
    const statusRef = (0, $cozmU.useRef)(status);
    statusRef.current = status;
    const lastCompleteProductLinksRef = (0, $cozmU.useRef)({});
    if (status === (0, $cXPtd.RequestStatus).COMPLETE) lastCompleteProductLinksRef.current = {
        ...productLinks
    };
    const getBffProductLinksForKey = (0, $cozmU.useCallback)((apsKey)=>({
            links: ((0, $ixfCV.fg)('navx-gas-getlink-unstable-fix') ? lastCompleteProductLinksRef.current : productLinksRef.current)[apsKey] ?? [],
            status: (0, $ixfCV.fg)('navx-gas-getlink-unstable-fix') ? (0, $cXPtd.RequestStatus).COMPLETE : statusRef.current
        }), []);
    (0, $cozmU.useEffect)(()=>{
        if (!onUpdateGetFilteredProductLinksRef.current) return;
        if (status !== (0, $cXPtd.RequestStatus).COMPLETE && (0, $ixfCV.fg)('navx-gas-getlink-unstable-fix')) return;
        onUpdateGetFilteredProductLinksRef.current(getBffProductLinksForKey);
    }, [
        getBffProductLinksForKey,
        status,
        productLinks
    ]);
    // fetch the data from the bff if required
    (0, $cozmU.useEffect)(()=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($huGTe)))(shortcutsConfig) || isShortcutsStatic || !cloudId) return;
        buildURLAndFetchData();
    }, [
        buildURLAndFetchData,
        cloudId,
        shortcutsConfig,
        isShortcutsStatic
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (status === (0, $cXPtd.RequestStatus).ERROR && error) onError?.(error);
    }, [
        status,
        error,
        onError
    ]);
    // associate shortcuts with the returned bff data
    const hydratedAppShortcuts = (0, $cozmU.useMemo)(()=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($huGTe)))(shortcutsConfig)) return shortcutsConfig;
        const config = shortcutsConfig;
        if (status === (0, $cXPtd.RequestStatus).COMPLETE && Object.keys(productLinks).length) {
            const isArray = Array.isArray(config);
            if (isArray) return config.reduce((acc, item)=>{
                // if config does not need a data reference, just return the value
                if (item.type !== 'link' || !item.apsKey) {
                    acc.push(item);
                    return acc;
                }
                // if config requires the bff to determine the data reference
                const productLink = productLinks[item.apsKey];
                if (productLink) {
                    const filteredProductLink = cloudId ? productLink.filter((0, $4162cd98cfbbb9d0$export$54a1da5292674ec8)(cloudId))[0] : productLink[0];
                    acc.push({
                        ...item,
                        url: filteredProductLink.url
                    });
                }
                return acc;
            }, []);
            const entries = Object.entries(config);
            return entries.reduce((acc_0, [key, value])=>{
                // if config does not need a data reference, just return the value
                if (value.type !== 'link' || !value.apsKey) {
                    acc_0[key] = value;
                    return acc_0;
                }
                // if config requires the bff to determine the data reference
                const productLink_0 = productLinks[value.apsKey];
                if (productLink_0) {
                    const filteredProductLink_0 = cloudId ? productLink_0.filter((0, $4162cd98cfbbb9d0$export$54a1da5292674ec8)(cloudId))[0] : productLink_0[0];
                    acc_0[key] = {
                        ...value,
                        url: filteredProductLink_0.url
                    };
                    return acc_0;
                }
                return acc_0;
            }, {});
        }
        return shortcutsConfig;
    }, [
        productLinks,
        status,
        shortcutsConfig,
        cloudId
    ]);
    return hydratedAppShortcuts;
};
module.exports["useGlobalShortcutsDataBFF"] = $5076d2e48ef5ec58$export$716312c3742c01a3;

});

parcelRegister("dpUmv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $9e651d72fc8dd188$export$26537912ea160acd = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
module.exports["IdContext"] = $9e651d72fc8dd188$export$26537912ea160acd;

});

parcelRegister("iKSY4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $3b144472abeb9c2f$export$efa4d9670e96ac31 = /*#__PURE__*/ (0, $cozmU.createContext)(false);
module.exports["IsOpenContext"] = $3b144472abeb9c2f$export$efa4d9670e96ac31;

});

parcelRegister("7tDc6", function(module, exports) {
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $cozmU = parcelRequire("cozmU");

const $4afa9584bc62943e$export$37438ea5f80ca91e = /*#__PURE__*/ (0, $cozmU.createContext)({
    current: null
});
module.exports["TriggerRefObjectContext"] = $4afa9584bc62943e$export$37438ea5f80ca91e;

});

parcelRegister("a9KY5", function(module, exports) {
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $cozmU = parcelRequire("cozmU");

const $32cab1fd0861be84$export$53ee23205ed2541e = /*#__PURE__*/ (0, $cozmU.createContext)(null);
module.exports["TriggerRefContext"] = $32cab1fd0861be84$export$53ee23205ed2541e;

});

parcelRegister("hj0rK", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $1f499b3e197d95cf$export$2d7d3979eeceb992 = /*#__PURE__*/ (0, $cozmU.createContext)(false);
module.exports["EnsureIsInsidePopupContext"] = $1f499b3e197d95cf$export$2d7d3979eeceb992;

});

parcelRegister("dY7Kg", function(module, exports) {
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $cozmU = parcelRequire("cozmU");

const $1c6b30c4b798fcf7$export$a8c52551eddf6b9 = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
module.exports["RoleContext"] = $1c6b30c4b798fcf7$export$a8c52551eddf6b9;

});

parcelRegister("EZmp0", function(module, exports) {
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $cozmU = parcelRequire("cozmU");


var $dpsRj = parcelRequire("dpsRj");

const $693c50194f3dcf5f$export$85b81def7d2cbc37 = /*#__PURE__*/ (0, $cozmU.createContext)((0, $dpsRj.default));
module.exports["SetTriggerRefContext"] = $693c50194f3dcf5f$export$85b81def7d2cbc37;

});

parcelRegister("2HzLc", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $bB0i2 = parcelRequire("bB0i2");


var $hj0rK = parcelRequire("hj0rK");

const $318a1d6f64917d1a$export$421fc1dbb5b2c905 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useEnsureIsInsidePopup() {
    const context = (0, $cozmU.useContext)((0, $hj0rK.EnsureIsInsidePopupContext));
    (0, $bB0i2.default)(context, "PopupTrigger and PopupContent components must be used within a Popup");
} : function useEnsureIsInsidePopup() {
    const context = (0, $cozmU.useContext)((0, $hj0rK.EnsureIsInsidePopupContext));
    (0, $bB0i2.default)(context, 'PopupTrigger and PopupContent components must be used within a Popup');
};
module.exports["useEnsureIsInsidePopup"] = $318a1d6f64917d1a$export$421fc1dbb5b2c905;

});

parcelRegister("3bmmh", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $240ec326a31eadae$export$c69308b19dea1022 = /*#__PURE__*/ (0, $cozmU.createContext)({
    enabled: false
});
const $240ec326a31eadae$export$b40e2d2385213009 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { children: children, enabled: t1 } = t0;
    const enabled = t1 === undefined ? false : t1;
    let t2;
    if ($[0] !== enabled) {
        t2 = {
            enabled: enabled
        };
        $[0] = enabled;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== children || $[3] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($240ec326a31eadae$export$c69308b19dea1022.Provider, {
            value: t2
        }, children);
        $[2] = children;
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ({ children: children, enabled: enabled = false })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($240ec326a31eadae$export$c69308b19dea1022.Provider, {
        value: {
            enabled: enabled
        }
    }, children);
};
module.exports["DragAndDropOptionsContext"] = $240ec326a31eadae$export$c69308b19dea1022;
module.exports["DragAndDropOptionsProvider"] = $240ec326a31eadae$export$b40e2d2385213009;

});


//# sourceMappingURL=ConversationAssistant.cf3f8698.js.map
